/* google places api autocomplete */
function autocomplete(countries = ['us']) {
  var input = $('#address')[0];
  var options = {
    componentRestrictions: {
      country: countries
    }
  };

  var autocomplete = new google.maps.places.Autocomplete(input, options);

  autocomplete.addListener('place_changed', function () {
    var place = autocomplete.getPlace();
    var lat = place.geometry.location.lat();
    var lng = place.geometry.location.lng();
    // convert offset to seconds
    var offset = place.utc_offset_minutes * 60;
    $(input).attr('data-latitude', lat).attr('data-longitude', lng).attr('data-offset', offset);
  });

  /*
   * Removed 'Your Location' from input field if user focuses on it to search for an actual address.
   * This prevents Google autocomplete from searching 'Your Location'.
   */
  $(input).focus(function (e) {
    if (e.target.value === 'Your Location') {
      $(this).val('');
    }
  });
}

function GetDateStr(date) {
  return moment(date).format("YYYY-MM-DD");
}

function GetMobileMonthFormat(month) {
  //Momentjs use 0 based indexing for month
  if (month == 0) {
    return 'Jan';
  } else if (month == 1) {
    return 'Feb';
  } else if (month == 2) {
    return 'Mar';
  } else if (month == 3) {
    return 'Apr';
  } else if (month == 4) {
    return 'May';
  } else if (month == 5) {
    return 'Jun';
  } else if (month == 6) {
    return 'Jul';
  } else if (month == 7) {
    return 'Aug';
  } else if (month == 8) {
    return 'Sep';
  } else if (month == 9) {
    return 'Oct';
  } else if (month == 10) {
    return 'Nov';
  } else if (month == 11) {
    return 'Dec';
  }
}

function initializeSession(facilityId) {
  const parkerId = crypto.randomUUID();
  const sessionId = crypto.randomUUID();
  const now = new Date();
  const localISO = new Date(now.getTime() - now.getTimezoneOffset() * 60000).toISOString();
  const formattedDate = localISO.split('T')[0];

  let apiUrl;
  console.log('window.location.hostname', window.location.hostname)
  switch (window.location.hostname) {
    case 'local.parkchirp.com':
      apiUrl = 'http://127.0.0.1:4004';
      break;
    case 'chirpqa.com':
      apiUrl = 'https://api.chirpqa.com/v2';
      break;
    case 'parkcheep.com':
      apiUrl = 'https://api.parkcheep.com/v2';
      break;
    default:
      apiUrl = 'https://api.parkchirp.com/v2';
      break;
  }

  const endpoint = `${apiUrl}/graphqlPublic`;

  const mutation = `
    mutation initializeMonthlySession(
        $id: String!,
        $rateId: String,
        $startDate: String,
        $facilityId: String,
        $parkerId: String!
        ) {
        initializeMonthlySession(
            id: $id,
            rateId: $rateId,
            startDate: $startDate,
            facilityId: $facilityId
            parkerId: $parkerId
        )
    }
  `;
  const variables = {
      id: sessionId,
      rateId: null,
      startDate: formattedDate,
      parkerId,
      facilityId
  };

  fetch(endpoint, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      query: mutation,
      variables: variables,
      context: {
        apiVersion: 'v2',
        public: true,
      }
    })
  })
  .then(response => response.json())
  .then(data => {
    let redirectUrl;
    const hostname = window.location.hostname;
    const domainParts = hostname.split('.');
    const domainWithoutTLD =
      domainParts.length > 2
        ? domainParts[1]
        : domainParts[0];
    switch (hostname) {
      case 'local.parkchirp.com':
        redirectUrl = 'http://127.0.0.1:4050';
        break;
      case 'chirpqa.com':
        redirectUrl = 'https://checkout.chirpqa.com';
        break;
      case 'parkcheep.com':
        redirectUrl = 'https://checkout.parkcheep.com';
        break;
      default:
        redirectUrl = `https://checkout.parkchirp.com`;
        break;
    }
    console.log('Redirecting to:', redirectUrl);
    window.location.href = `${redirectUrl}/?sessionId=${sessionId}&host=${domainWithoutTLD}`;
  })
  .catch(error => {
    console.error('Error during API call:', error);
  });
}

function initializeSessionFromMapPage(rateId, facilityId) {
  const parkerId = crypto.randomUUID();
  const sessionId = crypto.randomUUID();
  const now = new Date();
  const localISO = new Date(now.getTime() - now.getTimezoneOffset() * 60000).toISOString();
  const formattedDate = localISO.split('T')[0];
  let apiUrl;
  switch (window.location.hostname) {
    case 'local.parkchirp.com':
      apiUrl = 'http://127.0.0.1:4004';
      break;
    case 'chirpqa.com':
      apiUrl = 'https://api.chirpqa.com/v2';
      break;
    case 'parkcheep.com':
      apiUrl = 'https://api.parkcheep.com/v2';
      break;
    default:
      apiUrl = 'https://api.parkchirp.com/v2';
      break;
  }

  const endpoint = `${apiUrl}/graphqlPublic`;

  const mutation = `
    mutation initializeMonthlySession(
        $id: String!,
        $rateId: String,
        $startDate: String,
        $facilityId: String,
        $parkerId: String!
        ) {
        initializeMonthlySession(
            id: $id,
            rateId: $rateId,
            startDate: $startDate,
            facilityId: $facilityId
            parkerId: $parkerId
        )
    }
  `;
  const variables = {
    id: sessionId,
    rateId,
    startDate: formattedDate,
    parkerId,
    facilityId
  };

  fetch(endpoint, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      query: mutation,
      variables: variables,
      context: {
        apiVersion: 'v2',
        public: true,
      }
    })
  })
  .then(response => response.json())
  .then(data => {
    let redirectUrl;
    const hostname = window.location.hostname;
    const domainParts = hostname.split('.');
    const domainWithoutTLD =
      domainParts.length > 2
        ? domainParts[1]
        : domainParts[0];
    switch (hostname) {
      case 'local.parkchirp.com':
        redirectUrl = 'http://127.0.0.1:4050';
        break;
      case 'chirpqa.com':
        redirectUrl = 'https://checkout.chirpqa.com';
        break;
      case 'parkcheep.com':
        redirectUrl = 'https://checkout.parkcheep.com';
        break;
      default:
        redirectUrl = `https://checkout.parkchirp.com`;
        break;
    }
    console.log('Redirecting to:', redirectUrl);
    window.location.href = `${redirectUrl}/?sessionId=${sessionId}&host=${domainWithoutTLD}`;
  })
  .catch(error => {
    console.error('Error during API call:', error);
  });
}

function UpdateMobileMapTime(startUnix, endUnix) {
  //.format("YYYY-MM-DD hh:mm a")
  startMoment = moment.tz(startUnix * 1000, "Etc/UTC")
  endMoment = moment.tz(endUnix * 1000, "Etc/UTC")
  console.log(`${GetMobileMonthFormat(startMoment.month())} ${startMoment.format("D")} ${startMoment.format("h:mm a")}`)
  if (startMoment.isSame(new Date(), "day")) {
    $('.search-toolbar-button-datetime-start .search-toolbar-button-date').empty().text('Today');
  } else {
    $('.search-toolbar-button-datetime-start .search-toolbar-button-date').empty().text(`${GetMobileMonthFormat(startMoment.month())} ${startMoment.format("D")}`);
  }

  if (endMoment.isSame(new Date(), "day")) {
    $('.search-toolbar-button-datetime-end .search-toolbar-button-date').empty().text('Today');
  } else {
    $('.search-toolbar-button-datetime-end .search-toolbar-button-date').empty().text(`${GetMobileMonthFormat(endMoment.month())} ${endMoment.format("D")}`);
  }


  $('.search-toolbar-button-datetime-start .search-toolbar-button-time').empty().text(startMoment.format("h:mm a"));
  $('.search-toolbar-button-datetime-end .search-toolbar-button-time').empty().text(endMoment.format("h:mm a"));

}

function GetTimeNearest30(date) {
  m = moment(date);
  if (m.minute() > 30) {
    m.minute(30)
  } else {
    m.minute(0)
  }
  return m.format("HH:mm");
}

function GetTimeStr(date) {
  return moment(date).format("hh:mm a");
}

function GetUTCNow() {
  var date = new Date();
  `${date.getFullYear()}-${date.getMonth()}-${date.getDate()} ${date.getHours()}:${date.getMinutes()}`
  var now_utc = Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(),
    date.getHours(), date.getMinutes(), date.getSeconds());
  return Number(now_utc / 1000);
}

function GetSlugFromStr(str) {
  return str.split(' ').join('-').toLowerCase();
}

/* `#autocomplete-form` functionality */
function initialSearchForm(type) {

  // allow choosing location with keyboard
  $('#address').keydown(function (e) {
    if (e.which == 13 && $('.pac-container:visible').length) {
      return false;
    }
  });

  var autocompleteForm = $('#autocomplete-form').validate({
    // debug: true,
    errorElement: 'span',
    errorClass: 'form-field-error',
    validClass: 'form-field-valid',
    errorPlacement: function (error, element) {
      error.appendTo(element.parents('form'));
    },
    highlight: function (element, errorClass, validClass) {
      $(element).parents('form').addClass(errorClass).removeClass(validClass);
    },
    unhighlight: function (element, errorClass, validClass) {
      $(element).parents('form').removeClass(errorClass).addClass(validClass);
    },
    rules: {
      'address': {
        required: true
      }
    },
    messages: {
      'address': {
        required: 'Please enter a place, address, or landmark.'
      }
    },
    submitHandler: function (form) {
      $('.button-spinner').prop('disabled', true);

      var parkingType = 'hourly';
      if ($('input[name="parking-type"]', form).length > 0) {
        var parkingType = $('input[name="parking-type"]:checked', form).val();
      } else if (type) {
        var parkingType = type;
      }

      console.log('parking type:', parkingType);

      var address = $('#address').val();
      var offset = $('#address').attr('data-offset');
      var latitude = $('#address').attr('data-latitude');
      var longitude = $('#address').attr('data-longitude');
      var nonce = $('#autocomplete-form-nonce').val();

      console.log(latitude, longitude);

      if (latitude == 0 && longitude == 0) {
        // input has a value, but user hasn't selected a location from autocomplete
        autocompleteForm.showErrors({
          'address': 'Please choose a location from the dropdown menu.'
        });
        $('.button-spinner').prop('disabled', false);
      } else {
        var date = new Date();
        $.ajax({
          type: 'post',
          url: '/wp-admin/admin-ajax.php',
          data: {
            action: 'initial_search_query',
            parkingType: parkingType,
            address: address,
            latitude: latitude,
            longitude: longitude,
            startTime: GetTimeNearest30(date),
            startDate: GetDateStr(date),
            offset: offset,
            nonce: nonce
          },
          success: function (results) {
            var results = JSON.parse(results);
            console.log(results);
            if (results.status == 'success') {
              if (results.match == true) {
                var url = new URL(results.location.permalink);
                url.searchParams.set('type', results.parkingType);
                window.location.href = url.href;
              } else {
                var url = new URL(window.location.href);
                url.pathname = '/search/';
                url.searchParams.set('type', results.parkingType);
                url.searchParams.set('startDate', GetDateStr(date));
                url.searchParams.set('startTime', GetTimeNearest30(date));
                url.searchParams.set('lat', results.latitude);
                url.searchParams.set('lng', results.longitude);
                url.searchParams.set('address', encodeURIComponent(results.address));
                url.searchParams.set('offset', results.offset);
                console.log('url:', url);
                window.location.href = url.href;
              }
            } else {
              console.log('error!', results.message);
              $('.button-spinner').prop('disabled', false);
            }
          },
          error: function (results) {
            var results = JSON.parse(results);
            console.log(results);
            $('.button-spinner').prop('disabled', false);
          }
        });
      }
    }
  });
}

/* launch custom alert */
function launchAlert(alertTitle, alertText) {
  var alertTitle = alertTitle;
  var alertText = alertText;
  var alertTemplate = '<div class="site-content-overlay-alert"><div class="alert-header">' + alertTitle + '</div><div class="alert-content">' + alertText + '</div><div class="alert-buttons"><button class="alert-button" id="alert-close">Ok</button></div></div>';
  $('.site-content-overlay').addClass('site-content-overlay-active').append(alertTemplate);
  /* close custom alerts */
  $(document).on('click', '#alert-close', function () {
    $(this).closest('.site-content-overlay').removeClass('site-content-overlay-active');
    $('.site-content-overlay-alert').remove();
  });
}

/* custom map markers */
function customMarker(latlng, price, id, city, state, map) {
  this.latlng = latlng;
  this.price = price;
  this.id = id;
  this.city = city;
  this.state = state;
  this.setMap(map);
}

/* show all facilities on search page */
function allFacilitiesMap(mapId, centerType, centerLat, centerLng, centerZoom) {

  // get facilities from the search results list
  var facilities = [];
  $('.result').each(function (key, value) {
    var lat = $(this).attr('data-latitude');
    var lng = $(this).attr('data-longitude');
    var price = $(this).attr('data-display-price');
    var id = $(this).attr('id');
    var city = $(this).attr('data-city');
    var state = $(this).attr('data-state');
    facilities.push({
      lat: lat,
      lng: lng,
      price: price,
      id: id,
      city: city,
      state: state
    });
  });

  console.log(facilities);

  if (facilities) {

    var center = { lat: 0, lng: 0 }
    var zoom = 15;
    if (centerType === 'center-location') {
      var centerLat = Number(centerLat);
      var centerLng = Number(centerLng);
      var center = { lat: centerLat, lng: centerLng }
      var zoom = Number(centerZoom);
    }

    var mapOptions = {
      zoom: zoom,
      center: center,
      // disableDefaultUI: true,
      zoomControl: true,
      mapTypeControl: false,
      scaleControl: false,
      streetViewControl: false,
      rotateControl: true,
      fullScreenControl: false,
      clickableIcons: false
    };

    var map = new google.maps.Map(document.getElementById(mapId), mapOptions);

    if (centerType === 'fit-all-facilities') {
      var bounds = new google.maps.LatLngBounds();
    }

    // if (centerType === 'center-location') {
    //   var marker = new google.maps.Marker({
    //     position: center,
    //     map: map
    //   });
    // }

    $(facilities).each(function (index, facility) {
      var latLng = new google.maps.LatLng(facility.lat, facility.lng);
      var marker = new customMarker(latLng, facility.price, facility.id, facility.city, facility.state, map);
      if (centerType === 'fit-all-facilities') {
        bounds.extend(latLng);
      }
    });

    if (centerType === 'fit-all-facilities') {
      map.fitBounds(bounds);
    }

  }
}

/* fancy google map for search page */
function searchMap(lat, lng, mapId) {
  var lat = lat;
  var lng = lng;
  var mapId = mapId;

  var myLatLng = new google.maps.LatLng(lat, lng);
  var mapOptions = {
    zoom: 15,
    center: myLatLng,
    // disableDefaultUI: true,
    zoomControl: true,
    mapTypeControl: false,
    scaleControl: false,
    streetViewControl: false,
    rotateControl: true,
    fullScreenControl: false,
    clickableIcons: false
  };
  var map = new google.maps.Map(document.getElementById(mapId), mapOptions);

  var marker = new google.maps.Marker({
    position: myLatLng,
    map: map
  });

  // get facilities from the search results list
  var facilities = [];
  $('.result').each(function (key, value) {
    var lat = $(this).attr('data-latitude');
    var lng = $(this).attr('data-longitude');
    var price = $(this).attr('data-display-price');
    var id = $(this).attr('id');
    var city = $(this).attr('data-city');
    var state = $(this).attr('data-state');
    facilities.push({
      lat: lat,
      lng: lng,
      price: price,
      id: id,
      city: city,
      state: state
    });
  });

  // for each facility, run these...
  facilities.forEach(function (facility) {
    var latlng = new google.maps.LatLng(facility.lat, facility.lng);
    var chirpMarker = new customMarker(latlng, facility.price, facility.id, facility.city, facility.state, map);
  });

}

/* simple google map with one marker */
function simpleMap(lat, lng, mapId) {
  var lat = lat;
  var lng = lng;
  var mapId = mapId;

  var myLatLng = new google.maps.LatLng(lat, lng);
  var mapOptions = {
    zoom: 16,
    center: myLatLng,
    disableDefaultUI: true,
    clickableIcons: false
  };
  var map = new google.maps.Map(document.getElementById(mapId), mapOptions);

  var marker = new google.maps.Marker({
    position: myLatLng,
    map: map
  });
}

/* hourly parking query */
function updateSearchForm() {
  $('#update-search').submit(function (e) {
    e.preventDefault();

    // disable button on submit
    $('.button-spinner', this).prop('disabled', true);

    // close and empty modal if open
    if ($('body').hasClass('modal-active')) {
      $('body').removeClass('modal-active');
      $('.modal-window').empty();
    }

    // close search toolbar if open
    if ($('body').hasClass('search-toolbar-active')) {
      $('body').removeClass('search-toolbar-active');
    }

    // close filter toolbar if open
    if ($('body').hasClass('filter-toolbar-active')) {
      $('body').removeClass('filter-toolbar-active');
    }

    // trigger loading overlay
    $('.site-content-overlay').addClass('site-content-overlay-active');
    $('.site-content-overlay-text').empty().text('Loading...');

    // show all facilities, even if they don't have pricing or products?
    var showAllFacilities = 'false';
    if ($('#show-all-facilities').length) {
      var showAllFacilities = $('#show-all-facilities').val();
    }

    console.log('showAllFacilities', showAllFacilities);

    // shared fields for both hourly and monthly
    var parkingType = $('input[name="parking-type"]:checked').val();
    var address = $('#address').val();
    var lat = $('#address').attr('data-latitude');
    var lng = $('#address').attr('data-longitude');
    var amenities = [];
    $.each($('input[name="amenities"]:checked'), function () {
      amenities.push($(this).val());
    });
    var maxPrice = $('#max-price').val();
    var timezone = $('#timezone').val();
    // var offset = $('#offset').val();
    var offset = Number($('#address').attr('data-offset'));
    var nonce = $('#chirp-update-search-nonce').val();

    // compare to startDateTime and endDateTime for basic error handling
    var nowDateTime = Number($('#now-date-time').val());

    // hourly parking!
    if (parkingType == 'hourly') {

      // hourly-specific variables
      var startDate = $('#start-date').val();
      var startTime = $('#start-time').val();
      var endDate = $('#end-date').val();
      var endTime = $('#end-time').val();

      console.log('startDate:', startDate, 'startTime:', startTime);
      console.log('endDate:', endDate, 'endTime:', endTime);
      console.log('offset', offset);

      if (offset == 0) {

        var offsetISO8601 = '+00:00';

      } else {

        var offsetWIP = ((offset / 60) / 60) * 100;
        var offsetHours = offsetWIP.toString().slice(0, -2);
        var isNegative = offsetHours.indexOf('-');
        if (isNegative == 0) {
          if (offsetHours.length < 3) {
            offsetHours = offsetHours.substring(1);
            offsetHours = '-0' + offsetHours;
          }
        } else {
          if (offsetHours.length < 2) {
            offsetHours = '+0' + offsetHours;
          } else {
            offsetHours = '+' + offsetHours;
          }
        }
        var offsetMinutes = offsetWIP.toString().slice(-2);
        var offsetISO8601 = offsetHours + ':' + offsetMinutes;

      }

      offsetISO8601 = '+00:00';
      console.log('offsetISO8601:', offsetISO8601);

      // convert dates and times to unix epoch format
      // DO NOT ENABLE, THis is correct behavior on checkout but not for map page.
      // MAP PAGE uses set default timezone which breaks this logic
      // var startDateTime = new Date(startDate + 'T' + startTime + offsetISO8601).getTime() / 1000;
      // var endDateTime = new Date(endDate + 'T' + endTime + offsetISO8601).getTime() / 1000;
      var startDateTime = new Date(startDate + 'T' + startTime).getTime() / 1000;
      var endDateTime = new Date(endDate + 'T' + endTime).getTime() / 1000;
      var nowDateTime = GetUTCNow();

      console.log('startDateTime', startDateTime);
      console.log('endDateTime', endDateTime);
      console.log('nowDateTime', nowDateTime);

      if (startDateTime < nowDateTime) {

        launchAlert('Error', 'Start date or time is in the past!');
        $('.button-spinner', this).prop('disabled', false);

      } else if (endDateTime < nowDateTime) {

        launchAlert('Error', 'End date or time is in the past!');
        $('.button-spinner', this).prop('disabled', false);

      } else if (startDateTime >= endDateTime) {

        launchAlert('Error', 'End date or time is earlier than start date or time!');
        $('.button-spinner', this).prop('disabled', false);

      } else {

        $.ajax({
          type: 'post',
          url: '/wp-admin/admin-ajax.php',
          data: {
            action: 'hourly_parking_query',
            showAllFacilities: showAllFacilities,
            parkingType: parkingType,
            address: address,
            lat: lat,
            lng: lng,
            amenities: amenities,
            maxPrice: maxPrice,
            timezone: timezone,
            offset: offset,
            nonce: nonce,
            startDateTime: startDateTime,
            startDate: startDate,
            startTime: startTime,
            endDate: endDate,
            endTime: endTime,
            endDateTime: endDateTime
          },
          success: function (results) {
            var results = JSON.parse(results);
            console.log(results);
            $('.button-spinner').prop('disabled', false);
            if (results.status == 'success') {

              $('.site-content-overlay').removeClass('site-content-overlay-active');
              $('.search-results-list').empty().append(results.template);

              // get current url and parameters
              var url = new URL(window.location);

              // update parameters based on search query
              url.searchParams.set('type', parkingType);
              url.searchParams.set('startDate', startDate);
              url.searchParams.set('startTime', startTime);
              url.searchParams.set('endDate', endDate);
              url.searchParams.set('endTime', endTime);
              url.searchParams.set('lat', lat);
              url.searchParams.set('lng', lng);
              url.searchParams.set('address', encodeURIComponent(address));
              url.searchParams.set('offset', offset);

              // update url with new parameters
              window.history.replaceState({}, '', url.origin + url.pathname + url.search);

              // window.history.replaceState({}, '', '/search/?type=hourly&startTime=' + startTime + '&startDate=' + startDate + '&lat=' + lat + '&lng=' + lng + '&address=' + encodeURIComponent(address) + '&offset=' + offset + '');

              UpdateMobileMapTime(results.startDateTime, results.endDateTime);
              console.log("REPLACE ", startTime)
              searchResultsList();
              sortSearchResults();
              searchMap(lat, lng, 'map');
              $('input[name="max-price"]').attr('disabled', false);

              /*** highlight pin when hovering on result listing ***/
              $('.result').hover(function () {
                var thisFacility = $(this).attr('id');
                $('.marker[data-facility-id="' + thisFacility + '"]').addClass('marker-active');
              }, function () {
                var thisFacility = $(this).attr('id');
                $('.marker[data-facility-id="' + thisFacility + '"]').removeClass('marker-active');
              });

              UpdateMobileMapTime(results.startDateTime, results.endDateTime);

            } else if (results.status == 'error') {

              if (results.template) {

                $('.site-content-overlay').removeClass('site-content-overlay-active');
                $('.search-results-list').empty().append(results.template);
                searchMap(lat, lng, 'map');

                // get current url and parameters
                var url = new URL(window.location);

                // update parameters based on search query
                url.searchParams.set('type', parkingType);
                // url.searchParams.set('startDate', startDate);
                // url.searchParams.set('startTime', startTime);
                // url.searchParams.set('endDate', endDate);
                // url.searchParams.set('endTime', endTime);
                url.searchParams.set('lat', lat);
                url.searchParams.set('lng', lng);
                url.searchParams.set('address', encodeURIComponent(address));
                url.searchParams.set('offset', offset);

                // update url with new parameters
                window.history.replaceState({}, '', url.origin + url.pathname + url.search);

                // window.history.replaceState({}, '', '/search/?type=hourly&lat=' + lat + '&lng=' + lng + '&address=' + encodeURIComponent(address) + '&offset=' + offset + '');

              } else {

                launchAlert('Error', results.message);

              }

            } else {

              launchAlert('Error', 'Uh oh, something went wrong.');

            }

          },
          error: function (results) {
            var results = JSON.parse(results);
            console.log(results);
            $('.button-spinner', this).prop('disabled', false);
          }
        });

      }

      // monthly parking!
    } else if (parkingType == 'monthly') {

      // monthly-specific variables
      var spotType = $('#spot-type').val();
      var accessHours = $('#access-hours').val();
      var startDate = $('#start-date-monthly').val();
      let cookieDomain = window.location.hostname;
      let isSecure = window.location.protocol === 'https:';
      let cookieString = `startDate=${startDate}; path=/; domain=.${cookieDomain};`;
      if (isSecure) {
        cookieString += ' Secure; SameSite=None;';
      }
      document.cookie = cookieString;
      var startTime = '23:59';

      var startDateTime = new Date(startDate + 'T' + startTime).getTime() / 1000;

      if (startDateTime < nowDateTime) {

        launchAlert('Error', 'Sorry, you can\'t buy parking in the past!')
        $('.button-spinner').prop('disabled', false);

      } else {

        $.ajax({
          type: 'post',
          url: '/wp-admin/admin-ajax.php',
          data: {
            action: 'monthly_parking_query',
            showAllFacilities: showAllFacilities,
            parkingType: parkingType,
            address: address,
            lat: lat,
            lng: lng,
            amenities: amenities,
            maxPrice: maxPrice,
            timezone: timezone,
            offset: offset,
            nonce: nonce,
            spotType: spotType,
            accessHours: accessHours,
            startDateTime: startDateTime
          },
          success: function (results) {
            var results = JSON.parse(results);
            console.log(results);
            $('.button-spinner').prop('disabled', false);
            if (results.status == 'success') {

              $('.search-toolbar').removeClass('hourly-parking');
              $('.search-toolbar').addClass('monthly-parking');
              $('.site-content-overlay').removeClass('site-content-overlay-active');
              $('.search-results-list').empty().append(results.template);

              // get current url and parameters
              var url = new URL(window.location);

              // update parameters based on search query
              url.searchParams.set('type', parkingType);
              // url.searchParams.set('startDate', startDate);
              // url.searchParams.set('startTime', startTime);
              // url.searchParams.set('endDate', endDate);
              // url.searchParams.set('endTime', endTime);
              url.searchParams.set('lat', lat);
              url.searchParams.set('lng', lng);
              url.searchParams.set('address', encodeURIComponent(address));
              url.searchParams.set('offset', offset);
              url.searchParams.set('spotType', spotType);
              url.searchParams.set('accessHours', accessHours);

              // update url with new parameters
              window.history.replaceState({}, '', url.origin + url.pathname + url.search);

              // window.history.replaceState({}, '', '/search/?type=monthly&lat=' + lat + '&lng=' + lng + '&address=' + encodeURIComponent(address) + '&offset=' + offset + '&spotType=' + spotType + '&accessHours=' + accessHours + '');

              searchResultsList();
              sortSearchResults();
              searchMap(lat, lng, 'map');
              $('input[name="max-price"]').attr('disabled', true);

              /*** highlight pin when hovering on result listing ***/
              $('.result').hover(function () {
                var thisFacility = $(this).attr('id');
                $('.marker[data-facility-id="' + thisFacility + '"]').addClass('marker-active');
              }, function () {
                var thisFacility = $(this).attr('id');
                $('.marker[data-facility-id="' + thisFacility + '"]').removeClass('marker-active');
              });

            } else if (results.status == 'error') {

              if (results.template) {

                $('.site-content-overlay').removeClass('site-content-overlay-active');
                $('.search-results-list').empty().append(results.template);
                searchMap(lat, lng, 'map');

                // get current url and parameters
                var url = new URL(window.location);

                // update parameters based on search query
                url.searchParams.set('type', parkingType);
                // url.searchParams.set('startDate', startDate);
                // url.searchParams.set('startTime', startTime);
                // url.searchParams.set('endDate', endDate);
                // url.searchParams.set('endTime', endTime);
                url.searchParams.set('lat', lat);
                url.searchParams.set('lng', lng);
                url.searchParams.set('address', encodeURIComponent(address));
                url.searchParams.set('offset', offset);

                // update url with new parameters
                window.history.replaceState({}, '', url.origin + url.pathname + url.search);

                // window.history.replaceState({}, '', '/search/?type=hourly&lat=' + lat + '&lng=' + lng + '&address=' + encodeURIComponent(address) + '&offset=' + offset + '');

              } else {

                launchAlert('Error', results.message);

              }

            } else {

              launchAlert('Error', results.message);

            }
          },
          error: function (results) {
            var results = JSON.parse(results);
            console.log(results);
            $('.button-spinner').prop('disabled', false);
          }

        });

      }

    } else {

      launchAlert('Error', 'Somehow you managed to not choose hourly or monthly parking?');
      $('.button-spinner').prop('disabled', false);

    }

  });

}

/* facility modal window */
function facilityModal(facilityId) {

  $('.site-content-overlay').addClass('site-content-overlay-active');
  $('.site-content-overlay-text').empty().text('Loading...');

  // get facility information
  var facilityId = facilityId;
  var thisFacility = $('#' + facilityId);
  var reserveUrl = $('.result-button-reserve', thisFacility).attr('href');

  // get search information
  var parkingType = $('input[name="parking-type"]:checked').val();
  var price = $('#' + facilityId).attr('data-price');

  console.log('price:', price);

  if (parkingType == 'hourly') {
    var startDate = $('#start-date').val();
    var startTime = $('#start-time').val();
    var endDate = $('#end-date').val();
    var endTime = $('#end-time').val();

    $.ajax({
      type: 'post',
      url: '/wp-admin/admin-ajax.php',
      data: {
        action: 'facility_modal',
        facilityId: facilityId,
        reserveUrl: reserveUrl,
        parkingType: parkingType,
        startDate: startDate,
        startTime: startTime,
        endDate: endDate,
        endTime: endTime,
        price: price
      },
      success: function (results) {
        $('.site-content-overlay').removeClass('site-content-overlay-active');
        $('.modal-window').empty().append(results);
        $('body').addClass('modal-active');
        modalClose();
        basicTabs();
        facilityPhotos();
        // modalDistance(facilityId);
      },
      error: function (results) {
        $('.site-content-overlay').removeClass('site-content-overlay-active');
        console.log('Hmm, something might be broken...', results);
      }
    });

  } else if (parkingType == 'monthly') {
    var startDate = $('#start-date-monthly').val();

    $.ajax({
      type: 'post',
      url: '/wp-admin/admin-ajax.php',
      data: {
        action: 'facility_modal',
        facilityId: facilityId,
        reserveUrl: reserveUrl,
        parkingType: parkingType,
        startDate: startDate,
        price: price
      },
      success: function (results) {
        $('.site-content-overlay').removeClass('site-content-overlay-active');
        $('.modal-window').empty().append(results);
        $('body').addClass('modal-active');
        modalClose();
        basicTabs();
        facilityPhotos();
        // modalDistance(facilityId);
      },
      error: function (results) {
        console.log('Hmm, something might be broken...', results);
      }
    });

  }
}

/* close modal and empty content */
function modalClose() {
  $('.modal-close-button').click(function (e) {
    e.preventDefault();
    $('body').removeClass('modal-active');
    $('.modal-window').empty();
  });
}

/* tabs functionality */
function basicTabs() {
  $('.tabs').each(function () {
    $('.tabs-nav a').click(function (e) {
      e.preventDefault();
      var tab = $(this).attr('href');
      $('.tabs-nav li').removeClass('tab-active');
      $('.tab').removeClass('tab-active');
      $(this).parent().addClass('tab-active');
      $(tab).addClass('tab-active');
    });
  });
}

/* facility photo gallery */
function facilityPhotos() {
  $('.facility-photo-gallery').each(function () {
    // if there's more than one photo, initalize slider
    if ($(this).find('.facility-photo').length > 1) {
      var facility_photos = $(this).flickity({
        adaptiveHeight: true,
        cellAlign: 'left',
        contain: true,
        imagesLoaded: true,
        pageDots: false,
        percentPosition: true,
        wrapAround: true
      });
    }
  });
}

/* search results list functionality */
function searchResultsList() {
  $('.result').each(function () {
    var thisFacility = $(this);
    var latitude = $(this).attr('data-latitude');
    var longitude = $(this).attr('data-longitude');
    // calculate walking distance and time from facility to location
    // walkingDistance(thisFacility, latitude, longitude);
    // get content for facility modal on "details" button click
    $('.result-button-details', this).click(function () {
      var facilityId = $(this).parents('li').attr('id');
      $('body').removeClass('search-results-overlay');
      facilityModal(facilityId);
    });
  });
}

/* search results sort functionality */
function sortSearchResults() {
  var config = {
    debug: {
      enable: true
    },
    load: {
      sort: 'proximity:asc'
    },
    animation: {
      effects: 'fade scale',
      duration: 500,
      easing: 'ease-in-out'
    },
    classNames: {
      block: 'toolbar',
      elementFilter: 'button',
      elementSort: 'button'
    },
    selectors: {
      target: '.result'
    }
  };
  var container = $('.search-results-list ol');
  if (container.length > 0) {
    var mixer = mixitup(container, config);
  }
}

/* get cookies */
function getCookie(cookieName) {
  let cookie = {};
  document.cookie.split(';').forEach(function (el) {
    let [key, value] = el.split('=');
    cookie[key.trim()] = value;
  });
  return cookie[cookieName];
}

/* process url parameters */
function getUrlParameter(name) {
  name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
  var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
  var results = regex.exec(location.search);
  return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
};

/* add a new license plate */
function newLicensePlateField() {
  $('input[name="license-plates"]').change(function () {
    var value = $(this).val();
    if (value == 'new') {
      $('#new-license-plate-field').show();
    } else {
      $('#new-license-plate-field').hide();
    }
  });
}

/* add a new credit card */
function newCreditCardField() {
  $('input[name="credit-cards"]').change(function () {
    var value = $(this).val();
    if (value == 'new') {
      $('#new-credit-card-field').show();
    } else {
      $('#new-credit-card-field').hide();
    }
  });
}

function debounce(func, wait, immediate) {
  var timeout;
  return function () {
    var context = this, args = arguments;
    var later = function () {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
};

let USDollar = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD'
});

function calculateMonthlyPrice() {
  var quantity = $('#quantity').val();
  if (quantity > 0) {
    var productPrice = $('input[name="monthly-options"]:checked').attr('data-price');
    var displayPrice = productPrice * quantity;
    $('#display-price').text(USDollar.format(displayPrice).replace('$', '').trim());
    // var stripePrice = displayPrice * 100;
    var stripePrice = productPrice * 100;
    $('#price').val(stripePrice);
  } else {
    console.log('quantity is less than 1');
  }
}

function calculateCouponPrice() {
  var quantity = $('#quantity').val();
  if (quantity > 0) {
    var productPrice = $('input[name="coupon-options"]:checked').attr('data-price');
    var displayPrice = productPrice * quantity;
    $('#display-price').text(USDollar.format(displayPrice).replace('$', '').trim());
    // var stripePrice = displayPrice * 100;
    var stripePrice = productPrice * 100;
    $('#price').val(stripePrice);
  } else {
    console.log('quantity is less than 1');
  }
}

function slugify(string) {
  var slug = string;
  slug = $.trim(slug);
  slug = slug.replace(/[^a-z0-9-]/gi, '-').replace(/-+/g, '-').replace(/^-|-$/g, '');
  return slug.toLowerCase();
}

function updateGpiCardFormHeight() {
  Object.keys(GPIForm.fields).forEach(formField => {
    $(GPIForm.fields[formField].target + " iframe").height(50);
  });
}

function chirp2_sf_form_update_hourly_checkout_url(url, start_date_time, end_date_time, offset, promo_code, price) {
  var checkout_url = new URL(url);
  // adjust times for offset
  start_date_time = Number(start_date_time) + Number(offset);
  end_date_time = Number(end_date_time) + Number(offset);
  // set/reset url parameters
  checkout_url.searchParams.set('startTime', start_date_time);
  checkout_url.searchParams.set('endTime', end_date_time);
  if (promo_code) {
    checkout_url.searchParams.set('promoCode', promo_code);	
  } else {
    checkout_url.searchParams.delete('promoCode');	
  }
  if (price) {
    checkout_url.searchParams.set('expectedPrice', price);  
  }
  // convert url object into string
  var checkout_url_string = checkout_url.toString();
  $('#hourly-parking-submit').attr('href', checkout_url_string);
}

function chirp2_sf_form_update_monthly_checkout_url(url, product_id, start_date, offset, quantity, promo_code) {
  var checkout_url = new URL(url);
  // convert start date into unix timestamp
  var start_moment_obj = moment(start_date + ' 12:00', 'YYYY-MM-DD HH:mm');
  var start_date_time = start_moment_obj.unix();
  // adjust times for offset
  start_date_time = Number(start_date_time) + Number(offset);
  // set/reset url parameters
  checkout_url.searchParams.set('productId', product_id);
  checkout_url.searchParams.set('startTime', start_date_time);
  checkout_url.searchParams.set('quantity', quantity);
  if (promo_code) {
    checkout_url.searchParams.set('promoCode', promo_code);	
  } else {
    checkout_url.searchParams.delete('promoCode');	
  }
  // convert url object into string
  var checkout_url_string = checkout_url.toString();
  $('#monthly-parking-submit').attr('href', checkout_url_string);
}

function chirp2_sf_form_update_coupon_checkout_url(url, product_id, quantity, promo_code) {
  var checkout_url = new URL(url);
  // set/reset url parameters
  checkout_url.searchParams.set('productId', product_id);
  checkout_url.searchParams.set('quantity', quantity);
  if (promo_code) {
    checkout_url.searchParams.set('promoCode', promo_code);	
  } else {
    checkout_url.searchParams.delete('promoCode');	
  }
  // convert url object into string
  var checkout_url_string = checkout_url.toString();
  $('#coupon-parking-submit').attr('href', checkout_url_string);
}

function chirp2_sf_form_update_hourly_price(facility_id, start_date, start_time, end_date, end_time, offset, promo_code) {
  // enable loading overlay
  $('#hourly-parking-loading').addClass('chirp2-sf-form-tab-loading-active');
  
  // convert dates and times into unix timestamps
  var start_moment_obj = moment(start_date + ' ' + start_time, 'YYYY-MM-DD HH:mm');
  var end_moment_obj = moment(end_date + ' ' + end_time, 'YYYY-MM-DD HH:mm');
  var start_date_time = start_moment_obj.unix();
  var end_date_time = end_moment_obj.unix();

  // get the date and time right now for comparison
  var now_moment = moment();
  // round minutes down to the nearest 30 minutes interval
  if (now_moment.minutes() < 30) {
    // minutes less than 30, round down to 0
    now_moment.minutes(0).seconds(0);
  } else {
    // minutes 30 or more, round down to 30
    now_moment.minutes(30).seconds(0);
  }
  var now_date_time = moment(now_moment).unix();
  
  $.ajax({
    type: 'post',
    url: '/wp-admin/admin-ajax.php',
    data: {
      action: 'calculate_hourly_price',
      facilityId: facility_id,
      startDateTime: start_date_time,
      endDateTime: end_date_time,
      nowDateTime: now_date_time,
      promoCode: promo_code
    },
    success: function(results) {
      var results = JSON.parse(results);
      console.log(results);
      if (results.status === 'success') {
        $('#hourly-display-price').empty().text(results.new_display_price);
        $('#hourly-price').val(results.new_price);
        $('#hourly-parking-message').empty().removeClass('form-card-message-error').addClass('form-card-message-success').text(results.message);
      } else if (results.status === 'error') {
        $('#hourly-display-price').empty().text(' N/A');
        $('#hourly-price').val('N/A');
        $('#hourly-parking-message').empty().removeClass('form-card-message-success').addClass('form-card-message-error').text(results.message);
      }
      var current_url = $('#hourly-parking-submit').attr('href');
      chirp2_sf_form_update_hourly_checkout_url(current_url, start_date_time, end_date_time, offset, promo_code, results.new_price);
      // disable loading overlay
      $('#hourly-parking-loading').removeClass('chirp2-sf-form-tab-loading-active');
    },
    error: function(results) {
      $('#hourly-display-price').empty().text(' N/A');
      $('#hourly-price').val('N/A');
      $('#hourly-parking-message').empty().removeClass('form-card-message-success').addClass('form-card-message-error').text('Something went wrong?');
      // disable loading overlay
      $('#hourly-parking-loading').removeClass('chirp2-sf-form-tab-loading-active');
    }
  });
}

function chirp2_sf_form_update_product_price(type, price, quantity) {
  var display_price = price * quantity;
  $('#' + type + '-display-price').text(USDollar.format(display_price).replace('$', '').trim());
}

function chirp2_sf_form_update_products(type, facility_id, promo_code) {
  $.ajax({
    type: 'post',
    url: '/wp-admin/admin-ajax.php',
    data: {
      action: 'calculate_product_price',
      facilityId: facility_id,
      parkingType: type,
      promoCode: promo_code
    },
    success: function(results) {
      var results = JSON.parse(results);
      console.log(results);
      if (results.status === 'success') {
        $('#' + type + '-products').empty().append(results.productTemplate);
        $('#' + type + '-display-price').empty().text(USDollar.format(results.productsArray[0].product_price).replace('$', '').trim());
        $('#' + type + '-parking-message').empty().removeClass('form-card-message-error').addClass('form-card-message-success').text(results.message);
        var current_url = $('#' + type + '-parking-submit').attr('href');
        var quantity = $('#' + type + '-quantity').val();
        chirp2_sf_form_update_coupon_checkout_url(current_url, results.productsArray[0].product_id, quantity, promo_code); 
      } else if (results.status === 'error') {
        $('#' + type + '-parking-message').empty().removeClass('form-card-message-success').addClass('form-card-message-error').text(results.message);
      }
    },
    error: function(results) {
      var results = JSON.parse(results);
      console.log(results);
      $('#' + type + '-parking-message').empty().removeClass('form-card-message-success').addClass('form-card-message-error').text('Something went wrong?');
    }
  });
  
}

function chirp2_sf_form_update_coupon_products(facility_id, promo_code) {
  console.log(facility_id, promo_code);
}

$(document).ready(function () {
  // get reCAPTCHA site key from script URL
  var recaptcha_url = new URL($('#recaptcha-js').attr('src'));
  var recaptcha_site_key = recaptcha_url.searchParams.get('render');

  const errorMessage = "There is an issue processing your payment. Please review the information entered, and try again."

  /* Request account deletion button */
  $('#request-account-deletion').on('click', function (e) {
    e.preventDefault();

    var button = $(this);
    $(button).prop('disabled', true);

    var name = $(this).attr('data-name');
    var email_address = $(this).attr('data-email-address');
    var time = moment().format('dddd, MMMM Do YYYY, h:mm:ss a');

    $.ajax({
      type: 'post',
      url: '/wp-admin/admin-ajax.php',
      data: {
        action: 'request_account_deletion',
        name: name,
        email_address: email_address,
        time: time
      },
      success: function (results) {
        var results = JSON.parse(results);
        console.log(results);
        if (results.status === 'success') {
          $(button).hide();
          $(button).next('.form-card-message').empty().removeClass('form-card-message-error').text(results.message);
        } else {
          $(button).next('.form-card-message').empty().removeClass('form-card-message-error').addClass('form-card-message-error').text(results.message);
        }
        $(button).prop('disabled', false);
      },
      error: function (results) {
        console.log(results);
        $(button).next('.form-card-message').empty().removeClass('form-card-message-error').addClass('form-card-message-error').text('Uh oh, something went wrong. Try again?');
        $(button).prop('disabled', false);
      }
    });
  });

  /* show/hide password field content */
  $('.reveal-password').on('click', function (e) {
    e.preventDefault();
    $(this).toggleClass('reveal-password-active');
    var input = $(this).parents('.form-field').find('input');
    console.log(input);
    if ($(input).attr('type') == 'password') {
      $(input).attr('type', 'text');
    } else if ($(input).attr('type') == 'text') {
      $(input).attr('type', 'password');
    }
  });

  /* open/close mobile nav */
  $('#mobile-nav-trigger').click(function () {
    var pixels_from_top = $(window).scrollTop();
    $('.mobile-nav').css('top', pixels_from_top + 'px');
    console.log('scrolled:', pixels_from_top);
    $('body').toggleClass('mobile-nav-active');
  });

  /* custom map markers */
  customMarker.prototype = new google.maps.OverlayView();

  customMarker.prototype.draw = function () {
    var thisMarker = this;
    var div = this.div;
    if (!div) {
      div = this.div = document.createElement('div');
      if (this.price == 'NA') {
        div.className = 'marker marker-alt';
      } else {
        div.className = 'marker';
      }

      if (this.city && this.state) {
        div.classList.add('marker-' + this.city + '-' + this.state);
      }

      var facilityId = document.createAttribute('data-facility-id');
      facilityId.value = this.id;
      div.setAttributeNode(facilityId);
      if (this.price == 'NA') {
        div.textContent = '';
      } else {
        div.textContent = '$' + Math.round(this.price);
      }

      // open facility modal on click
      google.maps.event.addDomListener(div, 'click', function (event) {
        google.maps.event.trigger(thisMarker, 'click');
        var facilityId = $(this).attr('data-facility-id');
        facilityModal(facilityId);
      });

      // highlight facility in sidebar on hover
      google.maps.event.addDomListener(div, 'mouseover', function (event) {
        var facilityId = $(this).attr('data-facility-id');
        $('#' + facilityId).addClass('result-active');
      });
      google.maps.event.addDomListener(div, 'mouseout', function (event) {
        var facilityId = $(this).attr('data-facility-id');
        $('#' + facilityId).removeClass('result-active');
      });

      var panes = this.getPanes();
      panes.floatPane.appendChild(div);
    }

    var position = this.getProjection().fromLatLngToDivPixel(this.latlng);
    if (position) {
      div.style.left = position.x + 'px';
      div.style.top = position.y + 'px';
    }
  };

  customMarker.prototype.remove = function () {
    if (this.div) {
      this.div.parentNode.removeChild(this.div);
      this.div = null;
    }
  };

  customMarker.prototype.getPosition = function () {
    return this.latlng;
  };

  /* toggle between map and list views */
  $('#map-list-trigger').click(function () {
    // if map view is visible, show list view
    // if list view is visible, show map view
    if ($('body').hasClass('search-map-active')) {
      $('body').removeClass('search-map-active').addClass('search-list-active');
    } else if ($('body').hasClass('search-list-active')) {
      $('body').removeClass('search-list-active').addClass('search-map-active');
    }
  });

  /* trigger search toolbar on mobile */
  $('#search-toolbar-trigger').click(function (e) {
    e.preventDefault();
    $('body').addClass('search-toolbar-active');
  });

  $('#search-toolbar-close').click(function (e) {
    e.preventDefault();
    $('body').removeClass('search-toolbar-active');
  });

  /* search toolbar - hourly/monthly parking toggle */
  $('#update-search input[name="parking-type"]').change(function () {

    $('.site-content-overlay').addClass('site-content-overlay-active');
    $('.site-content-overlay-text').empty().text('Loading...');

    // shared variables
    var parkingType = this.value;
    var lat = $('#address').attr('data-latitude');
    var lng = $('#address').attr('data-longitude');
    var address = 'you';
    if ($('#address').val().length > 0) {
      var address = $('#address').val();
    }
    var amenities = [];
    $.each($('input[name="amenities"]:checked'), function () {
      amenities.push($(this).val());
    });
    var maxPrice = $('#max-price').val();
    var timezone = $('#timezone').val();
    var offset = $('#offset').val();
    var nonce = $('#chirp-update-search-nonce').val();

    var nowDateTime = Number($('#now-date-time').val());

    var showAllFacilities = 'false';
    if ($('#show-all-facilities').length) {
      var showAllFacilities = $('#show-all-facilities').val();
    }

    console.log(parkingType, lat, lng, address, amenities, maxPrice, timezone, offset, nonce, nowDateTime, showAllFacilities);

    // toggle data-cy attributes
    var options = $('#update-search input[name="parking-type"]');
    $(options).each(function (index, option) {
      var data_cy_inactive_string = $(option).attr('data-cy-inactive-string');
      $(option).attr('data-cy', data_cy_inactive_string);
    });
    var data_cy_active_string = $(this).attr('data-cy-active-string');
    $(this).attr('data-cy', data_cy_active_string);

    if (parkingType == 'hourly') {

      // switch toolbar to show hourly parking fields
      $('.search-toolbar').removeClass('monthly-parking').addClass('hourly-parking');

      // hourly-only variables
      var startDate = $('#start-date').val();
      var startTime = $('#start-time').val();
      var endDate = $('#end-date').val();
      var endTime = $('#end-time').val();

      // convert dates and times to unix epoch format
      var startDateTime = new Date(startDate + 'T' + startTime).getTime() / 1000;
      var endDateTime = new Date(endDate + 'T' + endTime).getTime() / 1000;

      console.log(parkingType, startDate, startTime, endDate, endTime, startDateTime, endDateTime);

      $.ajax({
        type: 'post',
        url: '/wp-admin/admin-ajax.php',
        data: {
          action: 'hourly_parking_query',
          showAllFacilities: showAllFacilities,
          parkingType: parkingType,
          lat: lat,
          lng: lng,
          address: address,
          startDateTime: startDateTime,
          endDateTime: endDateTime,
          startDate: startDate,
          startTime: startTime,
          endDate: endDate,
          endTime: endTime,
          amenities: amenities,
          maxPrice: maxPrice,
          timezone: timezone,
          offset: offset
        },
        success: function (results) {
          var results = JSON.parse(results);
          console.log(results);

          // append results to sidebar
          $('.search-results-list').empty().append(results.template);

          // get current url and parameters
          var url = new URL(window.location);

          // update parameters based on search query
          url.searchParams.set('type', parkingType);
          url.searchParams.set('startDate', startDate);
          url.searchParams.set('startTime', startTime);
          url.searchParams.set('endDate', endDate);
          url.searchParams.set('endTime', endTime);
          url.searchParams.set('lat', lat);
          url.searchParams.set('lng', lng);
          url.searchParams.set('address', encodeURIComponent(address));
          url.searchParams.set('offset', offset);
          url.searchParams.set('spotType', spotType);
          url.searchParams.set('accessHours', accessHours);

          // update url with new parameters
          window.history.replaceState({}, '', url.origin + url.pathname + url.search);

          UpdateMobileMapTime(startDateTime, endDateTime);
          searchResultsList();
          sortSearchResults();
          searchMap(lat, lng, 'map');
          $('input[name="max-price"]').prop('disabled', false);

          /*** highlight pin when hovering on result listing ***/
          $('.result').hover(function () {
            var thisFacility = $(this).attr('id');
            $('.marker[data-facility-id="' + thisFacility + '"]').addClass('marker-active');
          }, function () {
            var thisFacility = $(this).attr('id');
            $('.marker[data-facility-id="' + thisFacility + '"]').removeClass('marker-active');
          });

          if (results.status == 'success') {
            // cool, found somewhere to park!
          } else if (results.status == 'error') {
            // nope, nowhere to park
          }

          // remove loading overlay
          $('.site-content-overlay').removeClass('site-content-overlay-active');
        },
        error: function (results) {
          console.log(results);
        }
      });

    } else if (parkingType == 'monthly') {

      // switch toolbar to show monthly parking fields
      $('.search-toolbar').removeClass('hourly-parking').addClass('monthly-parking');

      // monthly-specific variables
      var spotType = $('#spot-type').val();
      var accessHours = $('#access-hours').val();
      var startDate = $('#start-date-monthly').val();
      let cookieDomain = window.location.hostname;
      let isSecure = window.location.protocol === 'https:';
      let cookieString = `startDate=${startDate}; path=/; domain=.${cookieDomain};`;
      if (isSecure) {
        cookieString += ' Secure; SameSite=None;';
      }
      document.cookie = cookieString;

      var startTime = '23:59';

      var startDateTime = new Date(startDate + 'T' + startTime).getTime() / 1000;

      console.log(parkingType, spotType, accessHours, startDate, startTime, startDateTime);

      $.ajax({
        type: 'post',
        url: '/wp-admin/admin-ajax.php',
        data: {
          action: 'monthly_parking_query',
          showAllFacilities: showAllFacilities,
          parkingType: parkingType,
          address: address,
          lat: lat,
          lng: lng,
          amenities: amenities,
          maxPrice: maxPrice,
          timezone: timezone,
          offset: offset,
          nonce: nonce,
          spotType: spotType,
          accessHours: accessHours,
          startDateTime: startDateTime
        },
        success: function (results) {
          var results = JSON.parse(results);
          console.log(results);

          // append results to sidebar
          $('.search-results-list').empty().append(results.template);

          // get current url and parameters
          var url = new URL(window.location);

          // update parameters based on search query
          url.searchParams.set('type', parkingType);
          url.searchParams.set('startDate', startDate);
          url.searchParams.set('startTime', startTime);
          url.searchParams.set('endDate', endDate);
          url.searchParams.set('endTime', endTime);
          url.searchParams.set('lat', lat);
          url.searchParams.set('lng', lng);
          url.searchParams.set('address', encodeURIComponent(address));
          url.searchParams.set('offset', offset);
          url.searchParams.set('spotType', spotType);
          url.searchParams.set('accessHours', accessHours);

          // update url with new parameters
          window.history.replaceState({}, '', url.origin + url.pathname + url.search);

          UpdateMobileMapTime(startDateTime, startDateTime + 10800);
          searchResultsList();
          sortSearchResults();
          searchMap(lat, lng, 'map');
          $('input[name="max-price"]').prop('disabled', false);

          // highlight pin when hovering on result listing
          $('.result').hover(function () {
            var thisFacility = $(this).attr('id');
            $('.marker[data-facility-id="' + thisFacility + '"]').addClass('marker-active');
          }, function () {
            var thisFacility = $(this).attr('id');
            $('.marker[data-facility-id="' + thisFacility + '"]').removeClass('marker-active');
          });

          if (results.status == 'success') {
            // cool, found somewhere to park!
          } else if (results.status == 'error') {
            // nope, nowhere to park
          }

          // remove loading overlay
          $('.site-content-overlay').removeClass('site-content-overlay-active');
        },
        error: function (results) {
          console.log(results);
        }
      });
    }
  });

  /* trigger filter toolbar */
  $('#filter-toolbar-trigger').click(function (e) {
    e.preventDefault();
    $('body').toggleClass('filter-toolbar-active');
  });

  $('#filter-toolbar-close').click(function (e) {
    e.preventDefault();
    $('body').removeClass('filter-toolbar-active');
  });

  /* display value on input["range"] elements */
  $('.toolbar-input-range').each(function () {
    var rangeInput = $('input[type="range"]', this);
    var rangeValue = $('.toolbar-input-range-value', this);
    $(rangeInput).on('input change', function () {
      $(rangeValue).html($(this).val());
    });
  });

  /* show/hide password in registration fields */
  $('#show-password').change(function () {
    if ($(this).is(':checked')) {
      var input = $(this).closest('.form-field').find('input[type="password"]');
      input.attr('type', 'text');
    } else {
      var input = $(this).closest('.form-field').find('input[type="text"]');
      input.attr('type', 'password');
    }
  });

  /* registration form functionality */
  $('#registration-form').validate({
    // debug: true,
    errorElement: 'span',
    errorClass: 'form-field-error',
    validClass: 'form-field-valid',
    errorPlacement: function (error, element) {
      error.appendTo(element.parents('.form-field'));
      error.attr('data-cy', `${error[0].id}-text`);
    },
    highlight: function (element, errorClass, validClass) {
      $(element).parents('.form-field').addClass(errorClass).removeClass(validClass);
    },
    unhighlight: function (element, errorClass, validClass) {
      $(element).parents('.form-field').removeClass(errorClass).addClass(validClass);
    },
    rules: {
      'create-first-name': {
        required: true,
        minlength: 2
      },
      'create-last-name': {
        required: true,
        minlength: 2
      },
      'create-email': {
        required: true,
        email: true
      },
      'create-email-match': {
        email: true,
        equalTo: '#create-email'
      },
      'create-password': {
        required: true,
        minlength: 8,
        maxlength: 99
      },
      'create-password-match': {
        minlength: 8,
        maxlength: 99,
        equalTo: '#create-password'
      }
    },
    messages: {
      'create-first-name': {
        required: 'Please enter your first name.',
        minlength: 'Your first name must be at least 2 characters long.'
      },
      'create-last-name': {
        required: 'Please enter your last name.',
        minlength: 'Your last name must be at least 2 characters long.'
      },
      'create-email': {
        required: 'Please enter your email address.',
        email: 'Please enter a valid email address.'
      },
      'create-email-match': {
        email: 'Please enter a valid email address.',
        equalTo: 'Your email address does not match the previous field.'
      },
      'create-password': {
        required: 'Please provide a password.',
        minlength: 'Your password must be at least 8 characters long.',
        maxlength: 'Your password must be 64 characters or less.'
      },
      'create-password-match': {
        minlength: 'Your password must be at least 8 characters long.',
        maxlength: 'Your password must be 64 characters or less.',
        equalTo: 'Your password does not match the previous field.'
      }
    },
    submitHandler: function (form) {

      $('.button-spinner', form).prop('disabled', true);

      grecaptcha.ready(function () {
        grecaptcha.execute(recaptcha_site_key, { action: 'create_account' }).then(function (token) {
          var redirectUrl = $(form).attr('data-redirect-url');
          var firstName = $('#create-first-name').val();
          var lastName = $('#create-last-name').val();
          var email = $('#create-email').val();
          var username = $('#create-email').val();
          var password = $('#create-password').val();
          var siteId = $('#site-id').val();
          var nonce = $('#chirp-new-user-nonce').val();
          $.ajax({
            type: 'post',
            url: '/wp-admin/admin-ajax.php',
            data: {
              action: 'register_user',
              redirectUrl: redirectUrl,
              firstName: firstName,
              lastName: lastName,
              email: email,
              username: username,
              password: password,
              siteId: siteId,
              recaptchaToken: token,
              nonce: nonce
            },
            success: function (results) {
              var results = $.parseJSON(results);
              console.log(results);
              if (results.status === 'success') {
                console.log(results.redirectUrl);
                $('.form-card-message').removeClass('form-card-message-error').addClass('form-card-message-success').text(results.message);
                setTimeout(function () {
                  if (results.redirectUrl == 'reload') {
                    location.reload();
                  } else {
                    window.location.href = redirectUrl;
                  }
                }, 1000);
              } else if (results.status === 'error') {
                $('.button-spinner', form).prop('disabled', false);
                $('.form-card-message').removeClass('form-card-message-success').addClass('form-card-message-error').text(results.message);
              } else {
                $('.button-spinner', form).prop('disabled', false);
                $('.form-card-message').removeClass('form-card-message-success').addClass('form-card-message-error').text('Oops, something went wrong. Please try again?');
              }
            },
            error: function (results) {
              var results = $.parseJSON(results);
              console.log(results);
              $('.button-spinner', form).prop('disabled', false);
              $('.form-card-message').removeClass('form-card-message-success').addClass('form-card-message-error').text('Oops, something went wrong. Please try again?');
            }
          });
        });
      });
    }
  });

  /* log in form functionality */
  $('#login-form').validate({
    // debug: true,
    errorElement: 'span',
    errorClass: 'form-field-error',
    validClass: 'form-field-valid',
    errorPlacement: function (error, element) {
      error.appendTo(element.parents('.form-field'));
    },
    highlight: function (element, errorClass, validClass) {
      $(element).parents('.form-field').addClass(errorClass).removeClass(validClass);
    },
    unhighlight: function (element, errorClass, validClass) {
      $(element).parents('.form-field').removeClass(errorClass).addClass(validClass);
    },
    rules: {
      'email': {
        required: true,
        email: true
      },
      'password': {
        required: true
      }
    },
    messages: {
      'email': {
        required: 'Please enter your email address.',
        email: 'Please enter a valid email address.'
      },
      'password': {
        required: 'Please enter your password.'
      }
    },
    submitHandler: function (form) {

      $('.button-spinner', form).prop('disabled', true);

      grecaptcha.ready(function () {
        grecaptcha.execute(recaptcha_site_key, { action: 'login' }).then(function (token) {
          var email = $('#login-email').val();
          var password = $('#login-password').val();
          var remember = false;
          if ($('#login-remember').is(':checked')) {
            var remember = true;
          }
          var nonce = $('#chirp-login-nonce').val();
          $.ajax({
            type: 'post',
            url: '/wp-admin/admin-ajax.php',
            data: {
              action: 'login',
              email: email,
              password: password,
              remember: remember,
              recaptchaToken: token,
              nonce: nonce
            },
            success: function (results) {
              var results = $.parseJSON(results);
              console.log(results);
              if (results.status === 'success') {
                $('.form-card-message').removeClass('form-card-message-error').addClass('form-card-message-success').text(results.message);
                setTimeout(function () {
                  location.reload();
                }, 1000);
              } else if (results.status === 'error') {
                $('.button-spinner', form).prop('disabled', false);
                $('.form-card-message').removeClass('form-card-message-success').addClass('form-card-message-error').text(results.message);
              } else {
                $('.button-spinner', form).prop('disabled', false);
                $('.form-card-message').removeClass('form-card-message-success').addClass('form-card-message-error').text('Oops, something went wrong. Please try again?');
              }
            },
            error: function (results) {
              console.log('results', results);
              $('.button-spinner', form).prop('disabled', false);
              $('.form-card-message').removeClass('form-card-message-success').addClass('form-card-message-error').text('Oops, something went wrong. Please try again?');
            }
          });
        });
      });
    }
  });

  /* account settings: update profile form */
  $('#update-profile').validate({
    // debug: true,
    errorElement: 'span',
    errorClass: 'form-field-error',
    validClass: 'form-field-valid',
    errorPlacement: function (error, element) {
      error.appendTo(element.parents('.form-field'));
      error.attr('data-cy', `${error[0].id}-text`);
    },
    highlight: function (element, errorClass, validClass) {
      $(element).parents('.form-field').addClass(errorClass).removeClass(validClass);
    },
    unhighlight: function (element, errorClass, validClass) {
      $(element).parents('.form-field').removeClass(errorClass).addClass(validClass);
    },
    rules: {
      'first-name': {
        required: true,
        minlength: 2
      },
      'last-name': {
        required: true,
        minlength: 2
      },
      'phone-number': {
        // required: true,
        phoneUS: true
      },
      'street-address': {
        // required: true,
        minlength: 2
      },
      'city': {
        // required: true,
        minlength: 2
      },
      'zip-code': {
        // required: true,
        zipcodeUS: true
      }
    },
    messages: {
      'first-name': {
        required: 'Please enter your first name.',
        minlength: 'Your first name must be at least 2 characters long.'
      },
      'last-name': {
        required: 'Please enter your last name.',
        minlength: 'Your last name must be at least 2 characters long.'
      },
      'phone-number': {
        // required: 'Please enter your phone number.',
        phoneUS: 'Please enter a valid phone number.'
      },
      'street-address': {
        // required: 'Please enter your street address',
        minlength: 'Please enter a valid street address.'
      },
      'city': {
        // required: 'Please enter your city.',
        minlength: 'Please enter a valid city name.'
      },
      'zip-code': {
        // required: 'Please enter your zip code.',
        zipcodeUS: 'Please enter a valid zip code.'
      }
    },
    submitHandler: function (form) {

      $('.button-spinner', form).prop('disabled', true);

      var userId = $('#user-id').val();
      var firstName = $('#first-name').val();
      var lastName = $('#last-name').val();

      var phoneNumber = $('#phone-number').val();
      var streetAddress = $('#street-address').val();
      var city = $('#city').val();
      var state = $('#state').val();
      var zipCode = $('#zip-code').val();

      var licensePlates = [];
      $('input[name="license-plates"]').each(function () {
        if ($(this).val()) {
          var plate = $(this).val();
          licensePlates.push(plate);
        }
      });

      console.log(licensePlates);

      var nonce = $('#chirp-update-profile-nonce').val();

      $.ajax({
        type: 'post',
        url: '/wp-admin/admin-ajax.php',
        data: {
          action: 'update_profile',
          userId: userId,
          firstName: firstName,
          lastName: lastName,
          streetAddress: streetAddress,
          city: city,
          state: state,
          zipCode: zipCode,
          phoneNumber: phoneNumber,
          licensePlates: licensePlates,
          nonce: nonce
        },
        success: function (results) {
          var results = JSON.parse(results);
          console.log(results);
          $('.button-spinner', form).prop('disabled', false);
          if (results.updated == true) {
            $('.form-card-message', form).addClass('form-card-message-success').text(results.message).attr("data-cy", "form-success-text");
          } else {
            $('.form-card-message', form).addClass('form-card-message-error').text(results.message);
          }
        },
        error: function (results) {
          var results = JSON.parse(results);
          console.log(results);
          $('.button-spinner', form).prop('disabled', false);
        }
      });

    }
  });

  /* account settings: update password form */
  $('#update-password').validate({
    // debug: true,
    errorElement: 'span',
    errorClass: 'form-field-error',
    validClass: 'form-field-valid',
    errorPlacement: function (error, element) {
      error.appendTo(element.parents('.form-field'));
      error.attr('data-cy', `${error[0].id}-text`);
    },
    highlight: function (element, errorClass, validClass) {
      $(element).parents('.form-field').addClass(errorClass).removeClass(validClass);
    },
    unhighlight: function (element, errorClass, validClass) {
      $(element).parents('.form-field').removeClass(errorClass).addClass(validClass);
    },
    rules: {
      'current-password': {
        required: true,
        minlength: 8,
        maxlength: 99
      },
      'new-password': {
        required: true,
        minlength: 8,
        maxlength: 99
      },
      'new-password-again': {
        required: true,
        minlength: 8,
        maxlength: 99,
        equalTo: '#new-password'
      }
    },
    messages: {
      'current-password': {
        required: 'Please enter your password.',
        minlength: 'Your password must be at least 8 characters long.',
        maxlength: 'Your password must be 64 characters or less.'
      },
      'new-password': {
        required: 'Please enter your password.',
        minlength: 'Your password must be at least 8 characters long.',
        maxlength: 'Your password must be 64 characters or less.'
      },
      'new-password-again': {
        required: 'Please enter your password.',
        minlength: 'Your password must be at least 8 characters long.',
        maxlength: 'Your password must be 64 characters or less.',
        equalTo: 'Please enter the same new password as above.'
      }
    },
    submitHandler: function (form) {

      $('.button-spinner', form).prop('disabled', true);

      var userId = $('#user-id').val();
      var currentPass = $('#current-password').val();
      var newPass = $('#new-password').val();
      var newPassAgain = $('#new-password-again').val();
      var nonce = $('#chirp-update-password-nonce').val();

      $.ajax({
        type: 'post',
        url: '/wp-admin/admin-ajax.php',
        data: {
          action: 'update_password',
          userId: userId,
          currentPass: currentPass,
          newPass: newPass,
          newPassAgain: newPassAgain,
          nonce: nonce
        },
        success: function (results) {
          var results = JSON.parse(results);
          console.log(results);
          $('.button-spinner', form).prop('disabled', false);
          if (results.updated == true) {
            $('.form-card-message', form).addClass('form-card-message-success').text(results.message).attr('data-cy', 'success-message-text');
          } else {
            $('.form-card-message', form).addClass('form-card-message-error').text(results.message);
          }
        },
        error: function (results) {
          var results = JSON.parse(results);
          console.log(results);
          $('.button-spinner', form).prop('disabled', false);
        }
      });
    }
  });

  /* account settings: delete payment form */
  $('#delete-credit-cards, #delete-bank-accounts').submit(function (e) {
    e.preventDefault();

    $('.button-spinner', this).prop('disabled', true);

    var customerId = $('#customer-id').val();
    var nonce = $('#chirp-delete-payment-nonce').val();
    var sources = [];
    $('input[type="checkbox"]:checked', this).each(function () {
      var thisSourceId = $(this).val();
      sources.push(thisSourceId);
    });

    if (sources.length > 0) {

      $.ajax({
        type: 'post',
        url: '/wp-admin/admin-ajax.php',
        data: {
          action: 'delete_payment',
          customerId: customerId,
          sources: sources,
          nonce: nonce
        },
        success: function (results) {
          console.log('success!', results);
          $('.button-spinner', this).prop('disabled', false);
          location.reload();
        },
        error: function (results) {
          console.log('error!', results);
          $('.button-spinner', this).prop('disabled', false);
        }
      });

    } else {

      $('.button-spinner', this).prop('disabled', false);
      $(this).siblings('.form-card-message').empty().removeClass('form-card-message-success').addClass('form-card-message-error').text('Please select a source to delete.');

    }

  });

  /* request refund from transaction history */
  $('.transaction-refund').click(function (e) {
    e.preventDefault();
    var transactionId = $(this).attr('data-transaction-id');
    var facilityId = $(this).attr('data-facility-id');
    var thisTransaction = $(this).parents('.transaction');

    $.ajax({
      type: 'post',
      url: '/wp-admin/admin-ajax.php',
      data: {
        action: 'request_refund',
        transactionId: transactionId,
        facilityId: facilityId
      },
      success: function (results) {
        var results = JSON.parse(results);
        console.log(results);
        if (results.status == 'success') {

          $('.transaction-refund[data-transaction-id="' + transactionId + '"]').hide();
          $('.transaction-change-license[data-transaction-id="' + transactionId + '"]').hide();
          $(thisTransaction).addClass('transaction-refunded');
          console.log('Success!', results.message);

        } else {

          console.log('Error:', results.message);

        }
      },
      error: function (results) {
        // var results = JSON.parse(results);
        console.log(results);
      }
    });

  });

  /* reset password form functionality */
  $('#reset-password-form').validate({
    // debug: true,
    errorElement: 'span',
    errorClass: 'form-field-error',
    validClass: 'form-field-valid',
    errorPlacement: function (error, element) {
      error.appendTo(element.parents('.form-field'));
    },
    highlight: function (element, errorClass, validClass) {
      $(element).parents('.form-field').addClass(errorClass).removeClass(validClass);
    },
    unhighlight: function (element, errorClass, validClass) {
      $(element).parents('.form-field').removeClass(errorClass).addClass(validClass);
    },
    rules: {
      'email': {
        required: true,
        email: true
      }
    },
    messages: {
      'email': {
        required: 'Please enter your email address.',
        email: 'Please enter a valid email address.'
      },
    },
    submitHandler: function (form) {

      $('.button-spinner').prop('disabled', true);

      var email = $('#email').val();
      var nonce = $('#chirp-reset-password-nonce').val();

      $.ajax({
        type: 'post',
        url: '/wp-admin/admin-ajax.php',
        data: {
          action: 'reset_password',
          email: email,
          nonce: nonce
        },
        success: function (results) {
          var results = JSON.parse(results);
          console.log(results);
          $('.button-spinner').prop('disabled', false);
          if (results.status == 'success') {
            $('.form-card-message', form).empty().removeClass('form-card-message-error').addClass('form-card-message-success').text(results.message);
          } else {
            $('.form-card-message', form).empty().removeClass('form-card-message-success').addClass('form-card-message-error').text(results.message);
          }
        },
        error: function (results) {
          var results = JSON.parse(results);
          console.log(results);
          $('.button-spinner').prop('disabled', false);
          $('.form-card-message', form).empty().removeClass('form-card-message-success').addClass('form-card-message-error').text('Something went wrong. Please try again?');
        }
      });
    }
  });

  /* set new password form functionality */
  $('#new-password-form').validate({
    // debug: true,
    errorElement: 'span',
    errorClass: 'form-field-error',
    validClass: 'form-field-valid',
    errorPlacement: function (error, element) {
      error.appendTo(element.parents('.form-field'));
    },
    highlight: function (element, errorClass, validClass) {
      $(element).parents('.form-field').addClass(errorClass).removeClass(validClass);
    },
    unhighlight: function (element, errorClass, validClass) {
      $(element).parents('.form-field').removeClass(errorClass).addClass(validClass);
    },
    rules: {
      'new-password': {
        required: true,
        minlength: 8,
        maxlength: 99
      },
      'new-password-again': {
        required: true,
        minlength: 8,
        maxlength: 99,
        equalTo: '#new-password'
      }
    },
    messages: {
      'new-password': {
        required: 'Please enter your password.',
        minlength: 'Your password must be at least 8 characters long.',
        maxlength: 'Your password must be 64 characters or less.'
      },
      'new-password-again': {
        required: 'Please enter your password.',
        minlength: 'Your password must be at least 8 characters long.',
        maxlength: 'Your password must be 64 characters or less.',
        equalTo: 'Please enter the same new password as above.'
      }
    },
    submitHandler: function (form) {

      var key = $('#key').val();
      var login = $('#login').val();
      var newPassword = $('#new-password').val();
      var newPasswordAgain = $('#new-password-again').val();
      var nonce = $('#chirp-new-password-nonce').val();

      $.ajax({
        type: 'post',
        url: '/wp-admin/admin-ajax.php',
        data: {
          action: 'new_password',
          key: key,
          login: login,
          newPassword: newPassword,
          newPasswordAgain: newPasswordAgain,
          nonce: nonce
        },
        success: function (results) {
          var results = JSON.parse(results);
          console.log(results);
          if (results.reset == true) {
            $('.form-card-message', form).addClass('form-card-message-success').text(results.message);
          } else {
            $('.form-card-message', form).addClass('form-card-message-error').text(results.message);
          }
          // window.location.href = '/account';
        },
        error: function (results) {
          var results = JSON.parse(results);
          console.log(results);
          $('.form-card-message', form).addClass('form-card-message-error').text(results.message);
        }
      });
    }
  });

  /* toggle search results list */
  $('#search-results-trigger').click(function (e) {
    e.preventDefault();
    $('.search-grid').toggleClass('search-results-hidden');
  });

  /* toggle search panel (seo content) */
  $('#search-panel-trigger').click(function (e) {
    e.preventDefault();
    $('.search-grid').toggleClass('search-panel-hidden');
  });

  /* home page functionality */
  if ($('body').hasClass('page-template-page-home')) {

    // get local timezone
    var today = new Date();
    var timezoneOffset = today.getTimezoneOffset();
    var offset = (timezoneOffset * 60) * -1;
    $('#address').attr('data-offset', offset);

    autocomplete();
    initialSearchForm();
  }

  /* 404 page functionality */
  if ($('body').hasClass('error404')) {
    autocomplete();
    initialSearchForm();
  }

  /* single city page functionality */
  if ($('body').hasClass('single-cities')) {
    autocomplete();
    initialSearchForm();
  }

  /* single location page functionality */
  if ($('body').hasClass('single-locations') || $('body').hasClass('page-template-page-special-event')) {

    var lat = $('#address').attr('data-latitude');
    var lng = $('#address').attr('data-longitude');

    searchMap(lat, lng, 'map');
    autocomplete();
    searchResultsList();
    sortSearchResults();
    updateSearchForm();

  }

  /* search page functionality */
  if ($('body').hasClass('page-template-page-search') || $('body').hasClass('page-template-page-pw-search')) {
    var behavior = $('#default-behavior').val();
    if (behavior === 'geolocate') {

      $('.site-content-overlay').addClass('site-content-overlay-active');
      $('.site-content-overlay-text').empty().text('Finding your location...');

      if ('geolocation' in navigator) {

        var geoOptions = {
          enableHighAccuracy: true,
          timeout: 10000,
          maximumAge: 60000
        }

        navigator.geolocation.getCurrentPosition(geoSuccess, geoError, geoOptions);

        function geoSuccess(position) {
          console.log(position);

          var showAllFacilities = 'false';
          if ($('#show-all-facilities').length) {
            var showAllFacilities = $('#show-all-facilities').val();
          }
          var parkingType = $('input[name="parking-type"]:checked').val();
          var address = '';
          var latitude = position.coords.latitude;
          var longitude = position.coords.longitude;
          // var latitude = parseFloat(position.coords.latitude);
          // var longitude = parseFloat(position.coords.longitude);
          // var latitude = 27.95661879999999;
          // var longitude = -82.524525;

          var amenities = [];
          $.each($('input[name="amenities"]:checked'), function () {
            amenities.push($(this).val());
          });
          var maxPrice = $('#max-price').val();

          // get the date and time right now
          var start_moment = moment();
          // round minutes down to the nearest 30 minutes interval
          if (start_moment.minutes() < 30) {
            // minutes less than 30, round down to 0
            start_moment.minutes(0);
          } else {
            // minutes 30 or more, round down to 30
            start_moment.minutes(30);
          }
          // reset seconds to zero just to make it nice and clean
          start_moment.seconds(0);
          // add three hours to create the end date and time
          var end_moment = moment(start_moment).add(3, 'hours');

          // format start and end dates and times
          var startDate = start_moment.format('YYYY-MM-DD');
          var startTime = start_moment.format('HH:mm');
          var endDate = end_moment.format('YYYY-MM-DD');
          var endTime = end_moment.format('HH:mm');
          // get the timezone offset and format correctly
          var offset = start_moment.utcOffset() * 60;
          // use moment to find the timezone
          var timezone = moment.tz.guess();

          // set form elements to generated times
          $('#start-date').val(startDate);
          $('#start-time').val(startTime);
          $('#end-date').val(endDate);
          $('#end-time').val(endTime);
          $('#mobile-start-date').text(start_moment.format('MMM D'));
          $('#mobile-start-time').text(start_moment.format('H:mma'));
          $('#mobile-end-date').text(end_moment.format('MMM D'));
          $('#mobile-end-time').text(end_moment.format('H:mma'));
          $('#start-date-monthly').val(startDate);
          $('#now-date-time').val(start_moment.utc().unix());
          $('#timezone').val(timezone);
          $('#offset').val(offset);
          $('#address').attr({ 'data-latitude': latitude, 'data-longitude': longitude, 'data-offset': offset });

          if (parkingType == 'hourly') {

            var startDateTime = new Date(startDate + 'T' + startTime).getTime() / 1000;
            var endDateTime = new Date(endDate + 'T' + endTime).getTime() / 1000;

            $.ajax({
              type: 'post',
              url: '/wp-admin/admin-ajax.php',
              data: {
                action: 'hourly_parking_query',
                showAllFacilities: showAllFacilities,
                parkingType: parkingType,
                address: address,
                lat: latitude,
                lng: longitude,
                amenities: amenities,
                maxPrice: maxPrice,
                timezone: timezone,
                offset: offset,
                startDateTime: startDateTime,
                endDateTime: endDateTime,
                startDate: startDate,
                startTime: startTime,
                endDate: endDate,
                endTime: endTime,
              },
              success: function (results) {
                var results = JSON.parse(results);
                console.log(results);

                if (results.status == 'success') {

                  $('.site-content-overlay').removeClass('site-content-overlay-active');
                  $('.search-results-list').empty().append(results.template);

                  // get current url and parameters
                  var url = new URL(window.location);

                  // update parameters based on search query
                  url.searchParams.set('type', parkingType);
                  url.searchParams.set('startDate', startDate);
                  url.searchParams.set('startTime', startTime);
                  url.searchParams.set('endDate', endDate);
                  url.searchParams.set('endTime', endTime);
                  url.searchParams.set('lat', lat);
                  url.searchParams.set('lng', lng);
                  url.searchParams.set('address', encodeURIComponent(address));
                  url.searchParams.set('offset', offset);

                  // update url with new parameters
                  window.history.replaceState({}, '', url.origin + url.pathname + url.search);

                  // window.history.replaceState({}, '', '/search/?type=hourly&lat=' + latitude + '&lng=' + longitude + '&offset=' + offset + '');

                  UpdateMobileMapTime(results.startDateTime, results.endDateTime);
                  searchResultsList();
                  searchMap(latitude, longitude, 'map');
                  autocomplete();
                  updateSearchForm();
                  sortSearchResults();
                  $('input[name="max-price"]').attr('disabled', false);

                  /*** highlight pin when hovering on result listing ***/
                  $('.result').hover(function () {
                    var thisFacility = $(this).attr('id');
                    $('.marker[data-facility-id="' + thisFacility + '"]').addClass('marker-active');
                  }, function () {
                    var thisFacility = $(this).attr('id');
                    $('.marker[data-facility-id="' + thisFacility + '"]').removeClass('marker-active');
                  });

                  UpdateMobileMapTime(results.startDateTime, results.endDateTime);

                } else {

                  $('.site-content-overlay').removeClass('site-content-overlay-active');
                  $('.search-results-list').empty().append(results.template);

                  // get current url and parameters
                  var url = new URL(window.location);

                  // update parameters based on search query
                  url.searchParams.set('type', parkingType);
                  url.searchParams.set('startDate', startDate);
                  url.searchParams.set('startTime', startTime);
                  url.searchParams.set('endDate', endDate);
                  url.searchParams.set('endTime', endTime);
                  url.searchParams.set('lat', latitude);
                  url.searchParams.set('lng', longitude);
                  url.searchParams.set('address', encodeURIComponent(address));
                  url.searchParams.set('offset', offset);

                  // update url with new parameters
                  window.history.replaceState({}, '', url.origin + url.pathname + url.search);

                  // window.history.replaceState({}, '', '/search/?type=hourly&lat=' + latitude + '&lng=' + longitude + '&offset=' + offset + '');

                  searchResultsList();
                  searchMap(latitude, longitude, 'map');
                  $('#map').attr('data-latitude', latitude).attr('data-longitude', longitude);
                  autocomplete();
                  updateSearchForm();
                  sortSearchResults();
                  $('input[name="max-price"]').attr('disabled', false);
                  // launchAlert('Sorry!', results.message);

                }

              },
              error: function (results) {
                var results = JSON.parse(results);
                console.log(results);
                launchAlert('Error!', 'Uh oh, something is broken.');
              }
            });

          } else if (parkingType == 'monthly') {

            var spotType = $('#spot-type').val();
            var accessHours = $('#access-hours').val();
            startTime = '23:59';
            let cookieDomain = window.location.hostname;
            let isSecure = window.location.protocol === 'https:';
            let cookieString = `startDate=${startDate}; path=/; domain=.${cookieDomain};`;
            if (isSecure) {
              cookieString += ' Secure; SameSite=None;';
            }
            document.cookie = cookieString;
            var startDateTime = new Date(startDate + 'T' + startTime).getTime() / 1000;

            $.ajax({
              type: 'post',
              url: '/wp-admin/admin-ajax.php',
              data: {
                action: 'monthly_parking_query',
                showAllFacilities: showAllFacilities,
                parkingType: parkingType,
                address: address,
                lat: latitude,
                lng: longitude,
                amenities: amenities,
                maxPrice: maxPrice,
                timezone: timezone,
                offset: offset,
                startDateTime: startDateTime
              },
              success: function (results) {
                var results = JSON.parse(results);
                console.log(results);

                if (results.status == 'success') {

                  $('.site-content-overlay').removeClass('site-content-overlay-active');
                  $('.search-results-list').empty().append(results.template);

                  // get current url and parameters
                  var url = new URL(window.location);

                  // update parameters based on search query
                  url.searchParams.set('type', parkingType);
                  url.searchParams.set('startDate', startDate);
                  url.searchParams.set('startTime', startTime);
                  url.searchParams.set('endDate', endDate);
                  url.searchParams.set('endTime', endTime);
                  url.searchParams.set('lat', latitude);
                  url.searchParams.set('lng', longitude);
                  url.searchParams.set('address', encodeURIComponent(address));
                  url.searchParams.set('offset', offset);

                  // update url with new parameters
                  window.history.replaceState({}, '', url.origin + url.pathname + url.search);

                  // window.history.replaceState({}, '', '/search/?type=monthly&lat=' + latitude + '&lng=' + longitude + '&offset=' + offset + '');

                  searchResultsList();
                  searchMap(latitude, longitude, 'map');
                  autocomplete();
                  updateSearchForm();
                  $('input[name="max-price"]').attr('disabled', true);

                  /*** highlight pin when hovering on result listing ***/
                  $('.result').hover(function () {
                    var thisFacility = $(this).attr('id');
                    $('.marker[data-facility-id="' + thisFacility + '"]').addClass('marker-active');
                  }, function () {
                    var thisFacility = $(this).attr('id');
                    $('.marker[data-facility-id="' + thisFacility + '"]').removeClass('marker-active');
                  });

                  // update date and times in mobile view button
                  var startDateTimeObject = new Date((results.startDateTime * 1000) + (offset * 1000));
                  var nowDateTimeObject = new Date();

                  var startDateMonth = startDateTimeObject.getMonth() + 1;
                  var startDateDate = startDateTimeObject.getDate();
                  var startDateYear = startDateTimeObject.getFullYear();
                  var startTimeHours = startDateTimeObject.getHours() > 12 ? startDateTimeObject.getHours() - 12 : startDateTimeObject.getHours();
                  var startTimeMinutes = (startDateTimeObject.getMinutes() < 10 ? '0' : '') + startDateTimeObject.getMinutes();
                  var startTimeAmPm = (startDateTimeObject.getHours() > 11) ? 'pm' : 'am';

                  var nowDateMonth = nowDateTimeObject.getMonth() + 1;
                  var nowDateDate = nowDateTimeObject.getDate();
                  var nowDateYear = nowDateTimeObject.getFullYear();

                  function mobileMonthFormat(month) {
                    if (month == 1) {
                      return 'Jan';
                    } else if (month == 2) {
                      return 'Feb';
                    } else if (month == 3) {
                      return 'Mar';
                    } else if (month == 4) {
                      return 'Apr';
                    } else if (month == 5) {
                      return 'May';
                    } else if (month == 6) {
                      return 'Jun';
                    } else if (month == 7) {
                      return 'Jul';
                    } else if (month == 8) {
                      return 'Aug';
                    } else if (month == 9) {
                      return 'Sep';
                    } else if (month == 10) {
                      return 'Oct';
                    } else if (month == 11) {
                      return 'Nov';
                    } else if (month == 12) {
                      return 'Dec';
                    }
                  }

                  var startDateString = startDateYear + '-' + startDateMonth + '-' + startDateDate;
                  var startTimeString = startTimeHours + ':' + startTimeMinutes + '' + startTimeAmPm;
                  var startDateStringDisplay = mobileMonthFormat(startDateMonth) + ' ' + startDateDate;

                  var nowDateString = nowDateYear + '-' + nowDateMonth + '-' + nowDateDate;

                  if (startDateString == nowDateString) {
                    $('.search-toolbar-button-datetime-start .search-toolbar-button-date').empty().text('Today');
                  } else {
                    $('.search-toolbar-button-datetime-start .search-toolbar-button-date').empty().text(startDateStringDisplay);
                  }

                  $('.search-toolbar-button-datetime-start .search-toolbar-button-time').empty().text(startTimeString);

                } else {

                  launchAlert('Sorry!', results.message);

                }

              },
              error: function (results) {
                var results = JSON.parse(results);
                console.log(results);
                launchAlert('Error!', 'Uh oh, something is broken.');
              }
            });

          }

        }

        function geoError(error) {
          console.log(error);
          autocomplete();
          updateSearchForm();

          if (error.code == 1) {

            // permission denied
            launchAlert('Error', 'Please enable location services on your device and try again.');

          } else if (error.code == 2) {

            // position unavailable
            launchAlert('Error', 'Sorry, we were unable to find your location. Please try again.');

          } else if (error.code == 3) {

            // timeout
            launchAlert('Error', 'Geolocation timed out. Please try again.');

          } else {

            launchAlert('Error', error.message);

          }

        }

      } else {

        launchAlert('Sorry!', 'Your browser doesn\'t support geolocation.');

      }

    } else if (behavior === 'show-all-facilities') {

      var startDateTime = $('#start-date-time').val();
      var centerType = $('#center-type').val();
      var centerLat = $('#center-location-lat').val();
      var centerLng = $('#center-location-lng').val();
      var zoom = $('#center-location-zoom').val();

      if (startDateTime === '0') {

        $('.site-content-overlay').addClass('site-content-overlay-active');
        $('.site-content-overlay-text').empty().text('Loading...');

        // get current date and time, rounded to nearest 30 minutes
        var date = new Date();
        var startDate = GetDateStr(date);
        var startTime = GetTimeNearest30(date);

        $.ajax({
          type: 'post',
          url: '/wp-admin/admin-ajax.php',
          data: {
            action: 'chirp_get_date_and_show_all_facilities',
            startDate: startDate,
            startTime: startTime,
            centerType: centerType,
            centerLat: centerLat,
            centerLng: centerLng,
            zoom: zoom
          },
          success: function (results) {
            var results = JSON.parse(results);
            console.log(results);
            if (results.status === 'success') {

              $('#start-date').val(results.startDate);
              $('#start-time').val(results.startTime);
              $('#end-date').val(results.endDate);
              $('#end-time').val(results.endTime);

              $('.search-results-list').append(results.template);
              UpdateMobileMapTime(results.startDateTime, results.endDateTime);
              searchResultsList();
              allFacilitiesMap('map', centerType, centerLat, centerLng, zoom);
              autocomplete();
              updateSearchForm();
              sortSearchResults();
              /*** highlight pin when hovering on result listing ***/
              $('.result').hover(function () {
                var thisFacility = $(this).attr('id');
                $('.marker[data-facility-id="' + thisFacility + '"]').addClass('marker-active');
              }, function () {
                var thisFacility = $(this).attr('id');
                $('.marker[data-facility-id="' + thisFacility + '"]').removeClass('marker-active');
              });

              $('.site-content-overlay').removeClass('site-content-overlay-active');
              $('.site-content-overlay-text').empty();

            }
          },
          error: function (results) {
            // var results = JSON.parse(results);
            console.log(results);
            $('.site-content-overlay').removeClass('site-content-overlay-active');
            $('.site-content-overlay-text').empty()
          }
        });

      } else {
        allFacilitiesMap('map', centerType);
      }

    } else if (behavior === 'search-results') {

      var lat = $('#map').attr('data-latitude');
      var lng = $('#map').attr('data-longitude');

      searchMap(lat, lng, 'map');
      autocomplete();
      searchResultsList();
      sortSearchResults();
      updateSearchForm();

    }
  }

  /*** highlight pin when hovering on result listing ***/
  $('.result').hover(function () {
    var thisFacility = $(this).attr('id');
    $('.marker[data-facility-id="' + thisFacility + '"]').addClass('marker-active');
  }, function () {
    var thisFacility = $(this).attr('id');
    $('.marker[data-facility-id="' + thisFacility + '"]').removeClass('marker-active');
  });

  /* facility/checkout page functionality */

  /*** license plate repeater fields ***/

  $('.repeater').each(function () {
    var thisRepeater = $(this);

    // add a row
    $('.repeater-row-add', thisRepeater).click(function (e) {
      e.preventDefault();

      var rowNumbers = [];
      if ($('.repeater-row', thisRepeater).length) {
        $('.repeater-row', thisRepeater).each(function () {
          var rowNumber = $(this).attr('data-row-number');
          rowNumbers.push(rowNumber);
        });
        var newRowNumber = Math.max.apply(Math, rowNumbers) + 1;
      } else {
        var newRowNumber = 0;
      }

      $('.repeater-rows-group').append('<div class="form-field form-field-group repeater-row" data-row-number="' + newRowNumber + '"><div class="form-field"><label class="form-field-label visually-hidden" for="plate-' + newRowNumber + '">License Plate</label><input type="text" name="license-plates" id="plate-' + newRowNumber + '" /></div><button class="delete-button repeater-row-delete">Delete This Row</button></div>');
    });

    // delete a row
    $(document).on('click', '.repeater-row-delete', function (e) {
      e.preventDefault();
      $(this).parents('.repeater-row').remove();
    });

  });

  /*** stripe stuff ***/

  if ($('body').hasClass('single-facilities')) {

    var map = $('#map');
    if (map.length > 0) {
      var lat = $('#map').attr('data-latitude');
      var lng = $('#map').attr('data-longitude');
      if (lat.length > 0 && lng.length > 0) {
        simpleMap(lat, lng, 'map');
      }
    }

    facilityPhotos();

    var checkout = getUrlParameter('checkout');
    if (checkout == 'true') {

      var type = getUrlParameter('type');
      var expectedPrice = getUrlParameter('expectedPrice');
      var promoCode = getUrlParameter('promoCode');

      // $('#checkout-submit').prop('disabled', false);
      newLicensePlateField();
      basicTabs();

      // promo code apply button
      $('#apply-promo-code').click(function (e) {
        e.preventDefault();

        // show loading animation
        $('#reservation-summary .card-content-overlay').addClass('card-content-overlay-active');

        if (type == 'hourly') {

          // get variables
          var facilityId = $('#facility-id').val();
          var startDate = $('#start-date').val();
          var startTime = $('#start-time').val();
          var endDate = $('#end-date').val();
          var endTime = $('#end-time').val();
          var offset = Number($('#offset').val());
          var promoCode = $('#promo-code').val();

          console.log('startDate:', startDate, 'startTime:', startTime);
          console.log('endDate:', endDate, 'endTime:', endTime);

          if (offset == 0) {

            var offsetISO8601 = '+00:00';

          } else {

            var offsetWIP = ((offset / 60) / 60) * 100;
            var offsetHours = offsetWIP.toString().slice(0, -2);
            var isNegative = offsetHours.indexOf('-');
            if (isNegative == 0) {
              if (offsetHours.length < 3) {
                offsetHours = offsetHours.substring(1);
                offsetHours = '-0' + offsetHours;
              }
            } else {
              if (offsetHours.length < 2) {
                offsetHours = '+0' + offsetHours;
              } else {
                offsetHours = '+' + offsetHours;
              }
            }
            var offsetMinutes = offsetWIP.toString().slice(-2);
            var offsetISO8601 = offsetHours + ':' + offsetMinutes;

          }

          offsetISO8601 = '+00:00';
          console.log('offsetISO8601:', offsetISO8601);

          // convert dates and times to unix epoch format
          var startDateTime = new Date(startDate + 'T' + startTime + offsetISO8601).getTime() / 1000;
          var endDateTime = new Date(endDate + 'T' + endTime + offsetISO8601).getTime() / 1000;
          var nowDateTime = GetUTCNow();

          console.log('startDateTime:', startDateTime);
          console.log('endDateTime:', endDateTime);
          console.log('nowDateTime:', nowDateTime);

          if (startDateTime < (nowDateTime - (60 * 40))) {

            // disable checkout on error
            $('#secure-payment-field').prop('disabled', true);
            $('#submit-gpi').css("display", "none")
            // hide loading animation
            $('#reservation-summary .card-content-overlay').removeClass('card-content-overlay-active');
            $('#reservation-summary .form-card-message').removeClass('form-card-message-success').addClass('form-card-message-error').text('Start date/time is in the past.');

          } else if (endDateTime < nowDateTime) {

            // disable checkout on error
            $('#secure-payment-field').prop('disabled', true);
            $('#submit-gpi').css("display", "none")
            // hide loading animation
            $('#reservation-summary .card-content-overlay').removeClass('card-content-overlay-active');
            $('#reservation-summary .form-card-message').removeClass('form-card-message-success').addClass('form-card-message-error').text('End date/time is in the past.');

          } else if (startDateTime >= endDateTime) {

            // startDateTime is greater than or equal to endDateTime
            var difference = startDateTime - endDateTime;
            // console.log(difference);
            // disable checkout on error
            $('#secure-payment-field').prop('disabled', true);
            $('#submit-gpi').css("display", "none")
            // hide loading animation
            $('#reservation-summary .card-content-overlay').removeClass('card-content-overlay-active');
            $('#reservation-summary .form-card-message').removeClass('form-card-message-success').addClass('form-card-message-error').text('End date/time is earlier than start date/time.');

          } else {

            $('#submit-gpi').css("display", "block")
            // endDateTime is greater than startDateTime, proceed!
            $('#reservation-summary .form-card-message').removeClass('form-card-message-error').empty();

            $.ajax({
              type: 'post',
              url: '/wp-admin/admin-ajax.php',
              data: {
                action: 'calculate_hourly_price',
                facilityId: facilityId,
                startDateTime: startDateTime,
                endDateTime: endDateTime,
                nowDateTime: nowDateTime,
                promoCode: promoCode
              },
              success: function (results) {
                var results = JSON.parse(results);
                console.log(results);
                if (results.status == 'success') {

                  // enable checkout (if disabled) on success
                  $('#secure-payment-field').prop('disabled', false);
                  // update hidden price field in pennies
                  $('#price').val(results['new_price']);
                  // update display price field in dollars
                  $('#display-price').text(results['new_display_price']);
                  $('#reservation-summary .form-card-message').removeClass('form-card-message-error').addClass('form-card-message-success').text(results.message);

                  console.log('TicketType:', results.body.ticket_items[0].type);

                  // add new startDateTime, endDateTime, and promoCode to the URL
                  var url = new URL(window.location);
                  url.searchParams.set('startTime', results.startDateTime);
                  url.searchParams.set('endTime', results.endDateTime);
                  url.searchParams.set('expectedPrice', results.new_price);
                  if (results.promoCode != '') {
                    url.searchParams.set('promoCode', results.promoCode);
                  }
                  history.pushState('', '', url);

                } else {

                  $('#reservation-summary .form-card-message').removeClass('form-card-message-success').addClass('form-card-message-error').text(results.message);
                  // disable checkout on error
                  $('#checkout-submit').prop('disabled', true);

                }
                // hide loading animation
                $('#reservation-summary .card-content-overlay').removeClass('card-content-overlay-active');
              },
              error: function (results) {
                var results = JSON.parse(results);
                console.log(results);
                // hide loading animation
                $('#reservation-summary .card-content-overlay').removeClass('card-content-overlay-active');
              }
            });

          }

        } else if (type == 'monthly' || type == 'coupon') {

          var facilityId = $('#facility-id').val();
          var promoCode = $('#promo-code').val();
          if (type == 'monthly') {
            var parkingType = 'monthly';
          } else if (type == 'coupon') {
            var parkingType = 'coupon';
          }

          $.ajax({
            type: 'post',
            url: '/wp-admin/admin-ajax.php',
            data: {
              action: 'calculate_product_price',
              facilityId: facilityId,
              parkingType: parkingType,
              promoCode: promoCode
            },
            success: function (results) {
              var results = JSON.parse(results);
              console.log(results);

              if (results.status == 'success') {

                // remove default options, replace with promo code product
                $('#reservation-summary .radio-buttons-group').empty().append(results.productTemplate);
                // update price to promo code price
                var displayPrice = results.productsArray[0].product_price;
                var stripePrice = displayPrice * 100;
                $('#display-price').text(displayPrice);
                $('#price').val(stripePrice);
                // remove loading overlay
                $('#reservation-summary .card-content-overlay').removeClass('card-content-overlay-active');
                $('#reservation-summary .form-card-message').removeClass('form-card-message-error').addClass('form-card-message-success').text(results.message);

                console.log('TicketType:', results.body.ticket_items[0].type);

                // add new startDateTime, endDateTime, and promoCode to the URL
                var url = new URL(window.location);
                if (results.promoCode != '') {
                  url.searchParams.set('promoCode', results.promoCode);
                }
                history.pushState('', '', url);

              } else {

                $('#reservation-summary .card-content-overlay').removeClass('card-content-overlay-active');
                $('#reservation-summary .form-card-message').removeClass('form-card-message-success').addClass('form-card-message-error').text(results.message);

              }

            },
            error: function (results) {
              var results = JSON.parse(results);
              console.log(results);
            }
          });

        }

      });

      if (type == 'hourly') {

        // if url is missing the `expectedPrice` parameter, run the ajax call to get a price
        if (expectedPrice == 0) {

          // show loading animation
          $('#reservation-summary .card-content-overlay').addClass('card-content-overlay-active');

          // get variables
          var facilityId = $('#facility-id').val();
          var startDate = $('#start-date').val();
          var startTime = $('#start-time').val();
          var endDate = $('#end-date').val();
          var endTime = $('#end-time').val();
          var offset = Number($('#offset').val());
          var promoCode = $('#promo-code').val();

          console.log('startDate:', startDate, 'startTime:', startTime);
          console.log('endDate:', endDate, 'endTime:', endTime);
          console.log('offset:', offset);

          if (offset == 0) {

            var offsetISO8601 = '+00:00';

          } else {

            var offsetWIP = ((offset / 60) / 60) * 100;
            var offsetHours = offsetWIP.toString().slice(0, -2);
            var isNegative = offsetHours.indexOf('-');
            if (isNegative == 0) {
              if (offsetHours.length < 3) {
                offsetHours = offsetHours.substring(1);
                offsetHours = '-0' + offsetHours;
              }
            } else {
              if (offsetHours.length < 2) {
                offsetHours = '+0' + offsetHours;
              } else {
                offsetHours = '+' + offsetHours;
              }
            }
            var offsetMinutes = offsetWIP.toString().slice(-2);
            var offsetISO8601 = offsetHours + ':' + offsetMinutes;

          }

          offsetISO8601 = '+00:00';
          console.log('offsetISO8601:', offsetISO8601);

          // convert dates and times to unix epoch format
          var startDateTime = new Date(startDate + 'T' + startTime + offsetISO8601).getTime() / 1000;
          var endDateTime = new Date(endDate + 'T' + endTime + offsetISO8601).getTime() / 1000;
          var nowDateTime = GetUTCNow();

          console.log('startDateTime:', startDateTime);
          console.log('endDateTime:', endDateTime);
          console.log('nowDateTime:', nowDateTime);

          if (startDateTime < (nowDateTime - (60 * 40))) {

            // disable checkout on error
            $('#secure-payment-field').prop('disabled', true);
            $('#submit-gpi').css("display", "none")
            // hide loading animation
            $('#reservation-summary .card-content-overlay').removeClass('card-content-overlay-active');
            $('#reservation-summary .form-card-message').removeClass('form-card-message-success').addClass('form-card-message-error').text('Start date/time is in the past.');

          } else if (endDateTime < nowDateTime) {

            // disable checkout on error
            $('#secure-payment-field').prop('disabled', true);
            $('#submit-gpi').css("display", "none")
            // hide loading animation
            $('#reservation-summary .card-content-overlay').removeClass('card-content-overlay-active');
            $('#reservation-summary .form-card-message').removeClass('form-card-message-success').addClass('form-card-message-error').text('End date/time is in the past.');

          } else if (startDateTime >= endDateTime) {

            // startDateTime is greater than or equal to endDateTime
            var difference = startDateTime - endDateTime;
            // console.log(difference);
            // disable checkout on error
            $('#secure-payment-field').prop('disabled', true);
            $('#submit-gpi').css("display", "none")
            // hide loading animation
            $('#reservation-summary .card-content-overlay').removeClass('card-content-overlay-active');
            $('#reservation-summary .form-card-message').removeClass('form-card-message-success').addClass('form-card-message-error').text('End date/time is earlier than start date/time.');

          } else {

            $('#submit-gpi').css("display", "block")
            // endDateTime is greater than startDateTime, proceed!
            $('#reservation-summary .form-card-message').removeClass('form-card-message-error').empty();

            $.ajax({
              type: 'post',
              url: '/wp-admin/admin-ajax.php',
              data: {
                action: 'calculate_hourly_price',
                facilityId: facilityId,
                startDateTime: startDateTime,
                endDateTime: endDateTime,
                nowDateTime: nowDateTime,
                promoCode: promoCode
              },
              success: function (results) {
                var results = JSON.parse(results);
                console.log(results);
                if (results.status == 'success') {

                  // enable checkout (if disabled) on success
                  $('#secure-payment-field').prop('disabled', false);
                  // update hidden price field in pennies
                  $('#price').val(results['new_price']);
                  // update display price field in dollars
                  $('#display-price').text(results['new_display_price']);
                  $('#reservation-summary .form-card-message').removeClass('form-card-message-error').addClass('form-card-message-success').text(results.message);

                  console.log('TicketType:', results.body.ticket_items[0].type);

                  // add new startDateTime, endDateTime, and promoCode to the URL
                  var url = new URL(window.location);
                  url.searchParams.set('startTime', results.startDateTime);
                  url.searchParams.set('endTime', results.endDateTime);
                  url.searchParams.set('expectedPrice', results.new_price);
                  if (results.promoCode != '') {
                    url.searchParams.set('promoCode', results.promoCode);
                  }
                  history.pushState('', '', url);

                } else {

                  $('#reservation-summary .form-card-message').removeClass('form-card-message-success').addClass('form-card-message-error').text(results.message);
                  // disable checkout on error
                  $('#secure-payment-field').prop('disabled', true);

                }
                // hide loading animation
                $('#reservation-summary .card-content-overlay').removeClass('card-content-overlay-active');
              },
              error: function (results) {
                var results = JSON.parse(results);
                console.log(results);
                // hide loading animation
                $('#reservation-summary .card-content-overlay').removeClass('card-content-overlay-active');
              }
            });

          }

        }

        // update price on date/time/promo change
        var recalculatePrice = debounce(function () {
          // show loading animation
          $('#reservation-summary .card-content-overlay').addClass('card-content-overlay-active');

          // get variables
          var facilityId = $('#facility-id').val();
          var startDate = $('#start-date').val();
          var startTime = $('#start-time').val();
          var endDate = $('#end-date').val();
          var endTime = $('#end-time').val();
          var offset = Number($('#offset').val());
          var promoCode = $('#promo-code').val();

          console.log('startDate:', startDate, 'startTime:', startTime);
          console.log('endDate:', endDate, 'endTime:', endTime);

          if (offset == 0) {

            var offsetISO8601 = '+00:00';

          } else {

            var offsetWIP = ((offset / 60) / 60) * 100;
            var offsetHours = offsetWIP.toString().slice(0, -2);
            var isNegative = offsetHours.indexOf('-');
            if (isNegative == 0) {
              if (offsetHours.length < 3) {
                offsetHours = offsetHours.substring(1);
                offsetHours = '-0' + offsetHours;
              }
            } else {
              if (offsetHours.length < 2) {
                offsetHours = '+0' + offsetHours;
              } else {
                offsetHours = '+' + offsetHours;
              }
            }
            var offsetMinutes = offsetWIP.toString().slice(-2);
            var offsetISO8601 = offsetHours + ':' + offsetMinutes;

          }

          offsetISO8601 = '+00:00';
          console.log('offsetISO8601:', offsetISO8601);

          // convert dates and times to unix epoch format
          var startDateTime = new Date(startDate + 'T' + startTime + offsetISO8601).getTime() / 1000;
          var endDateTime = new Date(endDate + 'T' + endTime + offsetISO8601).getTime() / 1000;
          var nowDateTime = GetUTCNow();

          console.log('startDateTime:', startDateTime);
          console.log('endDateTime:', endDateTime);
          console.log('nowDateTime:', nowDateTime);

          if (startDateTime < (nowDateTime - (60 * 40))) {

            // disable checkout on error
            $('#secure-payment-field').prop('disabled', true);
            $('#submit-gpi').css("display", "none")
            // hide loading animation
            $('#reservation-summary .card-content-overlay').removeClass('card-content-overlay-active');
            $('#reservation-summary .form-card-message').removeClass('form-card-message-success').addClass('form-card-message-error').text('Start date/time is in the past.');

          } else if (endDateTime < nowDateTime) {

            // disable checkout on error
            $('#secure-payment-field').prop('disabled', true);
            $('#submit-gpi').css("display", "none")
            // hide loading animation
            $('#reservation-summary .card-content-overlay').removeClass('card-content-overlay-active');
            $('#reservation-summary .form-card-message').removeClass('form-card-message-success').addClass('form-card-message-error').text('End date/time is in the past.');

          } else if (startDateTime >= endDateTime) {

            // startDateTime is greater than or equal to endDateTime
            var difference = startDateTime - endDateTime;
            // console.log(difference);
            // disable checkout on error
            $('#secure-payment-field').prop('disabled', true);
            $('#submit-gpi').css("display", "none")
            // hide loading animation
            $('#reservation-summary .card-content-overlay').removeClass('card-content-overlay-active');
            $('#reservation-summary .form-card-message').removeClass('form-card-message-success').addClass('form-card-message-error').text('End date/time is earlier than start date/time.');

          } else {

            $('#submit-gpi').css("display", "block")
            // endDateTime is greater than startDateTime, proceed!
            $('#reservation-summary .form-card-message').removeClass('form-card-message-error').empty();

            $.ajax({
              type: 'post',
              url: '/wp-admin/admin-ajax.php',
              data: {
                action: 'calculate_hourly_price',
                facilityId: facilityId,
                startDateTime: startDateTime,
                endDateTime: endDateTime,
                nowDateTime: nowDateTime,
                promoCode: promoCode
              },
              success: function (results) {
                var results = JSON.parse(results);
                console.log(results);
                if (results.status == 'success') {

                  // enable checkout (if disabled) on success
                  $('#secure-payment-field').prop('disabled', false);
                  // update hidden price field in pennies
                  $('#price').val(results['new_price']);
                  // update display price field in dollars
                  $('#display-price').text(results['new_display_price']);
                  $('#reservation-summary .form-card-message').removeClass('form-card-message-error').addClass('form-card-message-success').text(results.message);

                  console.log('TicketType:', results.body.ticket_items[0].type);

                  // add new startDateTime, endDateTime, and promoCode to the URL
                  var url = new URL(window.location);
                  url.searchParams.set('startTime', results.startDateTime);
                  url.searchParams.set('endTime', results.endDateTime);
                  url.searchParams.set('expectedPrice', results.new_price);
                  if (results.promoCode != '') {
                    url.searchParams.set('promoCode', results.promoCode);
                  }
                  history.pushState('', '', url);

                } else {

                  // disable checkout on error
                  $('#secure-payment-field').prop('disabled', true);
                  $('#reservation-summary .form-card-message').removeClass('form-card-message-success').addClass('form-card-message-error').text(results.message);

                }
                // hide loading animation
                $('#reservation-summary .card-content-overlay').removeClass('card-content-overlay-active');
              },
              error: function (results) {
                var results = JSON.parse(results);
                console.log(results);
                // hide loading animation
                $('#reservation-summary .card-content-overlay').removeClass('card-content-overlay-active');
              }
            });

          }

        }, 500);

        $('#start-date, #start-time, #end-date, #end-time, #promo-code').on('change', recalculatePrice);

      } else if (type == 'monthly') {

        if ($('input[name="monthly-options"]').length > 0) {

          calculateMonthlyPrice();

          var product = $('input[name="monthly-options"]:checked');
          var customQuestionsString = $(product).attr('data-custom-questions');
          var customQuestions = [];
          if (customQuestionsString.length) {
            var customQuestions = customQuestionsString.split(', ');
            $.each(customQuestions, function (index, question) {
              $('#' + question).show();
              if (question == 'why-purchase-monthly') {
                var value = $('input[name="why-purchase-monthly"]:checked').attr('id');
                if (value == 'work-in-building') {
                  $('#why-purchase-monthly-employer').show();
                  $('#employer').removeClass('ignore');
                } else if (value == 'live-in-building') {
                  $('#why-purchase-monthly-unit-number').show();
                  $('#unit-number').removeClass('ignore');
                }
              }
            });

            $('input[name="why-purchase-monthly"]').change(function () {
              $('#why-purchase-monthly-employer, #why-purchase-monthly-unit-number').hide();
              $('#employer, #unit-number').addClass('ignore');
              var value = $(this).attr('id');
              if (value == 'work-in-building') {
                $('#why-purchase-monthly-employer').show();
                $('#employer').removeClass('ignore');
              } else if (value == 'live-in-building') {
                $('#why-purchase-monthly-unit-number').show();
                $('#unit-number').removeClass('ignore');
              }
            });

          }

          $('.radio-buttons-group').on('change', 'input[name="monthly-options"]', function () {

            calculateMonthlyPrice();

            $('#why-purchase-monthly, #why-purchase-monthly-employer, #why-purchase-monthly-unit-number').hide();
            $('#employer, #unit-number').addClass('ignore');

            var product = $(this);
            var customQuestionsString = $(product).attr('data-custom-questions');
            var customQuestions = [];
            if (customQuestionsString.length) {
              var customQuestions = customQuestionsString.split(', ');
              $.each(customQuestions, function (index, question) {
                $('#' + question).show();
                if (question == 'why-purchase-monthly') {
                  var value = $('input[name="why-purchase-monthly"]:checked').attr('id');
                  if (value == 'work-in-building') {
                    $('#why-purchase-monthly-employer').show();
                    $('#employer').removeClass('ignore');
                  } else if (value == 'live-in-building') {
                    $('#why-purchase-monthly-unit-number').show();
                    $('#unit-number').removeClass('ignore');
                  }
                }
              });
            }

          });

          // recalculate on quantity change
          $('#quantity').change(function () {
            calculateMonthlyPrice();
          });

        }

      } else if (type == 'coupon') {

        if ($('input[name="coupon-options"]').length > 0) {

          calculateCouponPrice();

          var product = $('input[name="coupon-options"]:checked');
          var customQuestionsString = $(product).attr('data-custom-questions');
          var customQuestions = [];
          if (customQuestionsString.length) {
            var customQuestions = customQuestionsString.split(', ');
            $.each(customQuestions, function (index, question) {
              $('#' + question).show();
              if (question == 'why-purchase-coupons') {
                var value = $('input[name="why-purchase-coupons"]:checked').attr('id');
                if (value == 'live-in-building') {
                  $('#why-purchase-coupons-unit-number').show();
                  $('#unit-number').removeClass('ignore');
                }
              }
            });

            $('input[name="why-purchase-coupons"]').change(function () {
              $('#why-purchase-coupons-unit-number').hide();
              $('#unit-number').addClass('ignore');
              var value = $(this).attr('id');
              if (value == 'live-in-building') {
                $('#why-purchase-coupons-unit-number').show();
                $('#unit-number').removeClass('ignore');
              }
            });

          }

          $('.radio-buttons-group').on('change', 'input[name="coupon-options"]', function () {

            calculateCouponPrice();

            $('#why-purchase-coupons, #why-purchase-coupons-unit-number').hide();
            $('#unit-number').addClass('ignore');

            var product = $(this);
            var customQuestionsString = $(product).attr('data-custom-questions');
            var customQuestions = [];
            if (customQuestionsString.length) {
              var customQuestions = customQuestionsString.split(', ');
              $.each(customQuestions, function (index, question) {
                $('#' + question).show();
                if (question == 'why-purchase-coupons') {
                  var value = $('input[name="why-purchase-coupons"]:checked').attr('id');
                  if (value == 'live-in-building') {
                    $('#why-purchase-coupons-unit-number').show();
                    $('#unit-number').removeClass('ignore');
                  }
                }
              });
            }

          });

          // recalculate on quantity change
          $('#quantity').change(function () {
            calculateCouponPrice();
          });

        }

      }

      if (type == 'monthly' || type == 'coupon') {

        if (promoCode) {

          // show loading animation
          $('#reservation-summary .card-content-overlay').addClass('card-content-overlay-active');

          var facilityId = $('#facility-id').val();
          var promoCode = $('#promo-code').val();
          if (type == 'monthly') {
            var parkingType = 'monthly';
          } else if (type == 'coupon') {
            var parkingType = 'coupon';
          }

          $.ajax({
            type: 'post',
            url: '/wp-admin/admin-ajax.php',
            data: {
              action: 'calculate_product_price',
              facilityId: facilityId,
              parkingType: parkingType,
              promoCode: promoCode
            },
            success: function (results) {
              var results = JSON.parse(results);
              console.log(results);

              if (results.status == 'success') {

                // remove default options, replace with promo code product
                $('#reservation-summary .radio-buttons-group').empty().append(results.productTemplate);
                // update price to promo code price
                var displayPrice = results.productsArray[0].product_price;
                var stripePrice = displayPrice * 100;
                $('#display-price').text(displayPrice);
                $('#price').val(stripePrice);
                // remove loading overlay
                $('#reservation-summary .card-content-overlay').removeClass('card-content-overlay-active');
                $('#reservation-summary .form-card-message').removeClass('form-card-message-error').addClass('form-card-message-success').text(results.message);

                // add new startDateTime, endDateTime, and promoCode to the URL
                var url = new URL(window.location);
                if (results.promoCode != '') {
                  url.searchParams.set('promoCode', results.promoCode);
                }
                history.pushState('', '', url);

                if (type == 'monthly') {

                  calculateMonthlyPrice();

                  var product = $('input[name="monthly-options"]:checked');
                  var customQuestionsString = $(product).attr('data-custom-questions');
                  var customQuestions = [];
                  if (customQuestionsString.length) {
                    var customQuestions = customQuestionsString.split(', ');
                    $.each(customQuestions, function (index, question) {
                      $('#' + question).show();
                      if (question == 'why-purchase-monthly') {
                        var value = $('input[name="why-purchase-monthly"]:checked').attr('id');
                        if (value == 'work-in-building') {
                          $('#why-purchase-monthly-employer').show();
                          $('#employer').removeClass('ignore');
                        } else if (value == 'live-in-building') {
                          $('#why-purchase-monthly-unit-number').show();
                          $('#unit-number').removeClass('ignore');
                        }
                      }
                    });

                    $('input[name="why-purchase-monthly"]').change(function () {
                      $('#why-purchase-monthly-employer, #why-purchase-monthly-unit-number').hide();
                      $('#employer, #unit-number').addClass('ignore');
                      var value = $(this).attr('id');
                      if (value == 'work-in-building') {
                        $('#why-purchase-monthly-employer').show();
                        $('#employer').removeClass('ignore');
                      } else if (value == 'live-in-building') {
                        $('#why-purchase-monthly-unit-number').show();
                        $('#unit-number').removeClass('ignore');
                      }
                    });

                  }

                  $('.radio-buttons-group').on('change', 'input[name="monthly-options"]', function () {

                    calculateMonthlyPrice();

                    $('#why-purchase-monthly, #why-purchase-monthly-employer, #why-purchase-monthly-unit-number').hide();
                    $('#employer, #unit-number').addClass('ignore');

                    var product = $(this);
                    var customQuestionsString = $(product).attr('data-custom-questions');
                    var customQuestions = [];
                    if (customQuestionsString.length) {
                      var customQuestions = customQuestionsString.split(', ');
                      $.each(customQuestions, function (index, question) {
                        $('#' + question).show();
                        if (question == 'why-purchase-monthly') {
                          var value = $('input[name="why-purchase-monthly"]:checked').attr('id');
                          if (value == 'work-in-building') {
                            $('#why-purchase-monthly-employer').show();
                            $('#employer').removeClass('ignore');
                          } else if (value == 'live-in-building') {
                            $('#why-purchase-monthly-unit-number').show();
                            $('#unit-number').removeClass('ignore');
                          }
                        }
                      });
                    }

                  });

                  // recalculate on quantity change
                  $('#quantity').change(function () {
                    calculateMonthlyPrice();
                  });

                } else if (type == 'coupon') {

                  calculateCouponPrice();

                  var product = $('input[name="coupon-options"]:checked');
                  var customQuestionsString = $(product).attr('data-custom-questions');
                  var customQuestions = [];
                  if (customQuestionsString.length) {
                    var customQuestions = customQuestionsString.split(', ');
                    $.each(customQuestions, function (index, question) {
                      $('#' + question).show();
                      if (question == 'why-purchase-coupons') {
                        var value = $('input[name="why-purchase-coupons"]:checked').attr('id');
                        if (value == 'live-in-building') {
                          $('#why-purchase-coupons-unit-number').show();
                          $('#unit-number').removeClass('ignore');
                        }
                      }
                    });

                    $('input[name="why-purchase-coupons"]').change(function () {
                      $('#why-purchase-coupons-unit-number').hide();
                      $('#unit-number').addClass('ignore');
                      var value = $(this).attr('id');
                      if (value == 'live-in-building') {
                        $('#why-purchase-coupons-unit-number').show();
                        $('#unit-number').removeClass('ignore');
                      }
                    });

                  }

                  $('.radio-buttons-group').on('change', 'input[name="coupon-options"]', function () {

                    calculateCouponPrice();

                    $('#why-purchase-coupons, #why-purchase-coupons-unit-number').hide();
                    $('#unit-number').addClass('ignore');

                    var product = $(this);
                    var customQuestionsString = $(product).attr('data-custom-questions');
                    var customQuestions = [];
                    if (customQuestionsString.length) {
                      var customQuestions = customQuestionsString.split(', ');
                      $.each(customQuestions, function (index, question) {
                        $('#' + question).show();
                        if (question == 'why-purchase-coupons') {
                          var value = $('input[name="why-purchase-coupons"]:checked').attr('id');
                          if (value == 'live-in-building') {
                            $('#why-purchase-coupons-unit-number').show();
                            $('#unit-number').removeClass('ignore');
                          }
                        }
                      });
                    }

                  });

                  // recalculate on quantity change
                  $('#quantity').change(function () {
                    calculateCouponPrice();
                  });

                }

              } else {

                launchAlert('Error', results.message);

                // remove loading overlay
                $('#reservation-summary .card-content-overlay').removeClass('card-content-overlay-active');
                $('#reservation-summary .form-card-message').removeClass('form-card-message-success').addClass('form-card-message-error').text(results.message);

              }

            },
            error: function (results) {
              var results = JSON.parse(results);
              console.log(results);
            }
          });

        }

        var recalculatePrice = debounce(function () {

          // show loading animation
          $('#reservation-summary .card-content-overlay').addClass('card-content-overlay-active');

          var facilityId = $('#facility-id').val();
          var promoCode = $('#promo-code').val();
          if (type == 'monthly') {
            var parkingType = 'monthly';
          } else if (type == 'coupon') {
            var parkingType = 'coupon';
          }

          $.ajax({
            type: 'post',
            url: '/wp-admin/admin-ajax.php',
            data: {
              action: 'calculate_product_price',
              facilityId: facilityId,
              parkingType: parkingType,
              promoCode: promoCode
            },
            success: function (results) {
              var results = JSON.parse(results);
              console.log(results);

              if (results.status == 'success') {

                // remove default options, replace with promo code product
                $('#reservation-summary .radio-buttons-group').empty().append(results.productTemplate);
                // update price to promo code price
                var displayPrice = results.productsArray[0].product_price;
                var stripePrice = displayPrice * 100;
                $('#display-price').text(displayPrice);
                $('#price').val(stripePrice);
                // remove loading overlay
                $('#reservation-summary .card-content-overlay').removeClass('card-content-overlay-active');
                $('#reservation-summary .form-card-message').removeClass('form-card-message-error').addClass('form-card-message-success').text(results.message);

                // console.log('TicketType:', results.body.ticket_items[0].type);

                // add new startDateTime, endDateTime, and promoCode to the URL
                var url = new URL(window.location);
                if (results.promoCode != '') {
                  url.searchParams.set('promoCode', results.promoCode);
                }
                history.pushState('', '', url);

                if (type == 'monthly') {

                  calculateMonthlyPrice();

                  var product = $('input[name="monthly-options"]:checked');
                  var customQuestionsString = $(product).attr('data-custom-questions');
                  var customQuestions = [];
                  if (customQuestionsString.length) {
                    var customQuestions = customQuestionsString.split(', ');
                    $.each(customQuestions, function (index, question) {
                      $('#' + question).show();
                      if (question == 'why-purchase-monthly') {
                        var value = $('input[name="why-purchase-monthly"]:checked').attr('id');
                        if (value == 'work-in-building') {
                          $('#why-purchase-monthly-employer').show();
                          $('#employer').removeClass('ignore');
                        } else if (value == 'live-in-building') {
                          $('#why-purchase-monthly-unit-number').show();
                          $('#unit-number').removeClass('ignore');
                        }
                      }
                    });

                    $('input[name="why-purchase-monthly"]').change(function () {
                      $('#why-purchase-monthly-employer, #why-purchase-monthly-unit-number').hide();
                      $('#employer, #unit-number').addClass('ignore');
                      var value = $(this).attr('id');
                      if (value == 'work-in-building') {
                        $('#why-purchase-monthly-employer').show();
                        $('#employer').removeClass('ignore');
                      } else if (value == 'live-in-building') {
                        $('#why-purchase-monthly-unit-number').show();
                        $('#unit-number').removeClass('ignore');
                      }
                    });

                  }

                  $('.radio-buttons-group').on('change', 'input[name="monthly-options"]', function () {

                    calculateMonthlyPrice();

                    $('#why-purchase-monthly, #why-purchase-monthly-employer, #why-purchase-monthly-unit-number').hide();
                    $('#employer, #unit-number').addClass('ignore');

                    var product = $(this);
                    var customQuestionsString = $(product).attr('data-custom-questions');
                    var customQuestions = [];
                    if (customQuestionsString.length) {
                      var customQuestions = customQuestionsString.split(', ');
                      $.each(customQuestions, function (index, question) {
                        $('#' + question).show();
                        if (question == 'why-purchase-monthly') {
                          var value = $('input[name="why-purchase-monthly"]:checked').attr('id');
                          if (value == 'work-in-building') {
                            $('#why-purchase-monthly-employer').show();
                            $('#employer').removeClass('ignore');
                          } else if (value == 'live-in-building') {
                            $('#why-purchase-monthly-unit-number').show();
                            $('#unit-number').removeClass('ignore');
                          }
                        }
                      });
                    }

                  });

                  // recalculate on quantity change
                  $('#quantity').change(function () {
                    calculateMonthlyPrice();
                  });

                } else if (type == 'coupon') {

                  calculateCouponPrice();

                  var product = $('input[name="coupon-options"]:checked');
                  var customQuestionsString = $(product).attr('data-custom-questions');
                  var customQuestions = [];
                  if (customQuestionsString.length) {
                    var customQuestions = customQuestionsString.split(', ');
                    $.each(customQuestions, function (index, question) {
                      $('#' + question).show();
                      if (question == 'why-purchase-coupons') {
                        var value = $('input[name="why-purchase-coupons"]:checked').attr('id');
                        if (value == 'live-in-building') {
                          $('#why-purchase-coupons-unit-number').show();
                          $('#unit-number').removeClass('ignore');
                        }
                      }
                    });

                    $('input[name="why-purchase-coupons"]').change(function () {
                      $('#why-purchase-coupons-unit-number').hide();
                      $('#unit-number').addClass('ignore');
                      var value = $(this).attr('id');
                      if (value == 'live-in-building') {
                        $('#why-purchase-coupons-unit-number').show();
                        $('#unit-number').removeClass('ignore');
                      }
                    });

                  }

                  $('.radio-buttons-group').on('change', 'input[name="coupon-options"]', function () {

                    calculateCouponPrice();

                    $('#why-purchase-coupons, #why-purchase-coupons-unit-number').hide();
                    $('#unit-number').addClass('ignore');

                    var product = $(this);
                    var customQuestionsString = $(product).attr('data-custom-questions');
                    var customQuestions = [];
                    if (customQuestionsString.length) {
                      var customQuestions = customQuestionsString.split(', ');
                      $.each(customQuestions, function (index, question) {
                        $('#' + question).show();
                        if (question == 'why-purchase-coupons') {
                          var value = $('input[name="why-purchase-coupons"]:checked').attr('id');
                          if (value == 'live-in-building') {
                            $('#why-purchase-coupons-unit-number').show();
                            $('#unit-number').removeClass('ignore');
                          }
                        }
                      });
                    }

                  });

                  // recalculate on quantity change
                  $('#quantity').change(function () {
                    calculateCouponPrice();
                  });

                }

              } else {

                launchAlert('Error', results.message);

                // remove loading overlay
                $('#reservation-summary .card-content-overlay').removeClass('card-content-overlay-active');
                $('#reservation-summary .form-card-message').removeClass('form-card-message-success').addClass('form-card-message-error').text(results.message);

              }

            },
            error: function (results) {
              var results = JSON.parse(results);
              console.log(results);
            }
          });

        });

        $('#promo-code').on('change', recalculatePrice);

      }
    }
  }

  if ($('body').hasClass('page-template-page-account-receipt')) {

    // generate barcode image from string
    if ($('.receipt-barcode').length > 0) {
      $('.receipt-barcode').each(function () {
        var thisBarcode = $(this);
        var thisBarcodeString = $(thisBarcode).attr('data-barcode-string');
        var thisBarcodeSize = $(thisBarcode).attr('data-barcode-size');
        var thisQRCode = new QRCode(this, {
          text: thisBarcodeString,
          width: thisBarcodeSize,
          height: thisBarcodeSize,
          colorDark: '#000000',
          colorLight: '#FFFFFF',
          correctLevel: QRCode.CorrectLevel.H
        });
      });
    }

    if ($('#map').length > 0) {
      var map = $('#map');
      var latitude = map.attr('data-latitude');
      var longitude = map.attr('data-longitude');
      simpleMap(latitude, longitude, 'map');
    }

    facilityPhotos();
  }

  // show/hide frequently asked questions
  $('.faqs-group').each(function () {
    $('.faq-question').click(function () {
      $(this).parents('.faq').toggleClass('faq-active');
    });
  });

  if ($('body').hasClass('page-template-page-support')) {

    // show/hide form fields based on topic selection
    $('#topic').change(function () {
      var topic = $(this).val();
      console.log(topic);
      $('.form-field-optional').hide();
      $('.form-field-' + topic).show();
    });

    // show/hide app and browser options based on device selection
    $('#device').change(function () {
      var device = $(this).val();
      var target = $('#browser');
      $('optgroup, option', target).show();
      if (device == 'Android Phone' || device == 'iPhone' || device == 'Android Tablet' || device == 'iPad') {
        $('option[value="Edge"], option[value="Internet Explorer"]', target).hide();
        if (device == 'Android Phone' || device == 'Android Tablet') {
          $('option[value="ParkChirp iOS App"], option[value="Safari"]', target).hide();
        } else if (device == 'iPhone' || device == 'iPad') {
          $('option[value="ParkChirp Android App"]', target).hide();
        }
      } else if (device == 'Google Chromebook' || device == 'Macintosh Laptop or Desktop' || device == 'Windows Laptop or Desktop') {
        $('optgroup[label="Apps"]', target).hide();
        if (device == 'Google Chromebook') {
          $('option[value="Edge"], option[value="Firefox"], option[value="Internet Explorer"], option[value="Safari"], option[value="Other"]', target).hide();
        } else if (device == 'Macintosh Laptop or Desktop') {
          $('option[value="Edge"], option[value="Internet Explorer"]', target).hide();
        } else if (device == 'Windows Laptop or Desktop') {
          $('option[value="Safari"]', target).hide();
        }
      }
    });
  }

  /*** date and time picker helpers ***/
  if ($('#start-date').length && $('#start-time').length && $('#end-date').length && $('#end-time').length) {

    $('#start-date').on('change', function () {
      var startDate = $('#start-date').val();
      var startTime = $('#start-time').val();
      var endDate = $('#end-date').val();
      var endTime = $('#end-time').val();
      if (startDate > endDate) {
        $('#end-date').val(startDate);
        console.log('changed #end-date to match #start-date');
      }
    });

    // todo: #start-time helper

    $('#end-date').on('change', function () {
      var startDate = $('#start-date').val();
      var startTime = $('#start-time').val();
      var endDate = $('#end-date').val();
      var endTime = $('#end-time').val();
      if (endDate < startDate) {
        $('#start-date').val(endDate);
        console.log('changed #start-date to match #end-date');
      }
    });

    // todo: #end-time helper

  }

  /*** truncated list functionality ***/
  if ($('.truncated-list').length) {
    $('.truncated-list').each(function () {
      var thisList = $(this);
      $('.truncated-list-trigger', thisList).click(function () {
        thisList.toggleClass('truncated-list-expanded');
      });
    });
  }

  /*** transaction history pagination ***/

  if ($('body').hasClass('page-template-page-account-history-php')) {

    var config = {
      debug: {
        enable: true
      },
      load: {
        sort: 'date:desc'
      },
      animation: {
        effects: 'fade scale',
        duration: 500,
        easing: 'ease-in-out'
      },
      classNames: {
        block: 'toolbar',
        elementFilter: 'button',
        elementSort: 'button'
      },
      selectors: {
        pageList: '.transactions-page-list',
        pageStats: '.transactions-page-stats',
        target: '.transaction'
      },
      callbacks: {
        onMixEnd: function (state) {
          var errorField = $('.transactions-error');
          if (state.hasFailed) {
            errorField.show();
          } else {
            errorField.hide();
          }
        }
      },
      multifilter: {
        enable: true,
        logicBetweenGroups: 'and',
        logicWithinGroup: 'or'
      },
      pagination: {
        limit: 25
      }
    };
    var container = $('.transactions-group ol');
    if (container.length > 0) {
      var mixer = mixitup(container, config);
      console.log(mixer)

      $('#transactions-sort').change(function () {
        mixer.sort(this.value);
      });

      // show/hide transactions filters
      $('#filter-transactions-trigger').click(function (e) {
        e.preventDefault();
        $('.transactions-filters').toggleClass('transactions-filters-active');
      });
    }
  }

  /*** update license plate functionality ***/

  $('#open-license-form').on('click', function () {
    $('#update-license-section').show();
    $('#open-license-form').hide();
  });

  $('input[name=\'license-plates\']').change(function () {
    let input = $('#license-plate-container');
    this.id === 'new-license-plate-checkbox' ? input.show() : input.hide();
  });

  $('#update-license').validate({
    errorElement: 'span',
    errorClass: 'form-field-error',
    validClass: 'form-field-valid',
    errorPlacement: function (error, element) {
      error.appendTo(element.parents('.form-field'));
    },
    highlight: function (element, errorClass, validClass) {
      $(element).parents('.form-field').addClass(errorClass).removeClass(validClass);
    },
    unhighlight: function (element, errorClass, validClass) {
      $(element).parents('.form-field').removeClass(errorClass).addClass(validClass);
    },
    ignore: '.ignore',
    rules: {
      'license-plates': {
        required: true
      },
      'new-license-plate': {
        required: {
          depends: function (element) {
            return $('#new-license-plate-checkbox').is(':checked');
          }
        }
      }
    },
    messages: {
      'license-plates': {
        required: 'Please choose a license plate.'
      },
      'new-license-plate': {
        required: 'Please enter a license plate.'
      }
    },
    submitHandler: function (form) {
      let selectedCheckbox = $('input[name="license-plates"]:checked')[0];
      var licensePlate, saveNewLicense = false;
      if (selectedCheckbox.id === 'new-license-plate-checkbox') {
        saveNewLicense = true;
        licensePlate = $('#license-plate-container > input').val().trim();
      } else {
        licensePlate = $('input[name="license-plates"]:checked').val().trim();
      }
      var transactionId = $(form).attr('data-transaction-id');
      var facilityId = $(form).attr('data-facility-id');
      $('.button-spinner').prop('disabled', true);

      $.ajax({
        type: 'post',
        url: '/wp-admin/admin-ajax.php',
        data: {
          action: 'aws_cognito_chirp_update_license_plate',
          transaction_id: transactionId,
          facility_id: facilityId,
          license_plate: licensePlate,
          save_new_license: saveNewLicense
        },
        success: function (results) {
          var results = JSON.parse(results);
          console.log(results);
          $('.button-spinner').prop('disabled', false);
          if (results.status == 'success') {
            $('#license-plate-message').addClass('form-card-message-success').text(`License plate changed to ${results.message}`);
            $('#license-plate-display').text(results.message);
            $('#update-license-section').css("display", "none");
          } else {
            $('#license-plate-message').addClass('form-card-message-error').text(results.message);
          }
        },
        error: function (results) {
          // var results = JSON.parse(results);
          console.log(results);
          $('.button-spinner').prop('disabled', false);
          $('#license-plate-message').addClass('form-card-message-error').text(results.message);
        }
      });
    }
  });

  /*** monthly :: credentials ***/
  var graphQLToken = $('#token').attr('value');
  var graphQLAuth = 'Bearer ' + graphQLToken;
  var graphQLv2Auth = 'Bearer ' + graphQLToken;
  var graphQLNonce = $('#chirp-monthly-nonce').val();
  var graphQLHeaders = {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    'Authorization': 'Bearer ' + graphQLToken,
    'Access-Control-Allow-Origin': '*'
  };

  var lineItemEntryTypeMap = {
    'PAYMENT': 'Payment',
    'CHARGE': 'Charge',
    'REFUND': 'Refund',
    'POSITIVE_ADJUSTMENT': 'Positive Adjustment',
    'REVERSAL': 'Reversal',
    'ADJUSTMENT': 'Adjustment',
    'LANDLORD_COLLECTED': 'Landlord Collected',
    'WRITE_OFF': 'Write Off',
    'TERMINATION_ADJUSTMENT_NEGATIVE': 'Term adj - Negative',
    'TERMINATION_ADJUSTMENT_POSITIVE': 'Term adj - Positive',
  }

  var accessDeviceTypeMap = {
    'Barcode': 'BARCODE',
    'Proximity Card': 'PROXIMITY_CARD',
    'Tenant Access Card': 'TENANT_ACCESS_CARD',
    "AVI Transponder": 'AVI_TRANSPONDER',
    "Windshield Sticker": 'WINDSHIELD_STICKER',
    'License Plate Recognition': 'LICENSE_PLATE_RECOGNITION',
    'Flash Parking App': 'FLASH_PARKING_APP',
    'Hang Tag': 'HANG_TAG'
  }

  const createTerminationDate = (isThirtyDayNotice = false) => {
    const terminationDay = Number($('#subscription option:selected').attr('data-termination-day'));
    const today = moment();
    // create moment object for the termination date
    let terminationDate = moment().date(terminationDay);
    if (today.format('D') > terminationDay) {
      terminationDate = terminationDate.add(1, 'months');
    }
    // the last day to park is the last day of the month of the terminationDate
    let lastDayToPark = terminationDate.endOf('month');
    if (isThirtyDayNotice) {
      lastDayToPark = moment();
      lastDayToPark = lastDayToPark.add(1, 'months');
      // see PCA-3218 for this edge case, has to do with prorating a parker's auto invoice when they terminate
      const isJanuaryThirtyFirst = today.month() === 0 && moment().date() === 31;
      const isFebruaryFirst = today.month() === 1 && moment().date() === 1;
      if (isJanuaryThirtyFirst || isFebruaryFirst) {
        // February
        lastDayToPark.set('month', 1);
        // whatever the last day of February is, leap year or not
        lastDayToPark.set('date', lastDayToPark.daysInMonth());
      }
    }

    return lastDayToPark.format('YYYY-MM-DD');
  }
  const getTerminationDate = (parker = null, isThirtyDayNotice = false) => {
    let lastDayToPark = moment(createTerminationDate(isThirtyDayNotice));
    if (parker && parker.parker_status_history) {
      parker.parker_status_history.forEach((item) => {
        if (item.action === "TERMINATE") {
          lastDayToPark = moment(item.start_date);
        }
      });
    }
    return lastDayToPark.format("MMMM D, YYYY");
  }
  const getTerminationProrationPercentage = (terminationRule, terminationDay) => {
    let lastDayToPark = moment($('#parker-termination-date-picker').val(), 'YYYY-MM-DD');

    // assume the termination rule for the subscription is daily if it's not half month
    let percentage = lastDayToPark.date() / lastDayToPark.daysInMonth();
    if (terminationRule === 'HALF_MONTH') {
      // 50% discount if on or before the termination notice day, otherwise no proration
      percentage = lastDayToPark.date() <= terminationDay ? 0.5 : 1;
    }

    const percentageToTwoDecimalPlaces = Math.floor((percentage) * 10000) / 100;
    return percentageToTwoDecimalPlaces;
  }
  const getTerminationMonthAndYear = (isThirtyDayNotice) => {
    return moment(createTerminationDate(isThirtyDayNotice)).format("MMMM YYYY");
  }

  const oldGetParkerStatusText = (parker) => {
    if (parker.suspension_status == "SUSPENDED") {
      return "Suspended";
    }
    else if (parker.suspension_status == "TERMINATED" || parker.termination_status == "TERMINATED") {
      return "Terminated"
    }
    else if (parker.suspension_status == "PENDING" || parker.termination_status == "PENDING") {
      return "Pending"
    }
    else if (parker.suspension_status == "ACTIVE" || parker.termination_status == "ACTIVE" || parker.suspension_status == "SUSPENSION_PENDING" || parker.termination_status == "TERMINATION_PENDING") {
      return "Active";
    }
    return "";
  }
  const getParkerStatusText = (parker) => {
    if (!feature_flags.FEATURE_MYACCOUNT) {
      return oldGetParkerStatusText(parker);
    }

    if (parker.suspension_status == "SUSPENDED") {
      return "Suspended";
    }
    else if (parker.suspension_status == "TERMINATED" || parker.termination_status == "TERMINATED") {
      return "Terminated"
    }
    else if (parker.suspension_status == "PENDING" || parker.termination_status == "PENDING") {
      return "Pending"
    }
    else if (feature_flags.FEATURE_MYACCOUNT && parker.termination_status == "TERMINATION_PENDING") {
      return "Active: Parker will terminate on " + getTerminationDate(parker);
    }
    else if (parker.suspension_status == "ACTIVE" || parker.termination_status == "ACTIVE" || parker.suspension_status == "SUSPENSION_PENDING") {
      return "Active";
    }
    return "";
  }

  function displayNewCardForm(useSlidePay) {
    if (useSlidePay) {
      $('#gpi-card-form-container').hide();
      $('#slidepay-card-form-container')
        .show()
        .children()
        .show();
    } else {
      $('#slidepay-card-form-container').hide();
      $('#gpi-card-form-container')
        .show()
        .children()
        .show();

      updateGpiCardFormHeight();
    }
  }

  function makePayment(invoiceId, paymentSource, paymentType) {
    var invoiceId = invoiceId;
    var price = price;
    var paymentSource = paymentSource;

    const paymentMethod = paymentType === 'bank-account' ? 'ach' : paymentType === 'credit-card' ? 'card' : 'invalidType';

    $.ajax({
      type: 'post',
      url: '/wp-admin/admin-ajax.php',
      data: {
        action: 'chirp_graphql',
        api_version: 'v2',
        authorization: graphQLv2Auth,
        nonce: graphQLNonce,
        graphql_request: "mutation payInvoice($invoiceId: String!, $paymentToken: String!, $paymentMethod: String!) { payInvoice(invoiceId: $invoiceId, paymentToken: $paymentToken, paymentMethod: $paymentMethod) }",
        graphql_variables: JSON.stringify({
          invoiceId,
          paymentToken: paymentSource,
          paymentMethod,
        })
      },
      success: function (results) {
        const response = JSON.parse(results);
        console.log('success!', results);
        if (response.errors) {
          $('.button-spinner').prop('disabled', false);
          let errorText = response.errors[0].message ? response.errors[0].message : errorMessage;

          if (response.errors[0].message && response.errors[0].message.includes('Variable "$paymentMethod" of required type "String!" was not provided')) {
            errorText = "Please select a payment method before submitting"
          } else if (
            response?.errors?.[0]?.message?.includes('earliest payment application date') ||
            response?.errors?.[0]?.message?.includes('latest payment application date')
          ) {
            errorText = response.errors[0].message
          } else {
            errorText = errorMessage;
          }
          $('.form-card-message').empty().removeClass('form-card-message-success').addClass('form-card-message-error').text(errorText);
        } else {
          $('.form-card-message').empty().removeClass('form-card-message-error').addClass('form-card-message-success').text('Your payment was successful!');
          setTimeout(function () {
            window.location.href = '/account/monthly/activity/?invoice=' + invoiceId;
          }, 1000);
        }
      },
      error: function (results) {
        console.log('error!', results);
        $('.button-spinner').prop('disabled', false);
        $('.form-card-message').empty().removeClass('form-card-message-success').addClass('form-card-message-error').text(errorMessage);
      }
    });
  }

  /*** monthly :: subscription terms and conditions */
  if ($('body').hasClass('page-template-page-account-monthly-terms')) {
    var subscription_id = getUrlParameter('subscription');
    if (subscription_id) {
      console.log('subscription_id', subscription_id);
      $.ajax({
        type: 'post',
        url: '/wp-admin/admin-ajax.php',
        data: {
          action: 'chirp_graphql',
          authorization: graphQLAuth,
          nonce: graphQLNonce,
          graphql_request: "query getSubscription($subscription_id: String!) { getSubscription(subscription_id: $subscription_id) { id, billing_profile { id, facility { id, facility_name, terms_and_conditions } } } }",
          graphql_variables: JSON.stringify({
            "subscription_id": subscription_id
          })
        },
        success: function (results) {
          let { data, errors } = JSON.parse(results);
          console.log('success!', data);
          if (data.getSubscription.billing_profile.facility.terms_and_conditions) {
            var terms = data.getSubscription.billing_profile.facility.terms_and_conditions;
            var terms_formatted = terms.replace(/(?:\r\n|\r|\n)/g, '<br />');
            $('.card-content').append(terms_formatted);
            $('.facility-name').empty().text(data.getSubscription.billing_profile.facility.facility_name);
          }
          // remove loading overlay
          $('.card-content-overlay').removeClass('card-content-overlay-active');
        },
        error: function (results) {
          console.log(results);
          // remove loading overlay
          $('.card-content-overlay').removeClass('card-content-overlay-active');
        }
      });
    }
  }

  /*** monthly :: subscriptions index ***/
  if ($('body').hasClass('page-template-page-account-monthly')) {

    const paymentProviderId = !/platinum|icon/.test(window.location.host) ? 1 : 2;

    $.ajax({
      type: 'post',
      url: '/wp-admin/admin-ajax.php',
      data: {
        action: 'chirp_graphql',
        authorization: graphQLAuth,
        nonce: graphQLNonce,
        graphql_request: "query listUserSubscriptions($paymentProviderId: Int) { listUserSubscriptions(paymentProviderId: $paymentProviderId) { id, account_id, subscription_name, billing_profile { id, validation_only, facility { id, facility_name, address, timezone, terms_and_conditions } } } }",
        graphql_variables: JSON.stringify({ paymentProviderId })
      },
      success: function (results) {
        let { data, errors } = JSON.parse(results);
        console.log('success!', data);

        if (data.listUserSubscriptions.length > 0) {

          var subscriptions = data.listUserSubscriptions;

          $('.card-content').append('<div class="subscriptions-group" />');
          $(subscriptions).each(function (index, subscription) {
            var template = $($('#subscription-template').html());
            if (subscription.billing_profile.facility) {
              $('.facility-name', template).text(subscription.billing_profile.facility.facility_name);
            } else {
              $('.facility-name', template).text('FACILITY NAME');
            }
            if (subscription.billing_profile.validation_only) {
              $('.subscription-menu li:last-of-type', template).hide();
              $('.parking-type', template).text('Validation Subscription at');
            } else {
              $('.subscription-menu li:last-of-type', template).show();
            }
            $('.subscription-name', template).text('Subscription Name: ' + subscription.subscription_name);
            $('.account-id', template).text('Account ID: AC-' + subscription.account_id);
            var links = $('.subscription-menu a', template);
            $(links).each(function (index, link) {
              var href = $(this).attr('href');
              href = href.replaceAll('subscriptionId', subscription.id);
              $(link).attr('href', href);
            });
            if (subscription.billing_profile?.facility?.terms_and_conditions) {
              $('.subscription-menu ul', template).append('<li><a href="/account/monthly/terms/?subscription=' + subscription.id + '" title="Terms & Conditions" data-cy="terms-and-conditions-link">Terms & Conditions</a></li>');
            }
            $('.subscriptions-group').append(template);
          });

          // remove loading overlay
          $('.card-content-overlay').removeClass('card-content-overlay-active');

        } else {

          // inject error message
          $('.card-content-message').text('You don\'t have any subscriptions to display.');
          // remove loading overlay
          $('.card-content-overlay').removeClass('card-content-overlay-active');

        }
      },
      error: function (results) {
        console.log(results);
        // inject error message
        $('.card-content').append('<div class="card-content-error">Sorry, we were unable to look up your subscriptions. Try again?</div>');
        // remove loading overlay
        $('.card-content-overlay').removeClass('card-content-overlay-active');
      }
    });

  }

  let thisCreditCardFeePrice = 0;
  function getCreditCardFeePrice(billingProfileId, paymentAmount, subscriptionId) {
    $('.card-content-overlay').addClass('card-content-overlay-active');

    $.ajax({
      type: 'post',
      url: '/wp-admin/admin-ajax.php',
      data: {
        action: 'chirp_graphql',
        api_version: 'v2',
        authorization: graphQLv2Auth,
        nonce: graphQLNonce,
        graphql_request: `query getCreditCardFeePrice(
          $billingProfileId: String!,
          $paymentAmount: Int!,
          $subscriptionId: String
        ) {
          getCreditCardFeePrice(
            billingProfileId: $billingProfileId,
            paymentAmount: $paymentAmount,
            subscriptionId: $subscriptionId
          ) {
            price,
            displayPrice,
            displayPercentage,
            displayDollarAmount
          }
        }`,
        graphql_variables: JSON.stringify({
          billingProfileId,
          paymentAmount,
          subscriptionId,
        }),
      },
      success: function (results) {
        const { data, errors } = JSON.parse(results);
        if (errors) {
          console.log(errors);
          return;
        }

        const {
          price: creditCardFeePriceCents,
          displayPrice,
          displayPercentage,
          displayDollarAmount,
        } = data.getCreditCardFeePrice;

        if (creditCardFeePriceCents > 0) {
          thisCreditCardFeePrice = creditCardFeePriceCents;

          $('.credit-card-disclaimer').show();
          $('.bank-account-disclaimer').show();

          // Display credit card fee total price on one-time payment page
          $('.credit-card-fee-display-price').text(displayPrice);

          // Display credit card fee details on the recurring payments page
          let creditCardFeeDetails = '';
          if (displayDollarAmount) creditCardFeeDetails += `$${displayDollarAmount} flat fee`;
          if (displayPercentage) creditCardFeeDetails += `${displayDollarAmount ? ' plus a' : ''} ${displayPercentage}% fee`;
          $('.credit-card-fee-details').text(creditCardFeeDetails);

          // Update one-time payment total if credit card is selected
          const paymentType = $('input[name="payment-types"]:checked').val();
          if (paymentType == 'credit-card') {
            const creditCardFeePriceDollars = Number((creditCardFeePriceCents / 100).toFixed(2));
            const paymentAmountDollars = Number((paymentAmount / 100).toFixed(2));
            const invoiceAmount = (paymentAmountDollars + creditCardFeePriceDollars).toFixed(2);

            $('#invoice-amount').text(invoiceAmount);
            $('#price').val(paymentAmount + creditCardFeePriceCents);
          }

        } else {
          $('.credit-card-disclaimer').hide();
          $('.bank-account-disclaimer').hide();
        }

        $('.card-content-overlay').removeClass('card-content-overlay-active');
      },
      error: function () {
        $('.card-content-overlay').removeClass('card-content-overlay-active');
      }
    });
  }

  /*** monthly :: one-time payment ***/
  if ($('body').hasClass('page-template-page-account-monthly-one-time-payment')) {

    var displayAch = false;
    let displayCreditCard = true;

    /* get invoice id from url, if it exists */
    var thisSubscription = getUrlParameter('subscription');
    var thisInvoice = getUrlParameter('invoice');
    var thisInvoicePrice = 0;
    var thisBillingProfile = null;
    let thisPaymentProvider = null;

    function getInvoicesBySubscription(subscriptionId) {
      var thisSubscription = subscriptionId;
      $('.card-content-overlay').addClass('card-content-overlay-active');
      $.ajax({
        type: 'post',
        url: '/wp-admin/admin-ajax.php',
        data: {
          graphql_operation_name: 'get_invoices_by_subscription',
          action: 'chirp_graphql',
          authorization: graphQLAuth,
          nonce: graphQLNonce,
          graphql_request: `
            query getSubscription($subscription_id: String!) {
                getSubscription(subscription_id: $subscription_id) {
                    id,
                    achDisabled,
                    auto_pay,
                    mail_invoices,
                    billing_profile_id,
                    billing_profile {
                        id,
                        facility {
                            id,
                            facility_name,
                            address,
                            timezone,
                            use_ach,
                            use_credit_card
                            payment_provider
                        }
                    },
                    parkers {
                        id,
                        first_name,
                        last_name
                    },
                    payor {
                        id,
                        cognito_sub,
                        billing_firstname,
                        billing_lastname
                    },
                    invoices {
                        id,
                        readable_id,
                        due_on,
                        balance,
                        parking_period_month,
                        parking_period_year
                    }
                }
          }`,
          graphql_variables: JSON.stringify({
            "subscription_id": thisSubscription
          })
        },
        success: function (results) {
          let { data, errors } = JSON.parse(results);
          if (errors) {
            $('#invoice').empty();
            $('.card-content-message').empty().text('Something went wrong. Please try again?');
          } else {
            if (data.getSubscription) {
              const { invoices, billing_profile, billing_profile_id } = data.getSubscription;
              thisBillingProfile = billing_profile_id;
              displayAch = billing_profile.facility.use_ach;
              thisPaymentProvider = billing_profile.facility.payment_provider;
              if (data.getSubscription.billing_profile.facility.use_ach) {
                displayAch = !data.getSubscription.achDisabled
              }
              displayCreditCard = data.getSubscription.billing_profile.facility.use_credit_card;
              // you have subscriptions!
              if (data.getSubscription.invoices.length > 0) {
                $('#invoice').empty();
                var defaultOption = '<option value="#" selected disabled>Choose One...</option>';
                $('#invoice').append(defaultOption);
                var invoicesWithBalance = 0;
                $(invoices).each(function () {
                  if (this.balance > 0) {
                    var invoiceDueDate = moment.unix((this.due_on / 1000)).utc().format('MM-DD-YYYY');
                    var invoiceAmountDue = Number(this.balance / 100).toFixed(2);
                    var parkingPeriodMonth = this.parking_period_month;
                    var parkingPeriodYear = this.parking_period_year;
                    var invoiceText = (parkingPeriodMonth && parkingPeriodYear) ? parkingPeriodMonth + ' ' + parkingPeriodYear : 'Carryover';
                    var option = '<option value="' + this.id + '"data-payment-provider="' + thisPaymentProvider + '" data-due-date="' + invoiceDueDate + '" data-amount-due="' + invoiceAmountDue + '">' + invoiceText + ' Invoice - $' + invoiceAmountDue + '</option>';
                    $('#invoice').append(option);
                    invoicesWithBalance = invoicesWithBalance + 1;
                  }
                });
                if (invoicesWithBalance > 0) {
                  $('#invoices').show();
                } else {
                  // you have no invoices with a balance
                  $('#invoice').empty();
                  $('.card-content-message').empty().text('There are no invoices with a balance for this subscription.');
                }

                if (thisInvoice) {
                  $('#invoice option[value="' + thisInvoice + '"]').prop('selected', true);

                  var invoiceAmountDue = $('#invoice option:selected').attr('data-amount-due');
                  var invoiceAmountDueCents = Math.floor(invoiceAmountDue * 100);
                  thisInvoicePrice = invoiceAmountDueCents;

                  thisPaymentProvider = $('#invoice option:selected').attr('data-payment-provider');
                  var useSlidePay = thisPaymentProvider === '2';

                  $('#invoice-amount').text(invoiceAmountDue);
                  $('#price').val(invoiceAmountDueCents);

                  // show payment options
                  $('#payment-types').show();

                  if (displayCreditCard) {
                    $('#credit-card-radio-button').show();

                    if (!$('#bank-account').is(':checked')) {
                      if ($('#card-new').is(':checked')) {
                        displayNewCardForm(useSlidePay);
                      }

                      $('#credit-card-fields').show();
                    }
                  } else {
                    $('input[id=credit-card]').prop('checked', false);
                    $('#credit-card-radio-button').hide();
                    $('#credit-card-fields').hide();
                  }

                  if (displayAch) {
                    $('#ach-radio-button').show();
                  }

                  if ((displayCreditCard || displayAch)) {
                    $('#one-time-payment').show();
                  } else {
                    $('#one-time-payment').hide();
                  }

                  if (!displayCreditCard && !displayAch) {
                    $('#location-does-not-accept-online-payments').show();
                    $('#hide-choose-a-payment-type').hide();
                  } else {
                    $('#hide-choose-a-payment-type').show();
                    $('#location-does-not-accept-online-payments').hide();
                  }

                  // Show/hide credit card disclaimer and update total payment amount
                  getCreditCardFeePrice(thisBillingProfile, invoiceAmountDueCents, thisSubscription, invoiceAmountDue);
                } else {
                  $('.card-content-overlay').removeClass('card-content-overlay-active');
                }
              } else {
                // you have no invoices
                $('#invoice').empty();
                $('.card-content-message').empty().text('You don\'t have any invoices to pay right now.');
                $('.card-content-overlay').removeClass('card-content-overlay-active');
              }
            } else {
              // error?
              $('.card-content-message').empty().text('You don\'t have any subscriptions.');
              $('.card-content-overlay').removeClass('card-content-overlay-active');
            }
          }
        },
        error: function () {
          // error
          $('.card-content-message').empty().text('You don\'t have any subscriptions.');
          $('.card-content-overlay').removeClass('card-content-overlay-active');
        }
      });
    }

    const paymentProviderId = !/platinum|icon/.test(window.location.host) ? 1 : 2;

    $.ajax({
      type: 'post',
      url: '/wp-admin/admin-ajax.php',
      data: {
        action: 'chirp_graphql',
        authorization: graphQLAuth,
        nonce: graphQLNonce,
        graphql_request: `
          query listUserSubscriptions($paymentProviderId: Int) {
              listUserSubscriptions(paymentProviderId: $paymentProviderId) {
                  id
                  account_id
                  billing_profile {
                      facility {
                          id
                          facility_name
                          address
                          timezone
                      }
                  }
              }
          }
        `,
        graphql_variables: JSON.stringify({ paymentProviderId })
      },
      success: function (results) {
        let { data, errors } = JSON.parse(results);
        console.log('success!', data);
        if (errors) {
          $('.card-content-message').empty().text('Something went wrong. Please try again?');
        } else {
          if (data.listUserSubscriptions.length > 0) {
            // you have subscriptions
            var subscriptions = data.listUserSubscriptions;
            // loop through subscriptions and add to dropdown
            $(subscriptions).each(function (index, subscription) {
              var facilityName = 'FACILITY NAME';
              if (subscription.billing_profile.facility) {
                facilityName = subscription.billing_profile.facility.facility_name;
              }
              var option = '<option value="' + subscription.id + '">' + 'Monthly Parking at ' + facilityName + ' (AC-' + subscription.account_id + ')' + '</option>';
              $('#subscription').append(option);
            });
            if (subscriptions.length == 1) {
              // if you only have one subscription, automatically select it
              $('#subscription option:not([disabled])').prop('selected', true);
              var onlySubscription = $('#subscription option:selected').val();
              getInvoicesBySubscription(onlySubscription);
              window.history.replaceState('', '', '?subscription=' + onlySubscription);
            } else if (subscriptions.length > 1) {
              // if you have multiple subscriptions, choose from the dropdown
              if (thisSubscription) {
                $('#subscription option[value="' + thisSubscription + '"]').prop('selected', true);
                getInvoicesBySubscription(thisSubscription);
              } else {
                $('.card-content-overlay').removeClass('card-content-overlay-active');
              }
            }
          } else {
            $('#one-time-payment').hide();
            $('.card-content-message').empty().text('You don\'t have any subscriptions.');
            $('.card-content-overlay').removeClass('card-content-overlay-active');
          }
        }
      },
      error: function (results) {
        console.log('error!', results);
        $('#one-time-payment').hide();
        $('.card-content-message').empty().text('Something went wrong. Please try again?');
        $('.card-content-overlay').removeClass('card-content-overlay-active');
      }
    });

    /*** switching subscriptions ***/
    $('#subscription').change(function () {
      var thisSubscription = this.value;
      // hide invoices dropdown
      $('#invoices').hide();
      // hide payment options
      displayAch = false;
      $('#payment-types').hide();
      $('#bank-account-fields').hide();
      $('#ach-radio-button').hide();
      $('input[id="credit-card"]').prop('checked', true);
      $('#credit-card-fields').show();
      // clear error messages
      $('.card-content-message').empty();
      // update url
      var parameters = new URLSearchParams(window.location.search);
      parameters.set('subscription', thisSubscription);
      parameters.delete('invoice');
      thisInvoice = null;
      window.history.replaceState({}, '', location.pathname + '?' + parameters);
      // get invoices
      getInvoicesBySubscription(thisSubscription);
    });

    /*** switching invoices ***/
    $('#invoice').change(function () {
      var thisInvoice = this.value;

      // clear error messages
      $('.card-content-message').empty();

      // update price fields
      var invoiceAmountDue = $('option:selected', this).attr('data-amount-due');
      var invoiceAmountDueCents = Math.floor(invoiceAmountDue * 100);
      thisInvoicePrice = invoiceAmountDueCents;
      $('#invoice-amount').text(invoiceAmountDue);
      $('#price').val(invoiceAmountDueCents);

      // get payment provider info
      thisPaymentProvider  = $('option:selected', this).attr('data-payment-provider');
      var useSlidePay = thisPaymentProvider === '2';

      // update url
      var parameters = new URLSearchParams(window.location.search);
      parameters.set('invoice', thisInvoice);
      window.history.replaceState({}, '', location.pathname + '?' + parameters);
      // show payment options
      if ($('#payment-types').is(':hidden')) {
        $('#payment-types').show();
      }
      if (displayCreditCard) {
        $('#credit-card-radio-button').show();
        $('#credit-card-fields').show();

        if ($('#card-new').is(':checked')) {
          displayNewCardForm(useSlidePay);
        } else {
          $('#gpi-card-form-container').hide();
          $('#slidepay-card-form-container').hide();
          $('#new-credit-card-fields').hide();
        }

      } else {
        $('input[id=credit-card]').prop('checked', false);
        $('#credit-card-radio-button').hide();
        $('#credit-card-fields').hide();
      }
      if (displayAch) {
        $('#ach-radio-button').show();
      }
      if (displayCreditCard || displayAch) {
        $('#one-time-payment').show();
      } else {
        $('#one-time-payment').hide();
      }
      if (!displayCreditCard && !displayAch) {
        $('#location-does-not-accept-online-payments').show();
        $('#hide-choose-a-payment-type').hide();
      } else {
        $('#hide-choose-a-payment-type').show();
        $('#location-does-not-accept-online-payments').hide();
      }
      // Show/hide credit card disclaimer
      getCreditCardFeePrice(
        thisBillingProfile,
        invoiceAmountDueCents,
        thisSubscription,
      );
    });

    $('input[name="payment-types"]').change(function () {
      if (this.value == 'credit-card') {
        $('#bank-account-fields').hide();
        $('#credit-card-fields').show();

        const invoiceAmountCents = thisInvoicePrice + thisCreditCardFeePrice;
        const invoiceAmountDue = (invoiceAmountCents / 100).toFixed(2);
        $('#invoice-amount').text(invoiceAmountDue);
        $('#price').val(thisInvoicePrice + thisCreditCardFeePrice);
      } else if (this.value == 'bank-account') {
        $('#credit-card-fields').hide();
        $('#bank-account-fields').show();

        const invoiceAmountDue = (thisInvoicePrice / 100).toFixed(2);
        $('#invoice-amount').text(invoiceAmountDue);
        $('#price').val(thisInvoicePrice);
      } else {
        $('#credit-card-fields').hide();
        $('#bank-account-fields').hide();
      }
    });

    $('input[name="credit-cards"]').change(function () {
      if (this.value == 'card-new') {
        const useSlidePay = thisPaymentProvider === '2';
        displayNewCardForm(useSlidePay);
        $('#new-credit-card-fields').show();
      } else {
        $('#gpi-card-form-container').hide();
        $('#slidepay-card-form-container').hide();
        $('#new-credit-card-fields').hide();
      }
    });

    $('input[name="bank-accounts"]').change(function () {
      if (this.value == 'ach-new') {
        $('#new-bank-account-fields').show();
      } else {
        $('#new-bank-account-fields').hide();
      }
    });

    /*** submit one-time payment ***/
    $('#one-time-payment').validate({
      // debug: true,
      errorElement: 'span',
      errorClass: 'form-field-error',
      validClass: 'form-field-valid',
      errorPlacement: function (error, element) {
        error.appendTo(element.parents('.form-field'));
      },
      highlight: function (element, errorClass, validClass) {
        $(element).parents('.form-field').addClass(errorClass).removeClass(validClass);
      },
      unhighlight: function (element, errorClass, validClass) {
        $(element).parents('.form-field').removeClass(errorClass).addClass(validClass);
      },
      rules: {
        'invoice': {
          required: true
        },
        'sources': {
          required: true
        }
      },
      messages: {
        'invoice': {
          required: 'Please choose an invoice to pay.'
        },
        'sources': {
          required: 'Please choose a payment source.'
        }
      },
      submitHandler: function (form) {

        $('.button-spinner', form).prop('disabled', true);

        var invoiceId = $('#invoice').val();
        var price = $('#price').val();

        var paymentType = $('input[name="payment-types"]:checked').val();
        var paymentSource;
        if (paymentType == 'credit-card') {
          paymentSource = $('input[name="credit-cards"]:checked').val();
          if (paymentSource == 'card-new') {
            $('.form-card-message', form).empty().addClass('form-card-message-error').text('Please select a credit card');
            $('.button-spinner', form).prop('disabled', false);
          } else {
            paymentSource = $('input[name="credit-cards"]:checked').val();
            makePayment(invoiceId, paymentSource, paymentType);
          }
        } else if (paymentType == 'bank-account') {
          paymentSource = $('input[name="bank-accounts"]:checked').val();
          if (paymentSource == 'ach-new') {
            // check out with a new bank account
            $('.form-card-message', form).empty().addClass('form-card-message-error').text('Please select a bank account');
            $('.button-spinner', form).prop('disabled', false);
          } else {
            makePayment(invoiceId, paymentSource, paymentType);
          }
        }
      }
    });

  }

  /*** monthly :: recurring payments ***/
  if ($('body').hasClass('page-template-page-account-monthly-recurring-payments')) {

    /* get subscription id from url, if it exists */
    var thisSubscription = getUrlParameter('subscription');
    var thisBillingProfile = null;
    let displayAch = false;
    let displayCreditCard;
    let useSlidePay = false;

    /* initial page load */
    const paymentProviderId = !/platinum|icon/.test(window.location.host) ? 1 : 2;
    $.ajax({
      type: 'post',
      url: '/wp-admin/admin-ajax.php',
      data: {
        action: 'chirp_graphql',
        authorization: graphQLAuth,
        nonce: graphQLNonce,
        graphql_request: `
          query listUserSubscriptions($paymentProviderId: Int) {
            listUserSubscriptions(paymentProviderId: $paymentProviderId) {
              id
              achDisabled
              account_id
              paymentMethod { 
                id 
              }
              auto_pay
              mail_invoices
              created_at
              billing_profile_id
              billing_profile { 
                facility {
                  id
                  facility_name
                  address
                  timezone 
                  use_ach
                  use_credit_card
                  payment_provider 
                }
              } 
              payor { 
                id
                cognito_sub
                billing_firstname
                billing_lastname
              }
            }
          }
        `,
        graphql_variables: JSON.stringify({ paymentProviderId })
      },
      success: function (results) {
        const { data } = JSON.parse(results);

        if (data.listUserSubscriptions.length > 0) {
          /* if this user has subscriptions... */
          var subscriptions = data.listUserSubscriptions;

          $(subscriptions).each(function (_index, subscription) {
            var facilityName = 'FACILITY NAME';
            if (subscription.billing_profile.facility) {
              facilityName = subscription.billing_profile.facility.facility_name;
            }
            var option = '<option value="' + subscription.id + '">' + 'Monthly Parking at ' + facilityName + ' (AC-' + subscription.account_id + ')' + '</option>';
            $('select[name="subscription"]').append(option);

            if (thisSubscription == subscription.id) {
              displayAch = subscription.billing_profile.facility.use_ach;
              if (subscription.billing_profile.facility.use_ach) {
                displayAch = !subscription.achDisabled
              }
              displayCreditCard = subscription.billing_profile.facility.use_credit_card;
              thisBillingProfile = subscription.billing_profile_id;
              useSlidePay = subscription.billing_profile.facility.payment_provider === 2;

              /* set this subscription as 'selected' */
              $('#subscription option[value="' + subscription.id + '"]').prop('selected', true);

              /* show recurring payments fields */
              $('#recurring-payments-fields').show();

              /* check for `auto_pay` status */
              if (subscription.auto_pay == true) {

                /* set 'Enable Recurring Payments?' checkbox to TRUE */
                $('#recurring-payments-true').prop('checked', true);

                if (subscription.paymentMethod?.id) {
                  var found = false;
                  $('input[name="credit-cards"]').each(function () {
                    if ($(this).attr('id') == subscription.paymentMethod.id) {
                      $('#credit-card').prop('checked', true);
                      $('#credit-card-fields').show();
                      $('#bank-account-fields').hide();
                      $(this).prop('checked', true);
                      found = true;
                    }
                  });

                  if (!found) {
                    $('input[name="bank-accounts"]').each(function () {
                      if ($(this).attr('id') == subscription.paymentMethod.id) {
                        $('#bank-account').prop('checked', true);
                        $('#credit-card-fields').hide();
                        $('#bank-account-fields').show();
                        $(this).prop('checked', true);
                      }
                    });
                  }
                }

                /* show payment options fields */
                $('#payment-types').show();
                displayAch = subscription.billing_profile.facility.use_ach && !subscription.achDisabled;
                displayCreditCard = subscription.billing_profile.facility.use_credit_card;
                if (!displayAch) {
                  $('#ach-radio-button').hide();
                  $('#bank-account-fields').hide();
                } else {
                  $('#ach-radio-button').show();
                }

                if (displayCreditCard) {
                  $('#credit-card-radio-button').show();

                  if (!$('#bank-account').is(':checked')) {
                    if ($('#card-new').is(':checked')) {
                      displayNewCardForm(useSlidePay);
                    }

                    $('#credit-card-fields').show();
                  }
                } else {
                  $('input[id=credit-card]').prop('checked', false);
                  $('#credit-card-radio-button').hide();
                  $('#credit-card-fields').hide();
                }
                if (displayCreditCard || displayAch) {
                  $('#recurring-payments').show();
                } else {
                  $('#recurring-payments').hide();
                }
                
                if (!displayCreditCard && !displayAch) {
                  $('#location-does-not-accept-online-payments').show();
                  $('#hide-choose-a-payment-type').hide();
                } else {
                  $('#location-does-not-accept-online-payments').hide();
                  $('#hide-choose-a-payment-type').show();
                }

              } else if (subscription.auto_pay == false) {
                /* set 'Enable Recurring Payments?' checkbox to FALSE */
                $('#recurring-payments-true').prop('checked', false);

                /* hide payment options fields */
                $('#payment-types').hide();
              }
            }
          });

          if (subscriptions.length == 1) {
            $('#subscription option:not([disabled])').prop('selected', true);
            var subscription = subscriptions[0];
            thisSubscription = subscription.id;
            thisBillingProfile = subscription.billing_profile_id;
            displayAch = subscription.billing_profile.facility.use_ach && !subscription.achDisabled;
            displayCreditCard = subscription.billing_profile.facility.use_credit_card;
            useSlidePay = subscription.billing_profile.facility.payment_provider === 2;

            /* show recurring payments fields */
            $('#recurring-payments-fields').show();

            /* check for `auto_pay` status */
            if (subscription.auto_pay == true) {

              /* set 'Enable Recurring Payments?' checkbox to TRUE */
              $('#recurring-payments-true').prop('checked', true);

              if (subscription.paymentMethod?.id) {
                var found = false;
                $('input[name="credit-cards"]').each(function () {
                  if ($(this).attr('id') == subscription.paymentMethod.id) {
                    $('#credit-card').prop('checked', true);
                    $('#credit-card-fields').show();
                    $('#bank-account-fields').hide();
                    $(this).prop('checked', true);
                    found = true;
                  }
                });

                if (!found) {
                  $('input[name="bank-accounts"]').each(function () {
                    if ($(this).attr('id') == subscription.paymentMethod.id) {
                      $('#bank-account').prop('checked', true);
                      $('#credit-card-fields').hide();
                      $('#bank-account-fields').show();
                      $(this).prop('checked', true);
                    }
                  });
                }
              }

              /* show payment options fields */
              $('#payment-types').show();
              if (!displayAch) {
                $('#ach-radio-button').hide();
                $('#bank-account-fields').hide();
              } else {
                $('#ach-radio-button').show();
              }
              if (displayCreditCard) {
                $('#credit-card-radio-button').show();

                if (!$('#bank-account').is(':checked')) {
                  $('#credit-card-fields').show();
                }
              } else {
                $('input[id=credit-card]').prop('checked', false);
                $('#credit-card-radio-button').hide();
                $('#credit-card-fields').hide();
              }
              if (displayCreditCard || displayAch) {
                $('#recurring-payments').show();
              } else {
                $('#recurring-payments').hide();
              }
              if (!displayCreditCard && !displayAch) {
                $('#location-does-not-accept-online-payments').show();
                $('#hide-choose-a-payment-type').hide();
              } else {
                $('#location-does-not-accept-online-payments').hide();
                $('#hide-choose-a-payment-type').show();
              }

            } else if (subscription.auto_pay == false) {

              /* set 'Enable Recurring Payments?' checkbox to FALSE */
              $('#recurring-payments-true').prop('checked', false);

              /* hide payment options fields */
              $('#payment-types').hide();

            }

            /* update url with new subscription id */
            window.history.replaceState('', '', '?subscription=' + subscription.id);
          }

          if (thisSubscription) {
            // Show/hide credit card disclaimer
            getCreditCardFeePrice(
              thisBillingProfile,
              100, // Since no payment is actually being made this can be any positive integer
              thisSubscription,
            );
          } else {
            /* remove loading overlay */
            $('.card-content-overlay').removeClass('card-content-overlay-active');
          }
        } else {

          /* this user has no subscriptions */
          /* inject error message */
          $('.card-content-message').text('You don\'t have any subscriptions.');

          /* remove loading overlay */
          $('.card-content-overlay').removeClass('card-content-overlay-active');
        }
      },
      error: function () {
        /* inject error message */
        $('.card-content-message').text('Something went wrong. Try again?');

        /* remove loading overlay */
        $('.card-content-overlay').removeClass('card-content-overlay-active');
      }
    });

    /*** switching subscriptions ***/
    $('#subscription').change(function () {
      var thisSubscription = $(this).val();

      $.ajax({
        type: 'post',
        url: '/wp-admin/admin-ajax.php',
        data: {
          action: 'chirp_graphql',
          authorization: graphQLAuth,
          nonce: graphQLNonce,
          graphql_request: `
            query getSubscription($subscription_id: String!) { 
              getSubscription(subscription_id: $subscription_id) { 
                id 
                paymentMethod { 
                  id 
                } 
                achDisabled 
                auto_pay 
                mail_invoices 
                billing_profile_id 
                billing_profile { 
                  facility { 
                    use_ach 
                    use_credit_card
                    payment_provider
                  } 
                } 
                payor { 
                  id 
                  cognito_sub 
                  billing_firstname 
                  billing_lastname 
                } 
              } 
            }
          `,
          graphql_variables: JSON.stringify({
            "subscription_id": thisSubscription
          })
        },
        success: function (results) {
          const { data } = JSON.parse(results);

          /* empty error message */
          $('.card-content-message').empty();
          $('.form-card-message').empty().removeClass('form-card-message-error')

          /* hide disclaimers */
          $('.credit-card-disclaimer').hide();
          $('.bank-account-disclaimer').hide();

          if (data.getSubscription) {
            var subscription = data.getSubscription;
            const facility = subscription.billing_profile.facility;

            displayAch = facility.use_ach && !subscription.achDisabled;
            displayCreditCard = subscription.billing_profile.facility.use_credit_card;
            useSlidePay = facility.payment_provider === 2;

            /* show recurring payments fields */
            $('#recurring-payments-fields').show();

            // Show/hide credit card disclaimer
            getCreditCardFeePrice(
              subscription.billing_profile_id,
              100, // Since no payment is actually being made this can be any positive integer
              subscription.id,
            );

            /* check for `auto_pay` status */
            if (subscription.auto_pay == true) {

              /* set 'Enable Recurring Payments?' checkbox to TRUE */
              $('#recurring-payments-true').prop('checked', true);

              if (subscription.paymentMethod?.id) {
                var found = false;
                $('input[name="credit-cards"]').each(function () {
                  if ($(this).attr('id') == subscription.paymentMethod.id) {
                    $('#credit-card').prop('checked', true);
                    $('#credit-card-fields').show();
                    $('#bank-account-fields').hide();
                    $(this).prop('checked', true);
                    found = true;
                  }
                });

                if (!found) {
                  $('input[name="bank-accounts"]').each(function () {
                    if ($(this).attr('id') == subscription.paymentMethod.id) {
                      $('#bank-account').prop('checked', true);
                      $('#credit-card-fields').hide();
                      $('#bank-account-fields').show();
                      $(this).prop('checked', true);
                    }
                  });
                }
              }

              /* show payment options fields */
              $('#payment-types').show();

              if (!displayAch) {
                $('#ach-radio-button').hide();
                $('#bank-account-fields').hide();
              } else {
                $('#ach-radio-button').show();
              }

              if (displayCreditCard) {
                $('#credit-card-radio-button').show();

                if($('#card-new').is(':checked')) {
                  displayNewCardForm(useSlidePay);
                } else {
                  $('#credit-card-fields').hide();
                }

                if (!$('#bank-account').is(':checked')) {
                  $('#credit-card-fields').show();
                }
              } else {
                $('input[id=credit-card]').prop('checked', false);
                $('#credit-card-radio-button').hide();
                $('#credit-card-fields').hide();
              }

              if (displayCreditCard || displayAch) {
                $('#recurring-payments').show();
              } else {
                $('#recurring-payments').hide();
              }

              if (!displayCreditCard && !displayAch) {
                $('#location-does-not-accept-online-payments').show();
                $('#hide-choose-a-payment-type').hide();
              } else {
                $('#location-does-not-accept-online-payments').hide();
                $('#hide-choose-a-payment-type').show();
              }
            } else {
              /* set 'Enable Recurring Payments?' checkbox to FALSE */
              $('#recurring-payments-true').prop('checked', false);

              /* hide payment options fields */
              $('#payment-types').hide();
            }

            /* update url with new subscription id */
            window.history.replaceState('', '', '?subscription=' + thisSubscription);
          } else {
            /* inject error message */
            $('.card-content-message').text('You don\'t have any subscriptions.');

            /* remove loading overlay */
            $('.card-content-overlay').removeClass('card-content-overlay-active');
          }
        },
        error: function () {
          /* inject error message */
          $('.card-content-message').text('Something went wrong. Try again?');

          /* remove loading overlay */
          $('.card-content-overlay').removeClass('card-content-overlay-active');
        }
      });
    });

    /* toggle recurring payment on/off */
    $('input[name="recurring-payments"]').change(function () {
      if ($(this).is(':checked')) {
        $('#payment-types').show();
        if (!displayAch) {
          $('#ach-radio-button').hide();
          $('#bank-account-fields').hide();
        } else {
          $('#ach-radio-button').show();
        }
        if (displayCreditCard) {
          $('#credit-card-radio-button').show();

          if (!$('#bank-account').is(':checked')) {
            $('#credit-card-fields').show();
          }
        } else {
          $('input[id=credit-card]').prop('checked', false);
          $('#credit-card-radio-button').hide();
          $('#credit-card-fields').hide();
        }
        if (!displayCreditCard && !displayAch) {
          $('#location-does-not-accept-online-payments').show();
          $('#hide-choose-a-payment-type').hide();
        } else {
          $('#location-does-not-accept-online-payments').hide();
          $('#hide-choose-a-payment-type').show();
        }
      } else {
        $('#payment-types').hide();
      }
    });

    $('input[name="payment-types"]').change(function () {
      if (this.value == 'credit-card') {
        $('#bank-account-fields').hide();
        $('#credit-card-fields').show();
      } else if (this.value == 'bank-account') {
        $('#credit-card-fields').hide();
        $('#bank-account-fields').show();
      } else {
        $('#credit-card-fields').hide();
        $('#bank-account-fields').hide();
      }
    });

    $('input[name="credit-cards"]').change(function () {
      if (this.value == 'card-new') {
        displayNewCardForm(useSlidePay);
        $('#new-credit-card-fields').show();
      } else {
        $('#gpi-card-form-container').hide();
        $('#slidepay-card-form-container').hide();
        $('#new-credit-card-fields').hide();
      }
    });

    $('input[name="bank-accounts"]').change(function () {
      if (this.value == 'ach-new') {
        $('#new-bank-account-fields').show();
      } else {
        $('#new-bank-account-fields').hide();
      }
    });

    /* save recurring payments settings */
    function saveRecurringPayment(subscriptionId, subscription, form) {
      $.ajax({
        type: 'post',
        url: '/wp-admin/admin-ajax.php',
        data: {
          action: 'chirp_graphql',
          api_version: 'v2',
          authorization: graphQLAuth,
          nonce: graphQLNonce,
          graphql_request: "mutation myAccountUpdateRecurringPayments($subscriptionId: String!, $autoPay: Boolean!, $paymentMethodId: Int) { myAccountUpdateRecurringPayments(subscriptionId: $subscriptionId, autoPay: $autoPay, paymentMethodId: $paymentMethodId) }",
          graphql_variables: JSON.stringify({
            subscriptionId,
            autoPay: subscription.auto_pay,
            paymentMethodId: subscription.payment_method_id ? Number(subscription.payment_method_id) : null,
          })
        },
        success: function (results) {
          const { errors } = JSON.parse(results);
          console.log('success!');
          if (errors) {
            $('.form-card-message', form).empty().removeClass('form-card-message-success').addClass('form-card-message-error').text(errors[0].message);
          } else {
            $('.form-card-message', form).empty().removeClass('form-card-message-error').addClass('form-card-message-success').text('This subscription has been updated!');
          }

          $('.button-spinner', form).prop('disabled', false);
        },
        error: function () {
          $('.button-spinner', form).prop('disabled', false);
          $('.form-card-message', form).empty().removeClass('form-card-message-success').addClass('form-card-message-error').text(errorMessage);
        }
      });
    };

    $('#recurring-payments').validate({
      errorElement: 'span',
      errorClass: 'form-field-error',
      validClass: 'form-field-valid',
      errorPlacement: function (error, element) {
        error.appendTo(element.parents('.form-field'));
      },
      highlight: function (element, errorClass, validClass) {
        $(element).parents('.form-field').addClass(errorClass).removeClass(validClass);
      },
      unhighlight: function (element, errorClass, validClass) {
        $(element).parents('.form-field').removeClass(errorClass).addClass(validClass);
      },
      rules: {
        'subscription': {
          required: true
        },
        'payment-types': {
          required: {
            depends: function () {
              return $('input[name="recurring-payments"]').val() == true;
            }
          }
        },
        'credit-cards': {
          required: {
            depends: function () {
              return $('input[name="payment-types"]').val() == 'credit-card';
            }
          }
        },
        'bank-accounts': {
          required: {
            depends: function () {
              return $('input[name="payment-types"]').val() == 'bank-account';
            }
          }
        }
      },
      messages: {
        'subscription': {
          required: 'Please choose a subscription.'
        },
        'payment-types': {
          required: 'Please choose a payment type.'
        },
        'credit-cards': {
          required: 'Please choose a credit card.'
        },
        'bank-accounts': {
          required: 'Please choose a bank account.'
        }
      },
      submitHandler: function (form) {
        $('.button-spinner', form).prop('disabled', true);

        var subscriptionId = $('#subscription').val();
        var subscription = new Object();

        if ($('#recurring-payments-true').is(':checked')) {
          subscription.auto_pay = true;
          var paymentType = $('input[name="payment-types"]:checked').val();
          if (paymentType == 'credit-card') {
            var creditCard = $('input[name="credit-cards"]:checked').val();
            if (creditCard == 'card-new') {
              $('.form-card-message', form).empty().addClass('form-card-message-error').text('Please select a credit card');
              $('.button-spinner', form).prop('disabled', false);
            } else {
              subscription.payment_method_id = creditCard;
              saveRecurringPayment(subscriptionId, subscription, form);
            }
          } else if (paymentType == 'bank-account') {
            var bankAccount = $('input[name="bank-accounts"]:checked').val();
            if (bankAccount == 'ach-new') {
              $('.form-card-message', form).empty().addClass('form-card-message-error').text('Please select a bank account');
              $('.button-spinner', form).prop('disabled', false);
            } else {
              subscription.payment_method_id = bankAccount;
              saveRecurringPayment(subscriptionId, subscription, form);
            }
          }
        } else {
          subscription.auto_pay = false;
          saveRecurringPayment(subscriptionId, subscription, form);
        }
      }
    });

  }

  /*** monthly :: account activity ***/
  if ($('body').hasClass('page-template-page-account-monthly-activity')) {

    var thisSubscription = getUrlParameter('subscription');
    var thisInvoice = getUrlParameter('invoice');

    function listInvoices(invoices, target, invoiceType) {
      var target = target;
      var invoices = invoices;
      var pastDueInvoiceIndex = 0;
      var today = moment().valueOf();
      $('.transactions-group', target).empty();
      if (invoices.length > 0) {
        $(target).show();
        $('.transactions-group', target).append('<ol />');
        $(invoices).each(function (index) {
          var invoiceDueDate = moment.unix((this.due_on / 1000)).utc().format('MMMM D, YYYY');
          var invoiceBalanceDue = Number(this.balance / 100).toFixed(2);
          var invoiceStatus = null;
          if (this.balance > 0 && today > parseInt(this.due_on)) {
            invoiceStatus = 'Past Due';
          }
          var dataCyInvoiceType = invoiceStatus !== null ? 'past-due' : invoiceType
          var dataCyInvoiceIndex = invoiceStatus !== null ? pastDueInvoiceIndex : index
          var template = `<li class="transaction" data-cy="${dataCyInvoiceType}-invoice-${dataCyInvoiceIndex}">`;
          template += '<div class="transaction-title">';
          template += `<a href="?invoice=${this.id}" title="View Invoice # ${this.id}" data-cy="invoice-link">`;
          if (this.parking_period_month && this.parking_period_year) {
            var invoicePeriod = moment().month(this.parking_period_month).format('MMMM');
            var invoiceYear = this.parking_period_year;
            template += invoicePeriod + ' ' + invoiceYear + ' ';
          } else {
            template += 'Carryover' + ' ';
          }
          template += 'Invoice'
          template += '</a>';
          if (invoiceStatus != null) {
            template += ' <span class="transaction-status" data-cy="past-due-text">' + invoiceStatus + '<span>';
            pastDueInvoiceIndex++;
          }
          template += '</div>';
          template += '<div class="transaction-total" data-cy="invoice-value-text">$' + invoiceBalanceDue + '</div>';
          template += '<div class="transaction-meta">';
          template += '<div data-cy="invoice-due-date-text">Due: ' + invoiceDueDate + '</div>';
          template += '<div data-cy="invoice-number-text">Invoice #: ' + this.readable_id + '</div>';
          template += '</div>';
          template += '</li>';
          $('.transactions-group ol', target).append(template);
        });
      } else {
        $(target).hide();
      }
    }

    function listInvoicesBySubscription(subscriptionId) {
      var subscriptionId = subscriptionId;
      $('.card-content-overlay').addClass('card-content-overlay-active');
      $.ajax({
        type: 'post',
        url: '/wp-admin/admin-ajax.php',
        data: {
          action: 'chirp_graphql',
          authorization: graphQLAuth,
          nonce: graphQLNonce,
          graphql_request: "query getSubscription($subscription_id: String!) { getSubscription(subscription_id: $subscription_id) { id, invoices { id, readable_id, due_on, balance, parking_period_month, parking_period_year } } }",
          graphql_variables: JSON.stringify({
            "subscription_id": subscriptionId
          })
        },
        success: function (results) {

          let { data, errors } = JSON.parse(results);

          console.log('success!', data);
          if (errors) {
            $('.card-content-message').empty().text('Something went wrong. Try again?');
          } else {
            if (data.getSubscription.invoices.length > 0) {
              var invoices = data.getSubscription.invoices;
              var paidInvoices = new Array();
              var unpaidInvoices = new Array();
              $(invoices).each(function () {
                if (this.balance > 0) {
                  unpaidInvoices.push(this);
                } else {
                  paidInvoices.push(this);
                }
              });
              listInvoices(unpaidInvoices, '#invoices-unpaid', 'unpaid');
              listInvoices(paidInvoices, '#invoices-paid', 'paid');
            } else {
              $('.card-content-message').empty().text('This subscription has no invoices.');
            }
          }
          $('.card-content-overlay').removeClass('card-content-overlay-active');
        },
        error: function (results) {
          console.log('error!', results);
          $('.card-content-message').empty().text('Something went wrong. Try again?');
          $('.card-content-overlay').removeClass('card-content-overlay-active');
        }
      });
    }

    function getInvoicePDF(invoiceId) {

      $(this).prop('disabled', true);

      var invoiceId = invoiceId;

      $.ajax({
        type: 'post',
        url: '/wp-admin/admin-ajax.php',
        data: {
          action: 'chirp_graphql',
          authorization: graphQLAuth,
          nonce: graphQLNonce,
          api_version: 'v2',
          graphql_request: `
            query getInvoicePDFFromMyAccount($invoiceId: String!) {
              getInvoicePDFFromMyAccount(invoiceId: $invoiceId) {
                pdfUrl
              }
          }`,
          graphql_variables: JSON.stringify({
            invoiceId,
          }),
        },
        success: function (results) {
          const { data, errors } = JSON.parse(results);
          if (errors) {
            console.log(errors);
            return;
          }
          if (results) {
            downloadInvoicePDF(data);
          } else {
            $('.form-card-message').empty().text('Something went wrong. Try again?');
          }
          $(this).prop('disabled', false);
          $('.button-spinner').prop('disabled', false);
        },
        error: function (results) {

          if (results.status == '200' && results.responseText.length > 0) {
            const { data, errors } = JSON.parse(results);
            if (errors) {
              console.log(errors);
              return;
            }
            downloadInvoicePDF(data);
          } else {
            $('.form-card-message').empty().text('Something went wrong. Try again?');
          }
          $(this).prop('disabled', false);
          $('.button-spinner').prop('disabled', false);
        }
      });

    }

    function downloadInvoicePDF(content) {
      var content = content;
      var pdf = content.getInvoicePDFFromMyAccount.pdfUrl;
      var downloadLink = document.createElement('a');
      var fileName = 'invoice.pdf';
      downloadLink.href = pdf;
      downloadLink.target = '_blank';
      downloadLink.download = fileName;
      downloadLink.click();
    }

    let formatEntryValue = function (amount, type) {
      let formatedAmount = '$' + Number(amount / 100).toFixed(2);
      return ['CHARGE', 'REFUND'].includes(type) ? formatedAmount : '(' + formatedAmount + ')';
    }

    if (thisInvoice) {
      $.ajax({
        type: 'post',
        url: '/wp-admin/admin-ajax.php',
        data: {
          graphql_operation_name: 'get_invoice',
          action: 'chirp_graphql',
          authorization: graphQLAuth,
          nonce: graphQLNonce,
          graphql_request: "query getInvoice($invoice_id: String!) { getInvoice(invoice_id: $invoice_id) { id, readable_id, subscription_id, type, due_on, balance, amount, notes, parking_period_month, parking_period_year, line_items { id, invoice_id, balance, adjusted_gross_amount, parker { id, first_name, last_name, group, vehicles, selected_start_date, selected_end_date }, rate { id, name }, fee { type }, entries { id, type, amount, amount_tax_1, amount_tax_2, amount_tax_3, amount_tax_4, gross_amount, payment_id } created_at }, subscription { id, payor { id, type, status, cognito_sub, billing_firstname, billing_lastname, billing_street, billing_city, billing_state, billing_zip, billing_phone, billing_email } }, parkers { id, first_name, last_name, email }, payments { id, type, payment_meta, amount } } }",
          graphql_variables: JSON.stringify({
            "invoice_id": thisInvoice
          })
        },
        success: function (results) {

          let { data, errors } = JSON.parse(results);

          console.log('success!', data);
          if (errors) {

            console.log('invoice not found?');

          } else {

            var invoice = data.getInvoice;

            var invoiceDueDate = moment.unix((invoice.due_on / 1000)).utc().format('MM/DD/YYYY');

            let formattedTitle = 'Invoice';
            if (invoice.parking_period_month && invoice.parking_period_year) {
              formattedTitle = moment().month(invoice.parking_period_month).format('MMMM') + ' ' + invoice.parking_period_year + ' Invoice';
            } else {
              formattedTitle = 'Carryover Invoice';
            }
            $('.card-header-title').text(formattedTitle);
            $('.invoice-due-on').text(invoiceDueDate);
            $('.invoice-id').text(invoice.readable_id);
            $('.invoice-balance').text('$' + Number(invoice.balance / 100).toFixed(2))

            var content = '<p data-cy="billing-address-text">' +
              '<strong>Bill To:</strong><br />' +
              invoice.subscription.payor.billing_firstname + ' ' + invoice.subscription.payor.billing_lastname + '<br/>' +
              invoice.subscription.payor.billing_street + '<br/>' +
              invoice.subscription.payor.billing_city + ', ' + invoice.subscription.payor.billing_state + ' ' + invoice.subscription.payor.billing_zip + '<br/>' +
              invoice.subscription.payor.billing_phone + '<br/>' +
              invoice.subscription.payor.billing_email +
              '</p>';

            if (invoice.line_items.length > 0) {

              content += '<div class="invoice-line-items">';
              invoice.line_items.forEach(function (item) {
                let title = '';
                if (item.fee) {
                  if (item.fee.name) {
                    title += item.fee.name;
                  } else {
                    title += item.fee.type + ' Fee';
                  }
                } else if (invoice.type === 'CARRYOVER_INVOICE') {
                  title += 'Carryover';
                } else if (invoice.type === 'VALIDATION_INVOICE') {
                  title += 'Validation'
                }

                let selected_dates = '';
                if (item.parker) {
                  title += ' for ' + item.parker.first_name + ' ' + item.parker.last_name;
                }

                let start_date = item.parker && item.parker.selected_start_date ? moment.utc(item.parker.selected_start_date, 'x').format('MM/DD/YYYY') : null;
                let end_date = item.parker && item.parker.selected_end_date ? moment.utc(item.parker.selected_end_date, 'x').format('MM/DD/YYYY') : null;
                if (start_date || end_date) {
                  selected_dates += `<strong data-cy="${GetSlugFromStr(item.fee?.type ?? 'NA')}-charge-selected-dates">Selected Dates:</strong> ` + start_date + ' to ' + end_date;
                }

                content +=
                  '<div class="invoice-line-item">' +
                  '<p>' +
                  `<strong data-cy="${GetSlugFromStr(item.fee?.type ?? 'NA')}-charge-title-text">` + title + '</strong><br />' +
                  `<strong data-cy="${GetSlugFromStr(item.fee?.type ?? 'NA')}-charge-creation-date">Created:</strong> ` + moment(item.created_at, 'x').format('MM/DD/YYYY') + '<br />' +
                  selected_dates
                '</p>';

                content +=
                  '<table>' +
                  '<thead>' +
                  '<tr>' +
                  '<th>Type</th>' +
                  '<th>Net</th>' +
                  '<th>Tax #1</th>' +
                  '<th>Tax #2</th>' +
                  '<th>Tax #3</th>' +
                  '<th>Tax #4</th>' +
                  '<th>Total</th>' +
                  '</tr>' +
                  '</thead>' +
                  '<tbody>';

                item.entries.forEach(function (entry) {
                  content +=
                    '<tr>' +
                    `<td data-title="Type" data-cy="${GetSlugFromStr(item.fee?.type ?? 'NA')}-${GetSlugFromStr(lineItemEntryTypeMap[entry.type])}-charge-type-text">` + lineItemEntryTypeMap[entry.type] + '</td>' +
                    `<td data-title="Net" data-cy="${GetSlugFromStr(item.fee?.type ?? 'NA')}-${GetSlugFromStr(lineItemEntryTypeMap[entry.type])}-net-value-text">` + formatEntryValue(entry.amount, entry.type) + '</td>' +
                    `<td data-title="Tax #1" data-cy="${GetSlugFromStr(item.fee?.type ?? 'NA')}-${GetSlugFromStr(lineItemEntryTypeMap[entry.type])}-tax-1-text">` + formatEntryValue(entry.amount_tax_1, entry.type) + '</td>' +
                    `<td data-title="Tax #2" data-cy="${GetSlugFromStr(item.fee?.type ?? 'NA')}-${GetSlugFromStr(lineItemEntryTypeMap[entry.type])}-tax-2-text">` + formatEntryValue(entry.amount_tax_2, entry.type) + '</td>' +
                    `<td data-title="Tax #3" data-cy="${GetSlugFromStr(item.fee?.type ?? 'NA')}-${GetSlugFromStr(lineItemEntryTypeMap[entry.type])}-tax-3-text">` + formatEntryValue(entry.amount_tax_3, entry.type) + '</td>' +
                    `<td data-title="Tax #4" data-cy="${GetSlugFromStr(item.fee?.type ?? 'NA')}-${GetSlugFromStr(lineItemEntryTypeMap[entry.type])}-tax-4-text">` + formatEntryValue(entry.amount_tax_4, entry.type) + '</td>' +
                    `<td data-title="Total" data-cy="${GetSlugFromStr(item.fee?.type ?? 'NA')}-${GetSlugFromStr(lineItemEntryTypeMap[entry.type])}-charge-total-text">` + formatEntryValue(entry.gross_amount, entry.type) + '</td>' +
                    '</tr>';
                });

                content +=
                  '</tbody>' +
                  '</table>' +
                  '</div>';
              });
              content += '</div>';
            }
            if (invoice.balance > 0) {
              var footer = '<a href="/account/monthly/one-time-payment/?subscription=' + invoice.subscription_id + '&invoice=' + invoice.id + '" title="Pay Invoice #' + invoice.readable_id + '" class="button button-green" data-cy="submit-button">Pay This Invoice</a>';
              $('.invoice-footer').prepend(footer).show();
            }

            $('.invoice-content').append(content);

          }

          $('.card-content-overlay').removeClass('card-content-overlay-active');

        },
        error: function (results) {
          console.log('error!', results);
          $('.card-content-overlay').removeClass('card-content-overlay-active');
        }
      });

    } else {
      const paymentProviderId = !/platinum|icon/.test(window.location.host) ? 1 : 2;
      $.ajax({
        type: 'post',
        url: '/wp-admin/admin-ajax.php',
        data: {
          action: 'chirp_graphql',
          authorization: graphQLAuth,
          nonce: graphQLNonce,
          graphql_request: "query listUserSubscriptions($paymentProviderId: Int) { listUserSubscriptions(paymentProviderId: $paymentProviderId) { id, account_id, billing_profile { facility { id, facility_name, address, timezone } } } }",
          graphql_variables: JSON.stringify({ paymentProviderId })
        },
        success: function (results) {

          let { data, errors } = JSON.parse(results);

          console.log('success!', data);
          if (errors) {
            $('.card-content-message').empty().text('Something went wrong. Try again?');
          } else {
            if (data.listUserSubscriptions.length > 0) {
              // you have subscriptions
              var subscriptions = data.listUserSubscriptions;
              $(subscriptions).each(function (index, subscription) {
                var facilityName = 'FACILITY NAME';
                if (subscription.billing_profile.facility) {
                  facilityName = subscription.billing_profile.facility.facility_name;
                }
                var option = '<option value="' + subscription.id + '">' + 'Monthly Parking at ' + facilityName + ' (AC-' + subscription.account_id + ')' + '</option>';
                $('#subscription').append(option);
              });
              if (thisSubscription) {
                $('#subscription option[value="' + thisSubscription + '"]').prop('selected', true);
                listInvoicesBySubscription(thisSubscription);
              } else if (subscriptions.length == 1) {
                $('#subscription option:not([disabled])').prop('selected', true);
                var onlySubscription = $('#subscription option:selected').val();
                listInvoicesBySubscription(onlySubscription);
                window.history.replaceState('', '', '?subscription=' + onlySubscription);
              } else {
                $('.card-content-overlay').removeClass('card-content-overlay-active');
              }
            } else {
              // you have no subscriptions
              $('.card-content-message').empty().text('You don\'t have any subscriptions.');
              $('.card-content-overlay').removeClass('card-content-overlay-active');
            }
          }
        },
        error: function (results) {
          console.log('error!', results);
          $('.card-content-message').empty().text('Something went wrong. Try again?');
          $('.card-content-overlay').removeClass('card-content-overlay-active');
        }
      });

    }

    $('#subscription').change(function () {
      var thisSubscription = this.value;
      var parameters = new URLSearchParams(window.location.search);
      parameters.set('subscription', thisSubscription);
      parameters.delete('invoice');
      window.history.replaceState({}, '', location.pathname + '?' + parameters);
      listInvoicesBySubscription(thisSubscription);
    });

    $('#invoice-pdf').on('click', function () {
      $('.button-spinner').prop('disabled', true);
      var invoiceId = getUrlParameter('invoice');
      getInvoicePDF(invoiceId);
    });

  }

  /*** monthly :: billing information ***/
  if ($('body').hasClass('page-template-page-account-monthly-billing')) {

    var thisSubscription = getUrlParameter('subscription');
    const paymentProviderId = !/platinum|icon/.test(window.location.host) ? 1 : 2;
    $.ajax({
      type: 'post',
      url: '/wp-admin/admin-ajax.php',
      data: {
        action: 'chirp_graphql',
        authorization: graphQLAuth,
        nonce: graphQLNonce,
        graphql_request: "query listUserSubscriptions($paymentProviderId: Int) { listUserSubscriptions(paymentProviderId: $paymentProviderId) { id, account_id, billing_profile { facility { id, facility_name, address, timezone } } } }",
        graphql_variables: JSON.stringify({ paymentProviderId })
      },
      success: function (results) {

        let { data, errors } = JSON.parse(results);

        if (data.listUserSubscriptions.length > 0) {

          var subscriptions = data.listUserSubscriptions;

          $(subscriptions).each(function (index, subscription) {
            var facilityName = 'FACILITY NAME';
            if (subscription.billing_profile.facility) {
              facilityName = subscription.billing_profile.facility.facility_name;
            }
            var option = '<option value="' + subscription.id + '">' + 'Monthly Parking at ' + facilityName + ' (AC-' + subscription.account_id + ')' + '</option>';
            $('select[name="subscription"]').append(option);

            if (thisSubscription == subscription.id || subscriptions.length == 1) {

              if (thisSubscription == subscription.id) {
                $('#subscriptions option[value="' + subscription.id + '"]').prop('selected', true);
              } else if (subscriptions.length == 1) {
                $('#subscription option:not([disabled])').prop('selected', true);
                thisSubscription = $('#subscription option:selected').val();
              }

              $.ajax({
                type: 'post',
                url: '/wp-admin/admin-ajax.php',
                data: {
                  action: 'chirp_graphql',
                  authorization: graphQLAuth,
                  nonce: graphQLNonce,
                  graphql_request: "query getSubscription($subscription_id: String!) { getSubscription(subscription_id: $subscription_id) { id, payor { id, type, status, contact_notes, cognito_sub, billing_firstname, billing_lastname, billing_phone, billing_email, billing_street, billing_city, billing_state, billing_zip, info_name, info_attn, info_street, info_city, info_state, info_zip, created_at, updated_at } } }",
                  graphql_variables: JSON.stringify({
                    "subscription_id": thisSubscription
                  })
                },
                success: function (results) {

                  let { data, errors } = JSON.parse(results);

                  console.log('success!', data);

                  $('#subscription option[value="' + data.getSubscription.id + '"]').prop('selected', true);

                  var payor = data.getSubscription.payor;

                  $('#payor-fields').show();

                  $('#payor-id').val(payor.id);
                  $('#payor-type').val(payor.type);
                  $('#first-name').val(payor.billing_firstname);
                  $('#last-name').val(payor.billing_lastname);
                  $('#email-address').val(payor.billing_email);
                  $('#phone-number').val(payor.billing_phone);
                  $('#street-address').val(payor.billing_street);
                  $('#city').val(payor.billing_city);
                  $('#state').val(payor.billing_state);
                  $('#zip-code').val(payor.billing_zip);

                  if (payor.info_name || payor.info_attn || payor.info_street || payor.info_city || payor.info_state || payor.info_zip) {

                    $('#show-business-information').prop('checked', true);
                    $('#business-information').show();
                    $('#business-name').val(payor.info_name);
                    $('#business-attention').val(payor.info_attn);
                    $('#business-address').val(payor.info_street);
                    $('#business-city').val(payor.info_city);
                    $('#business-state').val(payor.info_state);
                    $('#business-zip-code').val(payor.info_zip);

                  } else {

                    $('#show-business-information').prop('checked', false);
                    $('#business-information').hide();
                    $('#business-information input').removeAttr('value');

                  }

                  if (payor.type == 'BUSINESS') {

                    $('#contact-information-checkbox').show();
                    $('#business-attention').parent('.form-field').show();

                    $('#show-contact-information').prop('checked', false);
                    $('#contact-information').hide();
                    $('#contact-information input').removeAttr('value');

                  } else {

                    $('#contact-information-checkbox').hide();
                    $('#business-attention').parent('.form-field').hide();

                  }

                  window.history.replaceState('', '', '?subscription=' + thisSubscription);
                  $('.card-content-overlay').removeClass('card-content-overlay-active');

                },
                error: function (results) {
                  console.log('error!', results);
                  $('.card-content-overlay').removeClass('card-content-overlay-active');
                }
              });

            } else {
              $('.card-content-overlay').removeClass('card-content-overlay-active');
            }
          });

        } else {

          $('.card-content').append('<div class="card-content-error">You don\'t have any subscriptions.</div>');
          $('.card-content-overlay').removeClass('card-content-overlay-active');

        }

      },
      error: function (results) {
        console.log(results);
      }
    });

    $('#subscription').change(function () {

      var thisSubscription = this.value;
      $('.card-content-overlay').addClass('card-content-overlay-active');

      $.ajax({
        type: 'post',
        url: '/wp-admin/admin-ajax.php',
        data: {
          action: 'chirp_graphql',
          authorization: graphQLAuth,
          nonce: graphQLNonce,
          graphql_request: "query getSubscription($subscription_id: String!) { getSubscription(subscription_id: $subscription_id) { id, payor { id, type, status, contact_notes, cognito_sub, billing_firstname, billing_lastname, billing_phone, billing_email, billing_street, billing_city, billing_state, billing_zip, info_name, info_attn, info_street, info_city, info_state, info_zip, created_at, updated_at } } }",
          graphql_variables: JSON.stringify({
            "subscription_id": thisSubscription
          })
        },
        success: function (results) {

          let { data, errors } = JSON.parse(results);

          console.log('success!', data);

          $('#subscription option[value="' + data.getSubscription.id + '"]').prop('selected', true);

          var payor = data.getSubscription.payor;

          $('#payor-fields').show();

          $('#payor-id').val(payor.id);
          $('#payor-type').val(payor.type);
          $('#first-name').val(payor.billing_firstname);
          $('#last-name').val(payor.billing_lastname);
          $('#email-address').val(payor.billing_email);
          $('#phone-number').val(payor.billing_phone);
          $('#street-address').val(payor.billing_street);
          $('#city').val(payor.billing_city);
          $('#state').val(payor.billing_state);
          $('#zip-code').val(payor.billing_zip);

          if (payor.info_name || payor.info_attn || payor.info_street || payor.info_city || payor.info_state || payor.info_zip) {

            $('#show-business-information').prop('checked', true);
            $('#business-information').show();
            $('#business-name').val(payor.info_name);
            $('#business-attention').val(payor.info_attn);
            $('#business-address').val(payor.info_street);
            $('#business-city').val(payor.info_city);
            $('#business-state').val(payor.info_state);
            $('#business-zip-code').val(payor.info_zip);

          } else {

            $('#show-business-information').prop('checked', false);
            $('#business-information').hide();
            $('#business-information input').removeAttr('value');

          }

          if (payor.type == 'BUSINESS') {

            $('#contact-information-checkbox').show();
            $('#business-attention').parent('.form-field').show();

            $('#show-contact-information').prop('checked', false);
            $('#contact-information').hide();
            $('#contact-information input').removeAttr('value');

          } else {

            $('#contact-information-checkbox').hide();
            $('#business-attention').parent('.form-field').hide();

          }

          window.history.replaceState('', '', '?subscription=' + thisSubscription);
          $('.card-content-overlay').removeClass('card-content-overlay-active');

        },
        error: function (results) {
          console.log('error!', results);
          $('.card-content-overlay').removeClass('card-content-overlay-active');
        }
      });

    });

    // toggle alternate contact information fields
    $('#show-contact-information').change(function () {
      if ($(this).is(':checked')) {
        $('#contact-information').show();
      } else {
        $('#contact-information').hide();
      }
    });
    $('#show-business-information').change(function () {
      if ($(this).is(':checked')) {
        $('#business-information').show();
      } else {
        $('#business-information').hide();
      }
    });

    // update billing information
    $('#update-payor').validate({
      // debug: true,
      errorElement: 'span',
      errorClass: 'form-field-error',
      validClass: 'form-field-valid',
      errorPlacement: function (error, element) {
        error.appendTo(element.parent('.form-field'));
      },
      highlight: function (element, errorClass, validClass) {
        $(element).parent('.form-field').addClass(errorClass).removeClass(validClass);
      },
      unhighlight: function (element, errorClass, validClass) {
        $(element).parent('.form-field').removeClass(errorClass).addClass(validClass);
      },
      rules: {
        'subscription': {
          required: true
        },
        'first-name': {
          required: true,
          minlength: 2
        },
        'last-name': {
          required: true,
          minlength: 2
        },
        'email-address': {
          required: true,
          email: true
        },
        'phone-number': {
          required: true,
          phoneUS: true
        },
        'street-address': {
          required: true,
          minlength: 2
        },
        'city': {
          required: true,
          minlength: 2
        },
        'state': {
          required: true,
        },
        'zip-code': {
          required: true,
          zipcodeUS: true
        }
      },
      messages: {
        'subscription': {
          required: 'Please choose a subscription.'
        },
        'first-name': {
          required: 'Please enter your first name.',
          minlength: 'Your first name must be at least 2 characters long.'
        },
        'last-name': {
          required: 'Please enter your last name.',
          minlength: 'Your last name must be at least 2 characters long.'
        },
        'email-address': {
          required: 'Please enter your email address.',
          email: 'Please enter a valid email address.'
        },
        'phone-number': {
          required: 'Please enter your phone number.',
          phoneUS: 'Please enter a valid phone number.'
        },
        'street-address': {
          required: 'Please enter your street address.',
          minlength: '2'
        },
        'city': {
          required: 'Please enter your city.',
          minlength: '2'
        },
        'state': {
          required: 'Please enter your state.',
        },
        'zip-code': {
          required: 'Please enter your zip code.',
          zipcodeUS: 'Please enter a valid zip code. '
        }
      },
      submitHandler: function (form) {

        $('.button-spinner', form).prop('disabled', true);

        var payor = new Object();
        payor.id = $('#payor-id').val();
        payor.type = $('#payor-type').val();
        payor.billing_firstname = $('#first-name').val();
        payor.billing_lastname = $('#last-name').val();
        payor.billing_phone = $('#phone-number').val();
        payor.billing_street = $('#street-address').val();
        payor.billing_city = $('#city').val();
        payor.billing_state = $('#state').val();
        payor.billing_zip = $('#zip-code').val();

        if ($('#show-business-information').is(':checked')) {
          payor.billing_company_name = $('#business-name').val();
          payor.billing_attn = $('#business-attention').val();
          payor.info_street = $('#business-address').val();
          payor.info_city = $('#business-city').val();
          payor.info_state = $('#business-state').val();
          payor.info_zip = $('#business-zip-code').val();
        }

        $.ajax({
          type: 'post',
          url: '/wp-admin/admin-ajax.php',
          data: {
            action: 'chirp_graphql',
            authorization: graphQLAuth,
            nonce: graphQLNonce,
            graphql_request: 'mutation updatePayor($payor: UpdatePayorInput!) { updatePayor(payor: $payor) { id, type, status, contact_notes, cognito_sub, billing_firstname, billing_lastname, billing_phone, billing_email, billing_street, billing_city, billing_state, billing_zip, billing_company_name, billing_attn, info_street, info_city, info_state, info_zip, created_at, updated_at } }',
            graphql_variables: JSON.stringify({
              'payor': payor
            })
          },
          success: function (results) {

            let { data, errors } = JSON.parse(results);

            console.log('success!', data);

            if (data.updatePayor) {

              $('.button-spinner', form).prop('disabled', false);
              $('.form-card-message', form).empty().removeClass('form-card-message-error').addClass('form-card-message-success').text(payor.billing_firstname + ' ' + payor.billing_lastname + '\'s profile has been updated!');

            } else {

              $('.button-spinner', form).prop('disabled', false);
              $('.form-card-message', form).empty().removeClass('form-card-message-error').addClass('form-card-message-success').text('Something went wrong? Please try again.');

            }

          },
          error: function (results) {
            console.log('error!', results);
            $('.button-spinner', form).prop('disabled', false);
            $('.form-card-message', form).empty().removeClass('form-card-message-error').addClass('form-card-message-success').text('Something went wrong? Please try again.');
          }
        });

      }
    });
  }

  /*** monthly :: manage parkers ***/
  if ($('body').hasClass('page-template-page-account-monthly-parkers')) {
    function surveyQuestionFunctionality() {

      var form = $('#termination-survey');

      // show 'next question' when you choose the corresponding select option
      $(form).on('change', '.form-field-parent select', function () {
        var question = this.name;
        var id = $('option:selected', this).attr('id');
        $('.form-field-child[data-parent-question="' + question + '"]').hide();
        $('.form-field-child[data-parent-option="' + id + '"]').show();
      });

      // show 'next question' when you choose the corresponding radio button
      $(form).on('change', '.form-field-parent input[type="radio"]', function () {
        var question = this.name;
        var id = this.id;
        $('.form-field-child[data-parent-question="' + question + '"]').hide();
        $('.form-field-child[data-parent-option="' + id + '"]').show();
      });

    }

    function surveyQuestions(questions, type, target) {

      var questions = questions;
      var type = type;

      // get templates from html
      var radioTemplate = $('#termination-survey-radio').html();
      var radioButtonTemplate = $('#termination-survey-radio-button').html();
      var selectTemplate = $('#termination-survey-select').html();
      var selectOptionTemplate = $('#termination-survey-select-option').html();
      var textTemplate = $('#termination-survey-text').html();

      // loop through questions and apply correct template
      $(questions).each(function (index) {
        if (this.type == type) {
          var questionCount = index;
          var nextQuestions = new Array();
          var nextQuestionCount = 0;
          if (this.structure.type == 'RADIO') {
            var question = $(radioTemplate);
            question.addClass('form-field-parent');
            $('.prompt', question).text(this.structure.prompt);
            $(this.structure.options).each(function (index) {
              var optionCount = index;
              var option = $(radioButtonTemplate);
              $('input[type="radio"]', option).attr({ name: 'question-' + questionCount, id: 'question-' + questionCount + '-option-' + optionCount, value: this.response });
              $('.radio-button-label', option).attr('for', 'question-' + questionCount + '-option-' + optionCount).text(this.response);
              if (optionCount == 0) {
                $('input[type="radio"]', option).prop('checked', true);
              }
              $('.radio-buttons-group', question).append(option);
              if (this.next_question) {
                if (this.next_question.type == 'RADIO') {
                  var nextQuestion = $(radioTemplate);
                  $(nextQuestion).addClass('form-field-child form-field-optional').attr({ 'data-parent-question': 'question-' + questionCount, 'data-parent-option': 'question-' + questionCount + '-option-' + optionCount });
                  if (optionCount == 0) {
                    $(nextQuestion).css('display', 'block');
                  }
                  $('.prompt', nextQuestion).text(this.next_question.prompt);
                  $(this.next_question.options).each(function (index) {
                    var optionCount = index;
                    var option = $(radioButtonTemplate);
                    $('input[type="radio"]', option).attr({ name: 'question-' + questionCount + '-' + nextQuestionCount, id: 'question-' + questionCount + '-' + nextQuestionCount + '-option-' + optionCount, value: this.response });
                    $('.radio-button-label', option).attr('for', 'question-' + questionCount + '-' + nextQuestionCount + '-option-' + optionCount).text(this.response);
                    if (optionCount == 0) {
                      $('input[type="radio"]', option).prop('checked', true);
                    }
                    $('.radio-buttons-group', nextQuestion).append(option);
                  });
                  nextQuestions.push(nextQuestion);
                } else if (this.next_question.type == 'SELECT') {
                  var nextQuestion = $(selectTemplate);
                  $(nextQuestion).addClass('form-field-child form-field-optional').attr({ 'data-parent-question': 'question-' + questionCount, 'data-parent-option': 'question-' + questionCount + '-option-' + optionCount });
                  if (optionCount == 0) {
                    $(nextQuestion).css('display', 'block');
                  }
                  $('.prompt', nextQuestion).text(this.next_question.prompt).attr('for', 'question-' + questionCount + '-' + nextQuestionCount);
                  $('select', nextQuestion).attr('name', 'question-' + questionCount + '-' + nextQuestionCount).attr('id', 'question-' + questionCount + '-' + nextQuestionCount);
                  $(this.next_question.options).each(function (index) {
                    var option = $(selectOptionTemplate);
                    $(option).attr('value', this.response).text(this.response);
                    $('select', nextQuestion).append(option);
                  });
                  nextQuestions.push(nextQuestion);
                } else if (this.next_question.type == 'TEXT') {
                  var nextQuestion = $(textTemplate);
                  $(nextQuestion).addClass('form-field-child form-field-optional').attr({ 'data-parent-question': 'question-' + questionCount, 'data-parent-option': 'question-' + questionCount + '-option-' + optionCount });
                  if (optionCount == 0) {
                    $(nextQuestion).css('display', 'block');
                  }
                  $('.prompt', nextQuestion).text(this.next_question.prompt).attr('for', 'question-' + questionCount + '-' + nextQuestionCount);
                  $('input[type="text"]', nextQuestion).attr({ name: 'question-' + questionCount + '-' + nextQuestionCount, id: 'question-' + questionCount + '-' + nextQuestionCount });
                  nextQuestions.push(nextQuestion);
                }
                nextQuestionCount++;
              }
            });
          } else if (this.structure.type == 'SELECT') {
            var question = $(selectTemplate);
            question.addClass('form-field-parent');
            $('.prompt', question).text(this.structure.prompt).attr('for', 'question-' + questionCount);
            $('select', question).attr('name', 'question-' + questionCount).attr('id', 'question-' + questionCount);
            $(this.structure.options).each(function (index) {
              var optionCount = index;
              var option = $(selectOptionTemplate);
              $(option).attr({ value: this.response, id: 'question-' + questionCount + '-option-' + optionCount }).text(this.response);
              $('select', question).append(option);
              if (this.next_question) {
                if (this.next_question.type == 'RADIO') {
                  var nextQuestion = $(radioTemplate);
                  $(nextQuestion).addClass('form-field-child form-field-optional').attr({ 'data-parent-question': 'question-' + questionCount, 'data-parent-option': 'question-' + questionCount + '-option-' + optionCount });
                  $('.prompt', nextQuestion).text(this.next_question.prompt);
                  $(this.next_question.options).each(function (index) {
                    var optionCount = index;
                    var option = $(radioButtonTemplate);
                    $('input[type="radio"]', option).attr({ name: 'question-' + questionCount + '-' + nextQuestionCount, id: 'question-' + questionCount + '-' + nextQuestionCount + '-option-' + optionCount, value: this.response });
                    $('.radio-button-label', option).attr('for', 'question-' + questionCount + '-' + nextQuestionCount + '-option-' + optionCount).text(this.response);
                    if (optionCount == 0) {
                      $('input[type="radio"]', option).prop('checked', true);
                    }
                    $('.radio-buttons-group', nextQuestion).append(option);
                  });
                  nextQuestions.push(nextQuestion);
                } else if (this.next_question.type == 'SELECT') {
                  var nextQuestion = $(selectTemplate);
                  $(nextQuestion).addClass('form-field-child form-field-optional').attr({ 'data-parent-question': 'question-' + questionCount, 'data-parent-option': 'question-' + questionCount + '-option-' + optionCount });
                  $('.prompt', nextQuestion).text(this.next_question.prompt).attr('for', 'question-' + questionCount + '-' + nextQuestionCount);
                  $('select', nextQuestion).attr('name', 'question-' + questionCount + '-' + nextQuestionCount).attr('id', 'question-' + questionCount + '-' + nextQuestionCount);
                  $(this.next_question.options).each(function (index) {
                    var option = $(selectOptionTemplate);
                    $(option).attr('value', this.response).text(this.response);
                    $('select', nextQuestion).append(option);
                  });
                  nextQuestions.push(nextQuestion);
                } else if (this.next_question.type == 'TEXT') {
                  var nextQuestion = $(textTemplate);
                  $(nextQuestion).addClass('form-field-child form-field-optional').attr({ 'data-parent-question': 'question-' + questionCount, 'data-parent-option': 'question-' + questionCount + '-option-' + optionCount });
                  $('.prompt', nextQuestion).text(this.next_question.prompt).attr('for', 'question-' + questionCount + '-' + nextQuestionCount);
                  $('input[type="text"]', nextQuestion).attr({ name: 'question-' + questionCount + '-' + nextQuestionCount, id: 'question-' + questionCount + '-' + nextQuestionCount });
                  nextQuestions.push(nextQuestion);
                }
                nextQuestionCount++;
              }
            });
          } else if (this.structure.type == 'TEXT') {
            var question = $(textTemplate);
            question.addClass('form-field-parent');
            $('.prompt', question).text(this.structure.prompt).attr('for', 'question-' + questionCount);
            $('input[type="text"]', question).attr({ name: 'question-' + questionCount, id: 'question-' + questionCount });
          }
        }
        $(target).append(question);
        if (nextQuestions) {
          $(target).append(nextQuestions);
        }
      });
      surveyQuestionFunctionality();
    }

    var thisSubscription = getUrlParameter('subscription');
    var thisParker = getUrlParameter('parker');
    var thisAdd = getUrlParameter('add');
    var thisEdit = getUrlParameter('edit');
    var thisBarcode = getUrlParameter('barcode');
    var accessDevices = [];

    if (thisSubscription.length > 0) {

      if (thisParker.length > 0) {

        $.ajax({
          type: 'post',
          url: '/wp-admin/admin-ajax.php',
          data: {
            action: 'chirp_graphql',
            authorization: graphQLAuth,
            nonce: graphQLNonce,
            graphql_request: "query getSubscription($subscription_id: String!) { getSubscription(subscription_id: $subscription_id) { id, auto_pay, mail_invoices, billing_profile { id, billing_day, termination_notice_day, facility { id, uid, facility_name, timezone, integration }, survey_questions { id, billing_profile_id, order, type, structure } }, parkers { id, barcode, subscription_id, rate_id, first_name, last_name, email, address, city, state, zip, country_code, phone, vehicles { id, parker_id, license, make, model, state, color, decal } }, payor { id, cognito_sub, billing_firstname, billing_lastname } } }",
            graphql_variables: JSON.stringify({
              subscription_id: thisSubscription
            })
          },
          success: function (results) {

            let { data, errors } = JSON.parse(results);

            console.log('success!', data);

            if (data.getSubscription.parkers.length > 0) {

              var subscription = data.getSubscription;
              var parkers = subscription.parkers;
              var matchIndex;

              parkers.forEach(function (parker, index) {
                if (thisParker == parker.id) {
                  return matchIndex = index;
                }
              });

              if (matchIndex > -1) {
                var matchParker = parkers[matchIndex];

                if (thisEdit.length > 0) {

                  // edit parker functionality
                  $('#first-name').val(matchParker.first_name);
                  $('#last-name').val(matchParker.last_name);
                  $('#email-address').val(matchParker.email);
                  $('#country-code').val(matchParker.country_code);
                  $('#phone-number').val(matchParker.phone);
                  $('#street-address').val(matchParker.address);
                  $('#city').val(matchParker.city);
                  $('#state').val(matchParker.state);
                  $('#zip-code').val(matchParker.zip);

                  const facilityIntegration = subscription?.billing_profile?.facility.integration;

                  $('#facility-integration').val(facilityIntegration);
                  $('#rate-id').val(matchParker.rate_id);
                  $('#parking-reason').val(matchParker.parking_reason);

                  if (matchParker.vehicles.length > 0) {
                    var vehicles = matchParker.vehicles;

                    vehicles.forEach(function (vehicle, index) {
                      if (index == 0) {
                        $('#vehicle-make-' + index).val(vehicle.make).prop('disabled', true);
                        $('#vehicle-model-' + index).val(vehicle.model).prop('disabled', true);
                        $('#vehicle-state-' + index).val(vehicle.state).prop('disabled', true);
                        $('#vehicle-plate-number-' + index).val(vehicle.license).prop('disabled', true);
                        $('#vehicle-color-' + index).val(vehicle.color).prop('disabled', true);
                        $('#vehicle-decal-' + index).val(vehicle.decal).prop('disabled', true);
                      } else {
                        var template = '<div class="form-field form-field-group form-field-group-outlined form-field-group-vehicle" id="vehicle-' + index + '">' +
                          '<div class="form-field">' +
                          '<label class="form-field-label" for="vehicle-make-' + index + '">Vehicle Make</label>' +
                          '<input disabled type="text" name="vehicle-make" id="vehicle-make-' + index + '" value="' + vehicle.make + '" />' +
                          '</div>' +
                          '<div class="form-field">' +
                          '<label class="form-field-label" for="vehicle-model-' + index + '">Vehicle Model</label>' +
                          '<input disabled type="text" name="vehicle-model" id="vehicle-model-' + index + '" value="' + vehicle.model + '" />' +
                          '</div>' +
                          '<div class="form-field">' +
                          '<label class="form-field-label" for="vehicle-state-' + index + '">License Plate State</label>' +
                          '<div class="select-wrapper">' +
                          `<select disabled name="vehicle-state" id="vehicle-state-${index}" data-cy="vehicle-state-select-${index}"/>
                            <option value="" ${!vehicle.state ? 'selected' : ''}>Select a state</option>
                            <option value="Alabama" ${vehicle.state === 'Alabama' ? 'selected' : ''}>Alabama</option>
                            <option value="Alaska" ${vehicle.state === 'Alaska' ? 'selected' : ''}>Alaska</option>
                            <option value="Arizona"${vehicle.state === 'Arizona' ? 'selected' : ''}>Arizona</option>
                            <option value="Arkansas" ${vehicle.state === 'Arkansas' ? 'selected' : ''}>Arkansas</option>
                            <option value="California" ${vehicle.state === 'California' ? 'selected' : ''}>California</option>
                            <option value="Colorado" ${vehicle.state === 'Colorado' ? 'selected' : ''}>Colorado</option>
                            <option value="Connecticut" ${vehicle.state === 'Connecticut' ? 'selected' : ''}>Connecticut</option>
                            <option value="Delaware" ${vehicle.state === 'Delaware' ? 'selected' : ''}>Delaware</option>
                            <option value="District of Columbia" ${vehicle.state === 'District of Columbia' ? 'selected' : ''}>District of Columbia</option>
                            <option value="Florida" ${vehicle.state === 'Florida' ? 'selected' : ''}>Florida</option>
                            <option value="Georgia" ${vehicle.state === 'Georgia' ? 'selected' : ''}>Georgia</option>
                            <option value="Hawaii" ${vehicle.state === 'Hawaii' ? 'selected' : ''}>Hawaii</option>
                            <option value="Idaho" ${vehicle.state === 'Idaho' ? 'selected' : ''}>Idaho</option>
                            <option value="Illinois" ${vehicle.state === 'Illinois' ? 'selected' : ''}>Illinois</option>
                            <option value="Indiana" ${vehicle.state === 'Indiana' ? 'selected' : ''}>Indiana</option>
                            <option value="Iowa" ${vehicle.state === 'Iowa' ? 'selected' : ''}>Iowa</option>
                            <option value="Kansas" ${vehicle.state === 'Kansas' ? 'selected' : ''}>Kansas</option>
                            <option value="Kentucky" ${vehicle.state === 'Kentucky' ? 'selected' : ''}>Kentucky</option>
                            <option value="Louisiana" ${vehicle.state === 'Louisiana' ? 'selected' : ''}>Louisiana</option>
                            <option value="Maine" ${vehicle.state === 'Maine' ? 'selected' : ''}>Maine</option>
                            <option value="Maryland" ${vehicle.state === 'Maryland' ? 'selected' : ''}>Maryland</option>
                            <option value="Massachusetts" ${vehicle.state === 'Massachusetts' ? 'selected' : ''}>Massachusetts</option>
                            <option value="Michigan" ${vehicle.state === 'Michigan' ? 'selected' : ''}>Michigan</option>
                            <option value="Minnesota" ${vehicle.state === 'Minnesota' ? 'selected' : ''}>Minnesota</option>
                            <option value="Mississippi" ${vehicle.state === 'Mississippi' ? 'selected' : ''}>Mississippi</option>
                            <option value="Missouri" ${vehicle.state === 'Missouri' ? 'selected' : ''}>Missouri</option>
                            <option value="Montana" ${vehicle.state === 'Montana' ? 'selected' : ''}>Montana</option>
                            <option value="Nebraska" ${vehicle.state === 'Nebraska' ? 'selected' : ''}>Nebraska</option>
                            <option value="Nevada" ${vehicle.state === 'Nevada' ? 'selected' : ''}>Nevada</option>
                            <option value="New Hampshire" ${vehicle.state === 'New Hampshire' ? 'selected' : ''}>New Hampshire</option>
                            <option value="New Jersey" ${vehicle.state === 'New Jersey' ? 'selected' : ''}>New Jersey</option>
                            <option value="New Mexico" ${vehicle.state === 'New Mexico' ? 'selected' : ''}>New Mexico</option>
                            <option value="New York" ${vehicle.state === 'New York' ? 'selected' : ''}>New York</option>
                            <option value="North Carolina" ${vehicle.state === 'North Carolina' ? 'selected' : ''}>North Carolina</option>
                            <option value="North Dakota" ${vehicle.state === 'North Dakota' ? 'selected' : ''}>North Dakota</option>
                            <option value="Ohio" ${vehicle.state === 'Ohio' ? 'selected' : ''}>Ohio</option>
                            <option value="Oklahoma" ${vehicle.state === 'Oklahoma' ? 'selected' : ''}>Oklahoma</option>
                            <option value="Oregon" ${vehicle.state === 'Oregon' ? 'selected' : ''}>Oregon</option>
                            <option value="Pennsylvania" ${vehicle.state === 'Pennsylvania' ? 'selected' : ''}>Pennsylvania</option>
                            <option value="Rhode Island" ${vehicle.state === 'Rhode Island' ? 'selected' : ''}>Rhode Island</option>
                            <option value="South Carolina" ${vehicle.state === 'South Carolina' ? 'selected' : ''}>South Carolina</option>
                            <option value="South Dakota" ${vehicle.state === 'South Dakota' ? 'selected' : ''}>South Dakota</option>
                            <option value="Tennessee" ${vehicle.state === 'Tennessee' ? 'selected' : ''}>Tennessee</option>
                            <option value="Texas" ${vehicle.state === 'Texas' ? 'selected' : ''}>Texas</option>
                            <option value="Utah" ${vehicle.state === 'Utah' ? 'selected' : ''}>Utah</option>
                            <option value="Vermont" ${vehicle.state === 'Vermont' ? 'selected' : ''}>Vermont</option>
                            <option value="Virginia" ${vehicle.state === 'Virginia' ? 'selected' : ''}>Virginia</option>
                            <option value="Washington" ${vehicle.state === 'Washington' ? 'selected' : ''}>Washington</option>
                            <option value="West Virginia" ${vehicle.state === 'West Virginia' ? 'selected' : ''}>West Virginia</option>
                            <option value="Wisconsin" ${vehicle.state == 'Wisconsin' ? 'selected' : ''}>Wisconsin</option>
                            <option value="Wyoming" ${vehicle.state === 'Wyoming' ? 'selected' : ''}>Wyoming</option>
                          </select>` +
                          '</div>' +
                          '</div>' +
                          '<div class="form-field">' +
                          '<label class="form-field-label" for="vehicle-plate-number-' + index + '">License Plate</label>' +
                          '<input disabled type="text" name="vehicle-plate-number" id="vehicle-plate-number-' + index + '" value="' + vehicle.license + '" />' +
                          '</div>' +
                          '<div class="form-field">' +
                          '<label class="form-field-label" for="vehicle-color-' + index + '">Vehicle Color</label>' +
                          '<input disabled type="text" name="vehicle-color" id="vehicle-color-' + index + '" value="' + vehicle.color + '" />' +
                          '</div>' +
                          '<div class="form-field">' +
                          '<label class="form-field-label" for="vehicle-decal-' + index + '">Vehicle Decal</label>' +
                          '<input disabled type="text" name="vehicle-decal" id="vehicle-decal-' + index + '" value="' + vehicle.decal + '" />' +
                          '</div>' +
                          '<div class="form-field">' +
                          '<button class="button button-small button-red vehicle-delete">Delete This Vehicle</button>' +
                          '</div>' +
                          '</div>';

                        $('.form-field-group-vehicles').append(template);
                      }
                    });
                  }
                } else if (thisBarcode.length > 0) {
                  // View Barcode functionality
                  var facilityName = 'FACILITY NAME';
                  if (subscription.billing_profile.facility) {
                    facilityName = subscription.billing_profile.facility.facility_name;
                  }

                  $('.card-header-title').text(matchParker.first_name + ' ' + matchParker.last_name);
                  $('.card-header-text p').text('Monthly Parking at ' + facilityName);

                  if (matchParker.barcode.length) {
                    var target = document.getElementById('barcode');
                    new QRCode(target, {
                      text: matchParker.barcode,
                      width: 150,
                      height: 150,
                      colorDark: '#000000',
                      colorLight: '#FFFFFF',
                      correctLevel: QRCode.CorrectLevel.H
                    });

                    $('#email-barcode-email').val(matchParker.email);

                    function getBarcodePass(passType) {
                      $(`#add-to-${passType}-wallet`).hide();
                      $('#apple-wallet-error').hide();
                      $('#google-wallet-error').hide();
                      $(`#${passType}-wallet-spinner`).prop('disabled', true);

                      $.ajax({
                        type: 'post',
                        url: '/wp-admin/admin-ajax.php',
                        data: {
                          action: 'chirp_download_barcode_pass',
                          authorization: graphQLAuth,
                          nonce: graphQLNonce,
                          passType,
                          parkerId: matchParker.id,
                        },
                        success: function (results) {
                          const { isError, body } = JSON.parse(results);
                          if (isError) {
                            console.log(body);
                            $(`#${passType}-wallet-error`).show();
                            return;
                          }

                          const link = document.createElement('a');
                          if (passType === 'apple') {
                            link.href = `data:application/vnd.apple.pkpass;base64,${body}`;
                            link.download = 'Barcode.pkpass';
                          } else if (passType === 'google') {
                            link.href = body;
                          }
                          link.click();
                        },
                        error: function () {
                          console.log(`Ajax error retrieving ${passType} wallet pass`);
                          $(`#${passType}-wallet-error`).show();
                        },
                        complete: function () {
                          $(`#add-to-${passType}-wallet`).show();
                          $(`#${passType}-wallet-spinner`).prop('disabled', false);
                        }
                      });
                    }

                    $('#add-to-apple-wallet').on('click', function () {
                      getBarcodePass('apple');
                    });

                    $('#add-to-google-wallet').on('click', function () {
                      getBarcodePass('google');
                    });

                    $('#send-barcode-email').on('click', function () {
                      $('#send-barcode-email').hide();
                      $('#email-barcode-spinner').show();
                      $('#email-barcode-success').hide();
                      $('#email-barcode-error').hide();

                      $.ajax({
                        type: 'post',
                        url: '/wp-admin/admin-ajax.php',
                        data: {
                          action: 'chirp_graphql',
                          authorization: graphQLAuth,
                          nonce: graphQLNonce,
                          graphql_request: 'mutation sendBarcodeEmail($parkerId: String!, $emailAddress: String!) { sendBarcodeEmail(parkerId: $parkerId, emailAddress: $emailAddress) }',
                          graphql_variables: JSON.stringify({
                            parkerId: matchParker.id,
                            emailAddress: $('#email-barcode-email').val()
                          }),
                        },
                        success: function (results) {
                          const { errors } = JSON.parse(results);

                          if (errors) {
                            console.log(errors);
                            $('#email-barcode-error').show().attr('data-cy', 'email-barcode-error-text');
                          } else {
                            $('#email-barcode-success').show().attr('data-cy', 'email-barcode-success-text');
                            $('#email-barcode-email').val('');
                          }
                        },
                        error: function (results) {
                          console.log(results);
                          $('#email-barcode-error').show();
                        },
                        complete: function () {
                          $('#send-barcode-email').show();
                          $('#email-barcode-spinner').hide();
                        }
                      });
                    });
                  }
                }
                $('.card-content-overlay').removeClass('card-content-overlay-active');
              } else {
                console.log('No parkers matched the supplied Parker ID?');
                $('.card-content-overlay').removeClass('card-content-overlay-active');
              }
            } else {
              console.log('There are no parkers for this subscription.');
            }
          },
          error: function (results) {
            console.log('error!', results);
          }
        });
      } else if (thisAdd) {
        $.ajax({
          type: 'post',
          url: '/wp-admin/admin-ajax.php',
          data: {
            action: 'chirp_graphql',
            authorization: graphQLAuth,
            nonce: graphQLNonce,
            api_version: 'v2',
            // graphql_request: "query($subscription_id: String!) { getAvailableRatesForSubscription(subscription_id: $subscription_id) { id, name } }",
            graphql_request: "query GetRatesForSubscriptionViaMyAccountPage($subscriptionId: String!, $display: RateDisplayEnum2) { getRatesBySubscription(subscriptionId: $subscriptionId, display: $display) { id, name, childRateStartDate, childRateEndDate, active, onlineEndDate, requireCarInfo } }",
            graphql_variables: JSON.stringify({
              "subscriptionId": thisSubscription,
              "display": "Yes"
            })
          },
          success: function (results) {

            let { data, errors } = JSON.parse(results);

            console.log('success!', data);
            if (data.getRatesBySubscription.length > 0) {
              var rates = data.getRatesBySubscription;

              const filteredRateData = rates.filter((rate) => {
                if (rate.childRateStartDate) {
                  const childStartDate = moment.utc(rate.childRateStartDate).startOf('day');
                  const childEndDate = rate.childEndDate ? moment.utc(rate.childRateEndDate).endOf('day') : moment().add(1, 'years');
                  const isBillingStartDateBetweenChildRateStartAndEnd = moment().isBetween(
                    childStartDate,
                    childEndDate,
                    'day',
                    '[]',
                  );
                  
                  return isBillingStartDateBetweenChildRateStartAndEnd;
                }

                if (!rate.active || (rate.onlineEndDate && moment.utc(rate.onlineEndDate).isSameOrBefore(moment()))) {
                  return false;
                }

                return true;
              });

              filteredRateData.forEach(function (rate) {
                const option = $('<option>')
                  .val(rate.id)
                  .text(rate.name)
                  .attr('data-requires-car-info', rate.requireCarInfo === 'REQUIRED');

                $('select[name="rate"]').append(option);
              });

              $('select[name="rate"]').change(function () {
              const selectedOption = $(this).find('option:selected');
              const requiresCarInfo = selectedOption.data('requires-car-info') === true;
              
              if (requiresCarInfo) {
                $('.form-field-group-title').html('Vehicles <span style="color: red;">*</span>');
              } else {
                $('.form-field-group-title').text('Vehicles');
              }

              if (requiresCarInfo) {
                $('.vehicle-delete').hide();
              } else {
                $('.vehicle-delete').show();
              }

              const fieldsToToggle = [
                '#vehicle-make-0',
                '#vehicle-model-0',
                '#vehicle-state-0',
                '#vehicle-plate-number-0',
                '#vehicle-color-0'
              ];

              fieldsToToggle.forEach(function (selector) {
                if (requiresCarInfo) {
                  $(selector).attr('required', true);
                } else {
                  $(selector).removeAttr('required');
                }
              });
            });

              $('#start-date').change(function () {
                const dateSelected = $(this).val();
                $('select[name="rate"]').empty();
                const filteredRateData = rates.filter((rate) => {
                  const dateToCompareTo = moment.utc(dateSelected).startOf('day').format();

                  if (rate.childRateStartDate) {
                    const childStartDate = moment.utc(rate.childRateStartDate).startOf('day');
                    const childEndDate = rate.childRateEndDate ? moment.utc(rate.childRateEndDate).endOf('day') : moment().add(1, 'years');
                    const isBillingStartDateBetweenChildRateStartAndEnd = moment.utc(dateToCompareTo).isBetween(
                      childStartDate,
                      childEndDate,
                      'day',
                      '[]',
                    );
                    return isBillingStartDateBetweenChildRateStartAndEnd
                  }

                  if (!rate.active || (rate.onlineEndDate && moment.utc(rate.onlineEndDate).isSameOrBefore(dateToCompareTo))) {
                    return false;
                  }

                  return true;
                });
                $('select[name="rate"]').append('<option value="#" selected disabled>Choose One...</option>');

                filteredRateData.forEach(function (rate) {

                  var option = '<option value="' + rate.id + '">' + rate.name + '</option>';

                  $('select[name="rate"]').append(option);

                });
              });


            } else {
              console.log('No rates available.')
              $('.card-content').append('<div class="card-content-error">No rates available.</div>');
            }
            $('.card-content-overlay').removeClass('card-content-overlay-active');
          },
          error: function (results) {
            console.log('error!', results);
          }
        });

        $.ajax({
          type: 'post',
          url: '/wp-admin/admin-ajax.php',
          data: {
            action: 'chirp_graphql',
            authorization: graphQLAuth,
            nonce: graphQLNonce,
            graphql_request: "query getSubscription($subscription_id: String!) { getSubscription(subscription_id: $subscription_id) { id, paymentMethod { token }, auto_pay, mail_invoices, billing_profile { id, billing_day, termination_notice_day, facility { id, facility_name, address, timezone, access_devices }, survey_questions { id, billing_profile_id, order, type, structure } }, parkers { id, barcode, first_name, last_name }, payor { id, cognito_sub, billing_firstname, billing_lastname } } }",
            graphql_variables: JSON.stringify({
              "subscription_id": thisSubscription
            })
          },
          success: function (results) {

            let { data, errors } = JSON.parse(results);

            console.log('success!', data);

            $('#payor-id').val(data.getSubscription.payor.id);
            $('#subscription-auto-pay').val(data.getSubscription.auto_pay);
            $('#subscription-mail-invoices').val(data.getSubscription.mail_invoices);
            $('#subscription-payment-method-id').val(data.getSubscription.paymentMethod?.token);

            accessDevices = data.getSubscription.billing_profile.facility.access_devices || [];
          },
          error: function (results) {
            console.log('error!', results);
          }
        });

      } else {
        const paymentProviderId = !/platinum|icon/.test(window.location.host) ? 1 : 2;
        $.ajax({
          type: 'post',
          url: '/wp-admin/admin-ajax.php',
          data: {
            action: 'chirp_graphql',
            authorization: graphQLAuth,
            nonce: graphQLNonce,
            graphql_request: "query listUserSubscriptions($exclude_validation_only: Boolean, $paymentProviderId: Int) { listUserSubscriptions(exclude_validation_only: $exclude_validation_only, paymentProviderId: $paymentProviderId) { id, account_id, billing_profile { id, validation_only, billing_day, termination_notice_day, terminationRule, facility { id, facility_name, address, timezone, myAccountFacilitySettings { showParkerTermination } } survey_questions { id, billing_profile_id, order, type, structure } }, parkers { id, suspension_status, termination_status, barcode, first_name, last_name, parker_status_history {action, start_date}}, payor { id, cognito_sub, billing_firstname, billing_lastname } } }",
            graphql_variables: JSON.stringify({
              exclude_validation_only: true,
              paymentProviderId
            })
          },
          success: function (results) {

            let { data, errors } = JSON.parse(results);

            console.log('success!', data);

            if (data.listUserSubscriptions.length > 0) {

              var subscriptions = data.listUserSubscriptions;

              subscriptions.forEach(function (subscription) {

                var facilityName = 'FACILITY NAME';
                if (subscription.billing_profile.facility) {
                  facilityName = subscription.billing_profile.facility.facility_name;
                }
                var option = '<option value="' + subscription.id + '" data-termination-day="' + subscription.billing_profile.termination_notice_day + '">' + 'Monthly Parking at ' + facilityName + '(AC-' + subscription.account_id + ')</option>';

                $('select[name="subscription"]').append(option);

                if (thisSubscription == subscription.id) {
                  $('select[name="subscription"]').val(subscription.id);

                  $('.parker-add').attr('href', '?subscription=' + thisSubscription + '&add=1').show();

                  var parkers = subscription.parkers;

                  if (parkers.length > 0) {

                    $('.transactions-group').prepend('<ol />');


                    parkers.forEach(function (parker, index) {
                      const isActive = (parker.suspension_status === 'ACTIVE' || parker.termination_status === 'ACTIVE')
                      const isTerminationPending = parker.termination_status === 'TERMINATION_PENDING';
                      const isShowTerminateButton = isActive && subscription.billing_profile.facility.myAccountFacilitySettings.showParkerTermination && (!feature_flags.FEATURE_MYACCOUNT || !isTerminationPending);

                      var template = `<li class="transaction" data-termination-day=${subscription.billing_profile.termination_notice_day} data-termination-rule=${subscription.billing_profile.terminationRule} data-subscription-id="${subscription.id}" data-parker-id="${parker.id}" data-parker-name="${parker.first_name} ${parker.last_name}" data-cy="parker-row-${index}">` +
                        '<div class="transaction-title">' +
                        '<a href="?subscription=' + subscription.id + '&parker=' + parker.id + '&edit=1" title="Edit ' + parker.first_name + ' ' + parker.last_name + '" data-cy="parker-name-link">' + parker.first_name + ' ' + parker.last_name + '</a>' +
                        '</div>' +
                        '<div class="transaction-actions">' +
                        (parker.barcode ? '<a href="?subscription=' + subscription.id + '&parker=' + parker.id + '&barcode=true" title="View ' + parker.first_name + ' ' + parker.last_name + '\'s Barcode" class="parker-barcode" data-cy="parker-barcode-link">View Barcode</a>' : '') +
                        (isShowTerminateButton ? '<a href="#" title="Delete ' + parker.first_name + ' ' + parker.last_name + '" class="parker-delete" data-cy="parker-terminate-link">Terminate</a>' : '') +
                        '</div>' +
                        '<div class="transaction-meta">' +
                        '<p data-cy="parker-status-text">' + getParkerStatusText(parker); + '</p>' +
                          '</div>' +
                          '</li>';

                      $('.transactions-group ol').append(template);

                    });

                    var questions = subscription.billing_profile.survey_questions;
                    if (questions.length) {
                      surveyQuestions(questions, 'TERMINATION', '#termination-survey-questions');
                    }

                  } else {

                    console.log('Successfully retrieved the subscription, but there are no parkers to display!');
                    $('.transactions-group').empty().append('<div class="card-content-error">There are no parkers for this subscription.</div>');

                  }

                }

              });

            } else {

              console.log('You don\'t have any subscriptions.')
              $('.card-content').append('<div class="card-content-error">You don\'t have any subscriptions.</div>')

            }

            $('.card-content-overlay').removeClass('card-content-overlay-active');

          },
          error: function (results) {
            console.log(results);
          }
        });

      }

    } else {
      const paymentProviderId = !/platinum|icon/.test(window.location.host) ? 1 : 2;
      $.ajax({
        type: 'post',
        url: '/wp-admin/admin-ajax.php',
        data: {
          action: 'chirp_graphql',
          authorization: graphQLAuth,
          nonce: graphQLNonce,
          graphql_request: "query listUserSubscriptions($exclude_validation_only: Boolean, $paymentProviderId: Int) { listUserSubscriptions(exclude_validation_only: $exclude_validation_only, paymentProviderId: $paymentProviderId) { id, account_id, billing_profile { id, validation_only, billing_day, termination_notice_day, terminationRule, facility { id, facility_name, address, timezone, myAccountFacilitySettings { showParkerTermination } } survey_questions { id, billing_profile_id, order, type, structure } }, parkers { id, suspension_status, termination_status, barcode, first_name, last_name, parker_status_history {action, start_date}}, payor { id, cognito_sub, billing_firstname, billing_lastname } } }",
          graphql_variables: JSON.stringify({
            exclude_validation_only: true,
            paymentProviderId
          })
        },
        success: function (results) {

          let { data, errors } = JSON.parse(results);

          console.log('success!', data);

          if (data.listUserSubscriptions.length > 0) {

            var subscriptions = data.listUserSubscriptions;

            $(subscriptions).each(function (index, subscription) {

              var facilityName = 'FACILITY NAME';
              if (subscription.billing_profile.facility) {
                facilityName = subscription.billing_profile.facility.facility_name;
              }
              var option = '<option value="' + subscription.id + '" data-termination-day="' + subscription.billing_profile.termination_notice_day + '">' + 'Monthly Parking at ' + facilityName + ' (AC-' + subscription.account_id + ')' + '</option>';
              $('select[name="subscription"]').append(option);

            });

            if (subscriptions.length == 1) {

              $('#subscription option:not([disabled])').prop('selected', true);
              var subscription = subscriptions[0];
              $('.parker-add').attr('href', '?subscription=' + thisSubscription + '&add=1').show();

              var parkers = subscription.parkers;

              if (parkers.length > 0) {

                $('.transactions-group').prepend('<ol />');

                parkers.forEach(function (parker) {
                  const isActive = (parker.suspension_status === 'ACTIVE' || parker.termination_status === 'ACTIVE');
                  const isTerminationPending = parker.termination_status === 'TERMINATION_PENDING';
                  const isShowTerminateButton = isActive && subscription.billing_profile.facility.myAccountFacilitySettings.showParkerTermination && (!feature_flags.FEATURE_MYACCOUNT || !isTerminationPending);

                  var template = `<li class="transaction" data-termination-day=${subscription.billing_profile.termination_notice_day} data-termination-rule=${subscription.billing_profile.terminationRule} data-subscription-id="${subscription.id}" data-parker-id="${parker.id}" data-parker-name="${parker.first_name} ${parker.last_name}">` +
                    '<div class="transaction-title">' +
                    `<a href="?subscription=${subscription.id}&parker=${parker.id}&edit=1" title="Edit ${parker.first_name} ${parker.last_name}" data-cy="parker-name-link">${parker.first_name} ${parker.last_name}</a>` +
                    '</div>' +
                    '<div class="transaction-actions">' +
                    (parker.barcode ? '<a href="?subscription=' + subscription.id + '&parker=' + parker.id + '&barcode=true" title="View ' + parker.first_name + ' ' + parker.last_name + '\'s Barcode" class="parker-barcode" data-cy="parker-barcode-link">View Barcode</a>' : '') +
                    (isShowTerminateButton ? '<a href="#" title="Delete ' + parker.first_name + ' ' + parker.last_name + '" class="parker-delete" data-cy="parker-terminate-link">Terminate</a>' : '') +
                    '</div>' +
                    '<div class="transaction-meta">' +
                    '<p data-cy="parker-status-text">' + getParkerStatusText(parker); + '</p>' +
                      '</div>' +
                      '</li>';

                  $('.transactions-group ol').append(template);

                });

                var questions = subscription.billing_profile.survey_questions;
                if (questions.length) {
                  surveyQuestions(questions, 'TERMINATION', '#termination-survey-questions');
                }

              } else {

                console.log('Successfully retrieved the subscription, but there are no parkers to display!');
                $('.transactions-group').empty().append('<div class="card-content-error">There are no parkers for this subscription.</div>');

              }
              window.history.replaceState('', '', '?subscription=' + subscription.id);
              $('.parker-add').attr('href', '?subscription=' + subscription.id + '&add=1').show();

            }

          } else {

            console.log('You don\'t have any subscriptions.')
            $('.card-content').append('<div class="card-content-error">You don\'t have any subscriptions.</div>');

          }

          $('.card-content-overlay').removeClass('card-content-overlay-active');

        },
        error: function (results) {
          console.log(results);
        }
      });

    }
    /*** lookup rates via promo code functionality */
    $('#promo-code').on('input', function (event) {
      // if there is a promo code entered, enable the promo code submit button
      $('#submit-promo-code').prop('disabled', !event.target.value);
    });

    $('#submit-promo-code').on('click', function () {
      // if the promo code input is disabled when the
      // button was pressed, then we were in the state where
      // the user wishes to clear the entered promo code
      const isInCancelState = $('#promo-code').prop('disabled');
      if (isInCancelState) {
        let nonPromoCodeOptions = [];
        $("#rate > option").each(function (_, element) {
          // If the option wasn't specified as a promo code rate
          // and isn't the default value, append it to the list
          if (!$(element).attr("data-is-promo-code-rate")
            && $(element).val() !== "#") {
            nonPromoCodeOptions.push(
              $('<option></option>')
                .attr("value", $(element).val())
                .text($(element).text())
            );
          }
        });

        $('#rate').empty();
        const defaultOption = '<option value="#" selected disabled>Choose One...</option>';
        $('#rate').append(defaultOption);

        nonPromoCodeOptions.forEach(function (element) {
          $('#rate').append(
            $('<option></option>')
              .attr("value", $(element).val())
              .text($(element).text())
          );
        });
        $('#submit-promo-code').text('Apply Promo Code');
        $('#promo-code').prop('disabled', false);
        $('#promo-code').val("").trigger('input');
        return;
      }
      const enteredPromoCode = $('#promo-code').val();
      if (!enteredPromoCode) {
        return;
      }
      $('#submit-promo-code').prop('disabled', true);
      const urlParameters = new URLSearchParams(window.location.search);
      subscriptionId = urlParameters.get('subscription');
      $.ajax({
        type: 'post',
        url: '/wp-admin/admin-ajax.php',
        data: {
          action: 'chirp_graphql',
          authorization: graphQLAuth,
          nonce: graphQLNonce,
          graphql_request: "query getPromoCodeByText($text: String!, $subscription_id: String!) { getPromoCodeByText(text: $text, subscription_id: $subscription_id) { id, name } }",
          graphql_variables: JSON.stringify({
            "text": enteredPromoCode,
            "subscription_id": subscriptionId,
          })
        },
        success: function (results) {
          let { data, errors } = JSON.parse(results);
          const promoCodeValid = !errors && data?.getPromoCodeByText?.length > 0;
          if (promoCodeValid) {
            const { getPromoCodeByText } = data;
            getPromoCodeByText.forEach(({ id, name }) => {
              $('#rate').append(
                $('<option></option>')
                  .attr("value", id)
                  .attr("data-is-promo-code-rate", true)
                  .text(name)
              );
              $('#rate').val(id);
            });
            $('#submit-promo-code').text('Promo code valid!');
            $('#promo-code').prop('disabled', true);
          } else {
            $('#submit-promo-code').text('Promo code invalid');
          }
          setTimeout(() => {
            if (promoCodeValid) {
              $('#submit-promo-code').text('Clear Promo Code');
            } else {
              $('#submit-promo-code').text('Apply Promo Code');
            }
            $('#submit-promo-code').prop('disabled', false);
          }, 2500);
        },
        error: function (error) {
          console.log('error fetching rate from promo code', error);
          $('#submit-promo-code').text('Promo code invalid');
          setTimeout(() => {
            $('#submit-promo-code').text('Apply Promo Code');
            $('#submit-promo-code').prop('disabled', false);
          }, 2500);
        }
      });
    });
    // look up subscription and display parkers in list
    $('#subscription').change(function () {

      $('.card-content-overlay-loading').addClass('card-content-overlay-active');

      var subscriptionId = this.value;

      $.ajax({
        type: 'post',
        url: '/wp-admin/admin-ajax.php',
        data: {
          action: 'chirp_graphql',
          authorization: graphQLAuth,
          nonce: graphQLNonce,
          graphql_request: "query getSubscription($subscription_id: String!) { getSubscription(subscription_id: $subscription_id) { id, billing_profile { id, billing_day, terminationRule, termination_notice_day, facility { id, facility_name, address, timezone, myAccountFacilitySettings { showParkerTermination } } survey_questions { id, billing_profile_id, order, type, structure } }, parkers { id, barcode, suspension_status, termination_status, first_name, last_name, parker_status_history {action, start_date}}, payor { id, cognito_sub, billing_firstname, billing_lastname } } }", graphql_variables: JSON.stringify({
            "subscription_id": subscriptionId
          })
        },
        success: function (results) {

          let { data, errors } = JSON.parse(results);

          console.log('success!', data);

          window.history.replaceState('', '', '?subscription=' + subscriptionId);
          $('.parker-add').attr('href', '?subscription=' + subscriptionId + '&add=1').show();

          if (data.getSubscription) {

            var subscription = data.getSubscription;
            var parkers = subscription.parkers;

            if (parkers.length > 0) {

              if ($('.transactions-group ol').length) {
                $('.transactions-group ol').empty();
              } else {
                $('.transactions-group').append('<ol />');
              }


              parkers.forEach(function (parker) {

                const isActive = (parker.suspension_status === 'ACTIVE' || parker.termination_status === 'ACTIVE');
                const isTerminationPending = parker.termination_status === 'TERMINATION_PENDING';
                const isShowTerminateButton = isActive && subscription.billing_profile.facility.myAccountFacilitySettings.showParkerTermination && (!feature_flags.FEATURE_MYACCOUNT || !isTerminationPending);

                var template = '<li class="transaction" data-subscription-id="' + subscription.id + '" data-parker-id="' + parker.id + '" data-parker-name="' + parker.first_name + ' ' + parker.last_name + '"' + ` data-termination-day=${subscription.billing_profile.termination_notice_day} data-termination-rule=${subscription.billing_profile.terminationRule} ` + '>' +
                  '<div class="transaction-title">' +
                  `<a href="?subscription=${subscription.id}&parker=${parker.id}&edit=1" title="Edit ${parker.first_name} ${parker.last_name}" data-cy="parker-name-link">` + parker.first_name + ' ' + parker.last_name + '</a>' +
                  '</div>' +
                  '<div class="transaction-actions">' +
                  (parker.barcode ? '<a href="?subscription=' + subscription.id + '&parker=' + parker.id + '&barcode=true" title="View ' + parker.first_name + ' ' + parker.last_name + '\'s Barcode" class="parker-barcode" data-cy="parker-barcode-link">View Barcode</a>' : '') +
                  (isShowTerminateButton ? '<a href="#" title="Delete ' + parker.first_name + ' ' + parker.last_name + '" class="parker-delete" data-cy="parker-terminate-link">Terminate</a>' : '') +
                  '</div>' +
                  '<div class="transaction-meta">' +
                  '<p data-cy="parker-status-text">' + getParkerStatusText(parker); + '</p>' +
                    '</div>' +
                    '</li>';

                $('.transactions-group ol').append(template);

              });

            } else {

              console.log('Successfully retrieved the subscription, but there are no parkers to display!');
              $('.transactions-group').empty().append('<div class="card-content-error">There are no parkers for this subscription.</div>');

            }

            var questions = subscription.billing_profile.survey_questions;
            if (questions.length) {
              surveyQuestions(questions, 'TERMINATION', '#termination-survey-questions');
            }

          }

          $('.card-content-overlay-loading').removeClass('card-content-overlay-active');

        },
        error: function (results) {
          console.log('error!', results);
          $('.card-content-overlay-loading').removeClass('card-content-overlay-active');
          // display error message
        }
      });

    });

    /* remove this set of vehicle fields */
    $('#vehicles').on('click', '.vehicle-delete', function (e) {
      e.preventDefault();
      $(this).parents('.form-field-group-vehicle').remove();
    });

    /* add another set of vehicle fields */
    $('.vehicle-add').click(function (e) {
      e.preventDefault();

      var index = $('#vehicles').find('.form-field-group-vehicle').length;

      var template = '<div class="form-field form-field-group form-field-group-outlined form-field-group-vehicle" id="vehicle-' + index + '">' +
        '<div class="form-field">' +
        '<label class="form-field-label" for="vehicle-make-' + index + '" data-cy="">Vehicle Make</label>' +
        `<input type="text" name="vehicle-make" id="vehicle-make-${index}" data-cy="vehicle-make-input-${index}"/>` +
        '</div>' +
        '<div class="form-field">' +
        '<label class="form-field-label" for="vehicle-model-' + index + '">Vehicle Model</label>' +
        `<input type="text" name="vehicle-model" id="vehicle-model-${index}" data-cy="vehicle-model-input-${index}" />` +
        '</div>' +
        '<div class="form-field">' +
        '<label class="form-field-label" for="vehicle-state-' + index + '">License Plate State</label>' +
        '<div class="select-wrapper">' +
        `<select name="vehicle-state" id="vehicle-state-${index}" data-cy="vehicle-state-select-${index}"/>
          <option value="" <?php echo (empty($state)) ? 'selected' : ''; ?>Select a state</option>
          <option value="Alabama" <?php echo ($state == 'Alabama') ? 'selected' : ''; ?>Alabama</option>
          <option value="Alaska" <?php echo ($state == 'Alaska') ? 'selected' : ''; ?>Alaska</option>
          <option value="Arizona" <?php echo ($state == 'Arizona') ? 'selected' : ''; ?>Arizona</option>
          <option value="Arkansas" <?php echo ($state == 'Arkansas') ? 'selected' : ''; ?>Arkansas</option>
          <option value="California" <?php echo ($state == 'California') ? 'selected' : ''; ?>California</option>
          <option value="Colorado" <?php echo ($state == 'Colorado') ? 'selected' : ''; ?>Colorado</option>
          <option value="Connecticut" <?php echo ($state == 'Connecticut') ? 'selected' : ''; ?>Connecticut</option>
          <option value="Delaware" <?php echo ($state == 'Delaware') ? 'selected' : ''; ?>Delaware</option>
          <option value="District of Columbia" <?php echo ($state == 'District of Columbia') ? 'selected' : ''; ?>District of Columbia</option>
          <option value="Florida" <?php echo ($state == 'Florida') ? 'selected' : ''; ?>Florida</option>
          <option value="Georgia" <?php echo ($state == 'Georgia') ? 'selected' : ''; ?>Georgia</option>
          <option value="Hawaii" <?php echo ($state == 'Hawaii') ? 'selected' : ''; ?>Hawaii</option>
          <option value="Idaho" <?php echo ($state == 'Idaho') ? 'selected' : ''; ?>Idaho</option>
          <option value="Illinois" <?php echo ($state == 'Illinois') ? 'selected' : ''; ?>Illinois</option>
          <option value="Indiana" <?php echo ($state == 'Indiana') ? 'selected' : ''; ?>Indiana</option>
          <option value="Iowa" <?php echo ($state == 'Iowa') ? 'selected' : ''; ?>Iowa</option>
          <option value="Kansas" <?php echo ($state == 'Kansas') ? 'selected' : ''; ?>Kansas</option>
          <option value="Kentucky" <?php echo ($state == 'Kentucky') ? 'selected' : ''; ?>Kentucky</option>
          <option value="Louisiana" <?php echo ($state == 'Louisiana') ? 'selected' : ''; ?>Louisiana</option>
          <option value="Maine" <?php echo ($state == 'Maine') ? 'selected' : ''; ?>Maine</option>
          <option value="Maryland" <?php echo ($state == 'Maryland') ? 'selected' : ''; ?>Maryland</option>
          <option value="Massachusetts" <?php echo ($state == 'Massachusetts') ? 'selected' : ''; ?>Massachusetts</option>
          <option value="Michigan" <?php echo ($state == 'Michigan') ? 'selected' : ''; ?>Michigan</option>
          <option value="Minnesota" <?php echo ($state == 'Minnesota') ? 'selected' : ''; ?>Minnesota</option>
          <option value="Mississippi" <?php echo ($state == 'Mississippi') ? 'selected' : ''; ?>Mississippi</option>
          <option value="Missouri" <?php echo ($state == 'Missouri') ? 'selected' : ''; ?>Missouri</option>
          <option value="Montana" <?php echo ($state == 'Montana') ? 'selected' : ''; ?>Montana</option>
          <option value="Nebraska" <?php echo ($state == 'Nebraska') ? 'selected' : ''; ?>Nebraska</option>
          <option value="Nevada" <?php echo ($state == 'Nevada') ? 'selected' : ''; ?>Nevada</option>
          <option value="New Hampshire" <?php echo ($state == 'New Hampshire') ? 'selected' : ''; ?>New Hampshire</option>
          <option value="New Jersey" <?php echo ($state == 'New Jersey') ? 'selected' : ''; ?>New Jersey</option>
          <option value="New Mexico" <?php echo ($state == 'New Mexico') ? 'selected' : ''; ?>New Mexico</option>
          <option value="New York" <?php echo ($state == 'New York') ? 'selected' : ''; ?>New York</option>
          <option value="North Carolina" <?php echo ($state == 'North Carolina') ? 'selected' : ''; ?>North Carolina</option>
          <option value="North Dakota" <?php echo ($state == 'North Dakota') ? 'selected' : ''; ?>North Dakota</option>
          <option value="Ohio" <?php echo ($state == 'Ohio') ? 'selected' : ''; ?>Ohio</option>
          <option value="Oklahoma" <?php echo ($state == 'Oklahoma') ? 'selected' : ''; ?>Oklahoma</option>
          <option value="Oregon" <?php echo ($state == 'Oregon') ? 'selected' : ''; ?>Oregon</option>
          <option value="Pennsylvania" <?php echo ($state == 'Pennsylvania') ? 'selected' : ''; ?>Pennsylvania</option>
          <option value="Rhode Island" <?php echo ($state == 'Rhode Island') ? 'selected' : ''; ?>Rhode Island</option>
          <option value="South Carolina" <?php echo ($state == 'South Carolina') ? 'selected' : ''; ?>South Carolina</option>
          <option value="South Dakota" <?php echo ($state == 'South Dakota') ? 'selected' : ''; ?>South Dakota</option>
          <option value="Tennessee" <?php echo ($state == 'Tennessee') ? 'selected' : ''; ?>Tennessee</option>
          <option value="Texas" <?php echo ($state == 'Texas') ? 'selected' : ''; ?>Texas</option>
          <option value="Utah" <?php echo ($state == 'Utah') ? 'selected' : ''; ?>Utah</option>
          <option value="Vermont" <?php echo ($state == 'Vermont') ? 'selected' : ''; ?>Vermont</option>
          <option value="Virginia" <?php echo ($state == 'Virginia') ? 'selected' : ''; ?>Virginia</option>
          <option value="Washington" <?php echo ($state == 'Washington') ? 'selected' : ''; ?>Washington</option>
          <option value="West Virginia" <?php echo ($state == 'West Virginia') ? 'selected' : ''; ?>West Virginia</option>
          <option value="Wisconsin" <?php echo ($state == 'Wisconsin') ? 'selected' : ''; ?>Wisconsin</option>
          <option value="Wyoming" <?php echo ($state == 'Wyoming') ? 'selected' : ''; ?>Wyoming</option>
        </select>` +
        '</div>' +
        '</div>' +
        '<div class="form-field">' +
        '<label class="form-field-label" for="vehicle-plate-number-' + index + '">License Plate</label>' +
        `<input type="text" name="vehicle-plate-number" id="vehicle-plate-number-${index}" data-cy="vehicle-plate-input-${index}"/>` +
        '</div>' +
        '<div class="form-field">' +
        '<label class="form-field-label" for="vehicle-color-' + index + '">Vehicle Color</label>' +
        `<input type="text" name="vehicle-color" id="vehicle-color-${index}" data-cy="vehicle-color-input-${index}" />` +
        '</div>' +
        '<div class="form-field">' +
        '<label class="form-field-label" for="vehicle-decal-' + index + '">Vehicle Decal</label>' +
        `<input type="text" name="vehicle-decal" id="vehicle-decal-${index}" data-cy="vehicle-decal-input-${index}" />` +
        '</div>' +
        '<div class="form-field">' +
        `<button class="button button-small button-red vehicle-delete" data-cy="vehicle-delete-button-${index}">Delete This Vehicle</button>` +
        '</div>' +
        '</div>';

      $('.form-field-group-vehicles').append(template);

    });

    /* delete this parker */
    $('.transactions-group').on('click', '.parker-delete', function (e) {
      e.preventDefault();

      var subscriptionId = $(this).parents('.transaction').attr('data-subscription-id');
      var parkerId = $(this).parents('.transaction').attr('data-parker-id');
      var parkerName = $(this).parents('.transaction').attr('data-parker-name');
      var terminationRule = $(this).parents('.transaction').attr('data-termination-rule');
      var terminationDay = $(this).parents('.transaction').attr('data-termination-day');

      // trigger #termination-confirm overlay
      var terminationConfirm = $('#termination-confirm');
      var isThirtyDayNotice = ['HALF_MONTH', 'DAILY_PRORATION'].includes(terminationRule);
      if (isThirtyDayNotice) {
        $('#parker-termination-confirm').html(`
          <input type="date" id="parker-termination-date-picker" name="datemin" value="${createTerminationDate(true)}" min="${createTerminationDate(true)}">
          <br>
          <br>
          <p>
            Please select the desired Termination Date. This Facility requires 30-day Termination Notice. The earliest available
            Termination Date is
            <span class="parker-earliest-termination-day" data-cy="parker-earliest-termination-day-text"></span>.
          </p>
          <p>
            You will be responsible for <span class="parker-termination-proration-percentage"
              data-cy="parker-termination-proration-percentage"></span>% of
            fees for <span class="parker-termination-month-year" data-cy="parker-termination-month-year-text"></span> per the
            Terms and Conditions
            for this parking facility.
          </p>
          `);
        $('#parker-termination-date-picker').on('change', function (e) {
          // e.target.value is '' if the date is invalud
          if (!e.target.value) {
            return;
          }
          const valueAsMoment = moment(e.target.value, 'YYYY-MM-DD')
          $('.parker-termination-month-year', terminationConfirm).empty().text(valueAsMoment.format("MMMM YYYY"));
          $('.parker-termination-proration-percentage', terminationConfirm).empty().text(getTerminationProrationPercentage(terminationRule, terminationDay));
        })
        // the initial month and year is whatever the month and year of the current moment
        $('.parker-termination-month-year', terminationConfirm).empty().text(getTerminationMonthAndYear(true));
        $('.parker-termination-proration-percentage', terminationConfirm)
          .empty()
          .text(
            getTerminationProrationPercentage(terminationRule, terminationDay)
          );
        $('.parker-earliest-termination-day', terminationConfirm).empty().text(getTerminationDate(null, isThirtyDayNotice));
      } else {
        $('#parker-termination-confirm').html(
          'Are you sure you want to delete <span class="parker-name" data-cy="parker-name-text"></span>? Their last day to park would be <span class="parker-last-day" data-cy="parker-last-day-text"></span>.'
        );
        $('.parker-name', terminationConfirm).empty().text(parkerName);
        $('.parker-last-day', terminationConfirm).empty().text(getTerminationDate(null, isThirtyDayNotice));
      }

      $(terminationConfirm).addClass('card-content-overlay-active');

      $('#termination-confirm-cancel').on('click', function () {
        $(terminationConfirm).removeClass('card-content-overlay-active');
        $('.form-card-message').empty();
      });

      $('#termination-confirm-ok').on('click', function () {
        function enableTerminationButtons() {
          $(this).prop('disabled', false);
          $('.button-spinner', this).prop('disabled', false);
          $('.button-spinner', this).css('display', '');
          $('#termination-confirm-cancel').prop('disabled', false);
          $('#termination-confirm-ok').prop('disabled', false);
        }
        if (isThirtyDayNotice) {
          const earliestTerminationDayAsMoment = moment(getTerminationDate(null, isThirtyDayNotice), '"MMMM D, YYYY"');

          const terminationDayAsMoment = moment($('#parker-termination-date-picker').val(), 'YYYY-MM-DD');
          if (!terminationDayAsMoment.isValid()) {
            enableTerminationButtons();
            $('.form-card-message')
              .empty()
              .removeClass('form-card-message-success')
              .addClass('form-card-message-error')
              .text('Please enter a valid termination date.');
            return;
          }
          if (terminationDayAsMoment.isBefore(earliestTerminationDayAsMoment)) {
            enableTerminationButtons();
            $('.form-card-message')
              .empty()
              .removeClass('form-card-message-success')
              .addClass('form-card-message-error')
              .text('The date entered cannot be before the earliest available Termination Date.');
            return;
          }
        }
        $('.form-card-message').empty();

        // var terminationDate = moment().add(1, 'day').format('YYYY-MM-DD');
        var terminationDate = createTerminationDate();
        if (isThirtyDayNotice) {
          terminationDate = $('#parker-termination-date-picker').val();
        }
        var surveyResponses = new Array();

        if ($('#termination-survey-questions .form-field').length > 0) {

          $('#manage-parkers-card').addClass('card-collapsed');
          $('#termination-survey-card').removeClass('card-collapsed');

          $('#termination-survey').submit(function (e) {
            e.preventDefault();
            $('.button-spinner', this).prop('disabled', true);
            $('#termination-survey-submit').prop('disabled', true);
            $('#termination-survey-skip').prop('disabled', true);
            $('#termination-survey-skip').css('display', 'none');
            $(this).prop('disabled', true);

            // loop through questions, gather prompts and responses, and add to array
            $('#termination-survey-questions .form-field').each(function () {
              var question = new Object();
              question.prompt = $('.prompt', this).text();
              var questionType = $(this).attr('data-question-type');
              if (questionType == 'radio') {
                question.response = $('input[type="radio"]:checked', this).val();
              } else if (questionType == 'select') {
                question.response = $('select', this).val();
              } else if (questionType == 'text') {
                question.response = $('input[type="text"]', this).val();
              }
              surveyResponses.push(question);
            });

            $.ajax({
              type: 'post',
              url: '/wp-admin/admin-ajax.php',
              data: {
                action: 'chirp_graphql',
                api_version: 'v2',
                authorization: graphQLAuth,
                nonce: graphQLNonce,
                graphql_request: "mutation myAccountTerminateParker($parkerId: String!, $terminationDate: String!, $surveyResponses: [MyAccountTerminateParkerSurveyResponseInput!]) { myAccountTerminateParker(parkerId: $parkerId, terminationDate: $terminationDate, surveyResponses: $surveyResponses) }",
                graphql_variables: JSON.stringify({
                  parkerId,
                  terminationDate,
                  surveyResponses
                })
              },
              success: function (results) {

                let { data, errors } = JSON.parse(results);

                console.log('success!', data);
                window.location.reload();
              },
              error: function (results) {
                console.log('error!', results);
                $('.button-spinner', this).prop('disabled', false);
                $('#termination-survey-submit').prop('disabled', false);
                $('#termination-survey-skip').prop('disabled', false);
                $('#termination-survey-skip').css('display', '');
              }
            });

          });

        } else {

          $(this).prop('disabled', true);
          $('.button-spinner', this).prop('disabled', true);
          $('#termination-confirm-cancel').prop('disabled', true);

          $.ajax({
            type: 'post',
            url: '/wp-admin/admin-ajax.php',
            data: {
              action: 'chirp_graphql',
              api_version: 'v2',
              authorization: graphQLAuth,
              nonce: graphQLNonce,
              graphql_request: "mutation myAccountTerminateParker($parkerId: String!, $terminationDate: String!, $surveyResponses: [MyAccountTerminateParkerSurveyResponseInput!]) { myAccountTerminateParker(parkerId: $parkerId, terminationDate: $terminationDate, surveyResponses: $surveyResponses) }",
              graphql_variables: JSON.stringify({
                parkerId,
                terminationDate,
                surveyResponses
              })
            },
            success: function (results) {
              let { data, errors } = JSON.parse(results);
              console.log('success!', data);
              if (errors) {
                enableTerminationButtons();

                const errorMessage = errors[0]?.message || '';
                if (errorMessage.includes('exceeds')) {
                  $('.form-card-message')
                    .empty()
                    .removeClass('form-card-message-success')
                    .addClass('form-card-message-error')
                    .text('Please contact your parking manager to complete this termination.');
                  return;
                }
                $('.form-card-message').empty().removeClass('form-card-message-success').addClass('form-card-message-error').text('An error occurred: ' + errors[0].message);
                return;
              }
              window.location.reload();
            },
            error: function (results) {
              console.log('error!', results);
              $(this).prop('disabled', false);
              $('#termination-confirm-cancel').prop('disabled', false);
            }
          });

        }

      });

    });

    /* submit #edit-parker form */
    $('#edit-parker').validate({
      // debug: true,
      errorElement: 'span',
      errorClass: 'form-field-error',
      validClass: 'form-field-valid',
      errorPlacement: function (error, element) {
        error.appendTo(element.parents('.form-field'));
      },
      highlight: function (element, errorClass, validClass) {
        $(element).parents('.form-field').addClass(errorClass).removeClass(validClass);
      },
      unhighlight: function (element, errorClass, validClass) {
        $(element).parents('.form-field').removeClass(errorClass).addClass(validClass);
      },
      rules: {
        'first-name': {
          required: true,
          minlength: 2
        },
        'last-name': {
          required: true,
          minlength: 2
        },
        'email-address': {
          required: true,
          email: true
        },
        'country-code': {
          required: {
            depends: function (element) {
              // Make country code required only if phone number has a value
              return $("#phone-number").val().length > 0;
            }
          },
          minlength: 1,
          maxlength: 3,
        },
        'phone-number': {
          // required: true,
          phoneUS: true
        },
        'street-address': {
          // required: true,
          minlength: 2
        },
        'city': {
          // required: true,
          minlength: 2
        },
        'zip-code': {
          // required: true,
          zipcodeUS: true
        }
      },
      messages: {
        'first-name': {
          required: 'Please enter your first name.',
          minlength: 'Your first name must be at least 2 characters long.'
        },
        'last-name': {
          required: 'Please enter your last name.',
          minlength: 'Your last name must be at least 2 characters long.'
        },
        'email-address': {
          required: 'Please enter your email address.',
          email: 'Please enter a valid email address.'
        },
        'street-address': {
          // required: 'Please enter your street address',
          minlength: 'Please enter a valid street address.'
        },
        'city': {
          // required: 'Please enter your city.',
          minlength: 'Please enter a valid city name.'
        },
        'zip-code': {
          // required: 'Please enter your zip code.',
          zipcodeUS: 'Please enter a valid zip code.'
        },
        'country-code': {
          required: 'Country code is required when phone number is provided.',
          minlength: 'Please enter a valid country code.',
          maxlength: 'Country code should not exceed 3 characters.'
        }
      },
      submitHandler: function (form) {
        $('.button-spinner', form).prop('disabled', true);

        var subscriptionId = getUrlParameter('subscription');
        var parkerId = getUrlParameter('parker');

        var parker = new Object();

        parker.id = parkerId;
        parker.first_name = $('#first-name').val();
        parker.last_name = $('#last-name').val();
        parker.email = $('#email-address').val();
        parker.country_code = $('#country-code').val();
        parker.phone = $('#phone-number').val();
        parker.address = $('#street-address').val();
        parker.city = $('#city').val();
        parker.state = $('#state').val();
        parker.zip = $('#zip-code').val();
        var integration = $('#facility-integration').val();

        var vehiclesObject = $('#vehicles').find('.form-field-group-vehicle');

        var vehicles = new Array();
        $(vehiclesObject).each(function () {
          var vehicle = new Object();
          vehicle.make = $('input[name="vehicle-make"]', this).val();
          vehicle.model = $('input[name="vehicle-model"]', this).val();
          vehicle.state = $('select[name="vehicle-state"]', this).val();
          vehicle.license = $('input[name="vehicle-plate-number"]', this).val();
          vehicle.color = $('input[name="vehicle-color"]', this).val();
          vehicle.decal = $('input[name="vehicle-decal"]', this).val();

          const vehicleValues = Object.values(vehicle);
          const vehicleHasValue = vehicleValues.some(value => value && value !== '');

          if (vehicleHasValue) vehicles.push(vehicle);
        });

        if (integration === 'GET_MY_PARKING' && !vehicles.length) {
          const errorMessage = 'At least one vehicle is required.';
          
          $('.form-card-message', form)
            .empty()
            .removeClass('form-card-message-success')
            .addClass('form-card-message-error')
            .text(errorMessage);

          $('.button-spinner', form).prop('disabled', false);

          return;
        }
        parker.vehicles = vehicles;

        console.log(parker);

        $.ajax({
          type: 'post',
          url: '/wp-admin/admin-ajax.php',
          data: {
            action: 'chirp_graphql',
            authorization: graphQLAuth,
            nonce: graphQLNonce,
            graphql_request: "mutation myAccountUpdateParker($subscription_id: String!, $parker: ParkerInput!) { myAccountUpdateParker(subscription_id: $subscription_id, parker: $parker) }",
            graphql_variables: JSON.stringify({
              "parker": parker,
              "subscription_id": subscriptionId
            })
          },
          success: function (results) {
            let { data, errors } = JSON.parse(results);
            console.log('success!');

            if (!errors?.length) {

              $('.button-spinner', form).prop('disabled', false);
              $('.form-card-message', form).empty().removeClass('form-card-message-error').addClass('form-card-message-success').text(parker.first_name + ' ' + parker.last_name + ' has been updated!');
              vehicles.forEach(function (vehicle, index) {
                $('#vehicle-make-' + index).val(vehicle.make).prop('disabled', true);
                $('#vehicle-model-' + index).val(vehicle.model).prop('disabled', true);
                $('#vehicle-state-' + index).val(vehicle.state).prop('disabled', true);
                $('#vehicle-color-' + index).val(vehicle.color).prop('disabled', true);
                $('#vehicle-decal-' + index).val(vehicle.decal).prop('disabled', true);
                $('#vehicle-plate-number-' + index).val(vehicle.license).prop('disabled', true);
              });
            } else {

              $('.button-spinner', form).prop('disabled', false);
              $('.form-card-message', form).empty().removeClass('form-card-message-success').addClass('form-card-message-error').text('Something went wrong. Try again?');

            }

          },
          error: function (results) {
            console.log('error!', results);
            $('.button-spinner', form).prop('disabled', false);
            $('.form-card-message', form).empty().removeClass('form-card-message-success').addClass('form-card-message-error').text('Something went wrong. Try again?');
          }
        });

      }
    });

    /* submit #add-parker form */
    $('#add-parker').validate({
      // debug: true,
      errorElement: 'span',
      errorClass: 'form-field-error',
      validClass: 'form-field-valid',
      errorPlacement: function (error, element) {
        error.appendTo(element.parent('.form-field'));
      },
      highlight: function (element, errorClass, validClass) {
        $(element).parent('.form-field').addClass(errorClass).removeClass(validClass);
      },
      unhighlight: function (element, errorClass, validClass) {
        $(element).parent('.form-field').removeClass(errorClass).addClass(validClass);
      },
      rules: {
        'start-date': {
          required: true
        },
        'rate': {
          required: true
        },
        'first-name': {
          required: true,
          minlength: 2
        },
        'last-name': {
          required: true,
          minlength: 2
        },
        'email-address': {
          required: true,
          email: true
        },
        'phone-number': {
          // required: true,
          minlength: 10,
          maxlength: 10
        },
        'street-address': {
          // required: true,
          minlength: 2
        },
        'city': {
          // required: true,
          minlength: 2
        },
        'zip-code': {
          // required: true,
          zipcodeUS: true
        },
      },
      messages: {
        'start-date': {
          required: 'Please choose a start date.'
        },
        'rate': {
          required: 'Please choose a rate.'
        },
        'first-name': {
          required: 'Please enter your first name.',
          minlength: 'Your first name must be at least 2 characters long.'
        },
        'last-name': {
          required: 'Please enter your last name.',
          minlength: 'Your last name must be at least 2 characters long.'
        },
        'email-address': {
          required: 'Please enter your email address.',
          email: 'Please enter a valid email address.'
        },
        'phone-number': {
          // required: 'Please enter your phone number.',
          minlength: 'Please provide a valid phone number',
          maxlength: 'Please provide a valid phone number'
        },
        'street-address': {
          // required: 'Please enter your street address',
          minlength: 'Please enter a valid street address.'
        },
        'city': {
          // required: 'Please enter your city.',
          minlength: 'Please enter a valid city name.'
        },
        'zip-code': {
          // required: 'Please enter your zip code.',
          zipcodeUS: 'Please enter a valid zip code.'
        }
      },
      submitHandler: function (form) {
        console.log('submitting');
        $('.button-spinner', form).prop('disabled', true);

        var subscriptionId = getUrlParameter('subscription');
        var rateId = $('#rate').val();
        console.log('RATEEEEE', $('#rate'));
        const startDate = $('#start-date').val();

        var parker = new Object();
        parker.first_name = $('#first-name').val();
        parker.last_name = $('#last-name').val();
        parker.email = $('#email-address').val();
        parker.country_code = $('#country-code').val();
        parker.phone = $('#phone-number').val();
        parker.address = $('#street-address').val();
        parker.city = $('#city').val();
        parker.state = $('#state').val();
        parker.zip = $('#zip-code').val();

        var vehiclesObject = $('#vehicles').find('.form-field-group-vehicle');

        var vehicles = new Array();
        $(vehiclesObject).each(function () {
          var vehicle = new Object();
          vehicle.make = $('input[name="vehicle-make"]', this).val();
          vehicle.model = $('input[name="vehicle-model"]', this).val();
          vehicle.state = $('select[name="vehicle-state"]', this).val();
          vehicle.license = $('input[name="vehicle-plate-number"]', this).val();
          vehicle.color = $('input[name="vehicle-color"]', this).val();
          vehicle.decal = $('input[name="vehicle-decal"]', this).val();

          const vehicleValues = Object.values(vehicle);
          const vehicleHasValue = vehicleValues.some(value => value && value !== '');

          if (vehicleHasValue) vehicles.push(vehicle);
        });

        parker.vehicles = vehicles;

        parker.access_devices = accessDevices.reduce((acc, device) => {
          if (device.required) {
            return [...acc, { type: accessDeviceTypeMap[device.type] }];
          }
          return acc;
        }, []);

        console.log('parker: ', parker);
        console.log('rate_id:', rateId);
        console.log('subscription_id:', subscriptionId);

        var ratePurchase = new Object();
        ratePurchase.rate_id = rateId;
        ratePurchase.parkers = [{ ...parker, vehicles }]

        $.ajax({
          type: 'post',
          url: '/wp-admin/admin-ajax.php',
          data: {
            action: 'chirp_graphql',
            api_version: 'v2',
            authorization: graphQLAuth,
            nonce: graphQLNonce,
            graphql_request: "mutation myAccountCreateParker($subscriptionId: String!, $rateId: String!, $startDate: String!, $firstName: String!, $lastName: String!, $email: String, $address: String, $city: String, $state: String, $zip: String, $countryCode: String, $phone: String, $vehicles: [VehicleInputType]) { myAccountCreateParker(subscriptionId: $subscriptionId, rateId: $rateId, startDate: $startDate, firstName: $firstName, lastName: $lastName, email: $email, address: $address, city: $city, state: $state, zip: $zip, countryCode: $countryCode, phone: $phone, vehicles: $vehicles) }",
            graphql_variables: JSON.stringify({
              subscriptionId,
              rateId,
              startDate,
              firstName: parker.first_name,
              lastName: parker.last_name,
              email: parker.email,
              address: parker.address,
              street: parker.street,
              city: parker.city,
              state: parker.state,
              zip: parker.zip,
              countryCode: parker.country_code,
              phone: parker.phone,
              vehicles: parker.vehicles
            })
          },
          success: function (results) {
            let { data, errors } = JSON.parse(results);

            if (!errors?.length) {
              console.log('success!', data);
              console.log('results =', results);

              $('.button-spinner', form).prop('disabled', false);
              $('.form-card-message', form).empty().removeClass('form-card-message-error').addClass('form-card-message-success').text(parker.first_name + ' ' + parker.last_name + ' has been added!');

              setTimeout(function () {
                window.location.href = window.location.pathname + '?subscription=' + subscriptionId;
              }, 1000);
            } else {
              console.log('errors', errors);
              $('.button-spinner', form).prop('disabled', false);
              $('.form-card-message', form).empty().removeClass('form-card-message-success').addClass('form-card-message-error').text('Something went wrong? Please try again.');
            }
          },
          error: function (results) {
            console.log('error!', results);
            $('.button-spinner', form).prop('disabled', false);
            $('.form-card-message', form).empty().removeClass('form-card-message-success').addClass('form-card-message-error').text('Something went wrong? Please try again.');
          }
        });
      }
    });
  }

  /*** monthly :: cancel subscription ***/
  if ($('body').hasClass('page-template-page-account-monthly-cancel')) {

    var thisSubscription = getUrlParameter('subscription');
    const paymentProviderId = !/platinum|icon/.test(window.location.host) ? 1 : 2;
    $.ajax({
      type: 'post',
      url: '/wp-admin/admin-ajax.php',
      data: {
        action: 'chirp_graphql',
        authorization: graphQLAuth,
        nonce: graphQLNonce,
        graphql_request: "query listUserSubscriptions($paymentProviderId: Int) { listUserSubscriptions(paymentProviderId: $paymentProviderId) { id, account_id, billing_profile { facility { id, facility_name, address, timezone } } } }",
        graphql_variables: JSON.stringify({ paymentProviderId })
      },
      success: function (results) {
        let { data, errors } = JSON.parse(results);

        if (data.listUserSubscriptions.length > 0) {

          var subscriptions = data.listUserSubscriptions;

          subscriptions.forEach(function (subscription) {

            var facilityName = 'FACILITY NAME';
            if (subscription.billing_profile.facility) {
              facilityName = subscription.billing_profile.facility.facility_name;
            }
            var option = '<option value="' + subscription.id + '">' + 'Monthly Parking at ' + facilityName + ' (AC-' + subscription.account_id + ')' + '</option>';

            $('select[name="subscription"]').append(option);

            if (thisSubscription == subscription.id) {
              $('select[name="subscription"]').val(subscription.id);
              // get subscription name from selected option
              var subscriptionName = $('#subscription option[value="' + thisSubscription + '"]').text();
              // change "Product Name at Facility Name" to name of chosen subscription
              $('#subscription-name').text(subscriptionName);
              // make rest of fields visible
              $('.form-field-optional').show();
            }

          });

        } else {

          console.log('You don\'t have any subscriptions.')
          $('.card-content').append('<div class="card-content-error">You don\'t have any subscriptions.</div>');

        }

        $('.card-content-overlay').removeClass('card-content-overlay-active');

      },
      error: function (results) {
        console.log(results);
      }
    });
  }

  /*** monthly :: SlidePay payment submitted ***/
  if ($('body').hasClass('page-template-page-account-monthly-payment-submitted')) {
    const thisInvoice = getUrlParameter('invoice');
    const thisStatus = getUrlParameter('status');
    const thisTransactionId = getUrlParameter('transactionId');

    function processExternalPayment(invoiceId, transactionId) {
      $.ajax({
        type: 'POST',
        url: '/wp-admin/admin-ajax.php',
        data: {
          action: 'chirp_graphql',
          api_version: 'v2',
          authorization: graphQLAuth,
          nonce: graphQLNonce,
          graphql_request: `
            mutation processExternalPayment($invoiceId: String!, $paymentMetaId: String!, $paymentType: String!) {
              processExternalPayment(invoiceId: $invoiceId, paymentMetaId: $paymentMetaId, paymentType: $paymentType) {
                invoiceId
              }
            }
          `,
          graphql_variables: JSON.stringify({
            invoiceId: thisInvoice,
            paymentMetaId: thisTransactionId,
            paymentType: 'card'
          })
        },
        success: function (response) {
          const { errors } = JSON.parse(response);

          if (errors) {
            $('#payment-status-title').text('Error');
            $('#payment-status-message').text('The payment was successful, but an error occurred updating the invoice. Please contact support.');
            return;
          }

          const activityUrl = `${window.location.host}/account/monthly/activity/?invoice=${thisInvoice}`;
          window.location.href = activityUrl;
        },
        error: function (err) {
          console.log('Error:', err);
          $('#payment-status-title').text('Error');
          $('#payment-status-message').text('The payment was successful, but an error occurred updating the invoice. Please contact support.');
        }
      })
    }

    switch (thisStatus.toLocaleLowerCase()) {
      case 'success':
        $('#payment-status-title').text('Payment Approved');
        $('#payment-status-message').text('Payment accepted. Please wait while we update your invoice.');
        processExternalPayment(thisInvoice, thisTransactionId);
        break;
      case 'declined':
        $('#payment-status-title').text('Payment Declined');
        $('#payment-status-message').text('Please wait and try again or choose a different payment method.');
        break;
      case 'cancelled':
        $('#payment-status-title').text('Payment Cancelled');
        $('#payment-status-message').text('You have cancelled this One-Time Payment. Please start over.')
        break;
      default:
        $('#payment-status-title').text('Error');
        $('#payment-status-message').text('There was an error processing your payment. Please retry the payment or select a different payment method.');
    }
  }

  // show rest of fields once a subscription is chosen
  $('#subscription').change(function () {
    // get subscription name from selected option
    var subscriptionName = $('option:selected', this).text();
    // change "Product Name at Facility Name" to name of chosen subscription
    $('#subscription-name').text(subscriptionName);
    // uncheck the "are you sure?" checkbox on subscription change
    $('input[id="are-you-sure-yes"]').prop('checked', false);
    // re-disable the submit button on subscription change
    $('#submit-button').prop('disabled', true);
    // make rest of fields visible
    $('.form-field-optional').show();
  });

  // enable submit button when checkbox is checked
  $('input[id="are-you-sure-yes"]').click(function () {
    if (this.checked) {
      $('#submit-button').prop('disabled', false);
      console.log(this.checked);
    } else {
      $('#submit-button').prop('disabled', true);
      console.log(this.checked);
    }
  });

  $('#cancel-subscription').validate({
    // debug: true,
    errorElement: 'span',
    errorClass: 'form-field-error',
    validClass: 'form-field-valid',
    errorPlacement: function (error, element) {
      error.appendTo(element.parents('.form-field'));
    },
    highlight: function (element, errorClass, validClass) {
      $(element).parents('.form-field').addClass(errorClass).removeClass(validClass);
    },
    unhighlight: function (element, errorClass, validClass) {
      $(element).parents('.form-field').removeClass(errorClass).addClass(validClass);
    },
    rules: {
      'subscription': {
        required: true
      },
      'are-you-sure': {
        required: true
      }
    },
    messages: {
      'subscription': {
        required: 'Please choose a subscription to cancel.'
      },
      'are-you-sure': {
        required: 'Please confirm that you would like to cancel your subscription.'
      }
    },
    submitHandler: function (form) {
      console.log('form submitted!');

      var subscriptionId = $('#subscription').val();
      var areYouSure = $('input[name="are-you-sure"]').val();

      // TODO: figure out JSON string to submit to API to cancel this subscription

      $.ajax({
        type: 'post',
        url: '/wp-admin/admin-ajax.php',
        data: {
          action: 'chirp_graphql',
          authorization: graphQLAuth,
          nonce: graphQLNonce,
          graphql_request: "",
          graphql_variables: JSON.stringify({})
        },
        success: function (results) {
          let { data } = JSON.parse(results);
          console.log(data);
        },
        error: function (results) {
          console.log(results);
        }
      });

    }
  });

  /*** AWS Cognito Experiments ***/
  // get endpoint url from meta tag
  var aws_api_endpoint_url = $('meta[name="aws-api-endpoint-url"]').attr('content');

  $('#aws-cognito-create-account').validate({
    // debug: true,
    errorElement: 'span',
    errorClass: 'form-field-error',
    validClass: 'form-field-valid',
    errorPlacement: function (error, element) {
      error.appendTo(element.parents('.form-field'));
      error.attr('data-cy', `${error[0].id}-text`);
    },
    highlight: function (element, errorClass, validClass) {
      $(element).parents('.form-field').addClass(errorClass).removeClass(validClass);
    },
    unhighlight: function (element, errorClass, validClass) {
      $(element).parents('.form-field').removeClass(errorClass).addClass(validClass);
    },
    'rules': {
      'create-first-name': {
        required: true,
        minlength: 2
      },
      'create-last-name': {
        required: true,
        minlength: 2
      },
      'create-email-address': {
        required: true,
        email: true
      },
      'create-country-code': {
        required: true,
        minlength: 1,
        maxlength: 3
      },
      'create-phone-number': {
        required: true,
        minlength: 10,
        maxlength: 15,
      },
      'create-password': {
        required: true,
        minlength: 12,
        maxlength: 99
      },
      'create-password-match': {
        required: true,
        minlength: 12,
        maxlength: 99,
        equalTo: '#create-password'
      }
    },
    'messages': {
      'create-first-name': {
        required: 'Please enter your first name.',
        minlength: 'Your first name must be at least 2 characters long.'
      },
      'create-last-name': {
        required: 'Please enter your last name.',
        minlength: 'Your last name must be at least 2 characters long.'
      },
      'create-email-address': {
        required: 'Please enter your email address.',
        email: 'Please enter a valid email address.'
      },
      'create-country-code': {
        required: 'Please enter your country code.',
        minlength: 'Your country code must be at least 1 character long.',
        maxlength: 'Your country code must be 3 characters or less.'
      },
      'create-phone-number': {
        required: 'Please enter your phone number.',
        minlength: 'Your phone number must be at least 10 characters long.',
        maxlength: 'Your phone number must be 15 characters or less.'
      },
      'create-password': {
        required: 'Please provide a password.',
        minlength: 'Your password must be at least 12 characters long.',
        maxlength: 'Your password must be 64 characters or less.'
      },
      'create-password-match': {
        required: 'Your password does not match the previous field.',
        minlength: 'Your password must be at least 12 characters long.',
        maxlength: 'Your password must be 64 characters or less.',
        equalTo: 'Your password does not match the previous field.'
      }
    },
    submitHandler: function (form) {
      // enable spinner animation on submit button
      $('.button-spinner', form).prop('disabled', true);

      grecaptcha.ready(function () {
        grecaptcha.execute(recaptcha_site_key, { action: 'aws_cognito_create_account' }).then(function (token) {
          // get all the variables
          var first_name = $('#create-first-name', form).val();
          var last_name = $('#create-last-name', form).val();
          var email_address = $('#create-email-address', form).val();
          var password = $('#create-password').val();
          var country_code = $('#create-country-code').val();
          var phone_number = $('#create-phone-number').val();
          // var nonce = $('#aws-cognito-create-account-nonce', form).val();

          // do something with them!
          $.ajax({
            type: 'post',
            url: '/wp-admin/admin-ajax.php',
            data: {
              action: 'aws_cognito_create_account',
              first_name: first_name,
              last_name: last_name,
              email_address: email_address,
              password: password,
              recaptcha_token: token,
              country_code: country_code,
              natl_phone: phone_number,
            },
            success: function (results) {
              var results = JSON.parse(results);
              // console.log(results);
              if (results.status === 'success') {
                $('.form-card-message', form).empty().removeClass('form-card-message-error').addClass('form-card-message-success').text(results.message);
                // pre-fill email address field on next step
                $('#confirm-email-address').val(results.email_address);
                // hide this step and show next step
                setTimeout(function () {
                  $(form).removeClass('form-flow-active');
                  $(form).next().addClass('form-flow-active');
                }, 250);
              } else if (results.status === 'error') {
                $('.form-card-message', form).empty().removeClass('form-card-message-success').addClass('form-card-message-error').text(results.message);
              } else {
                $('.form-card-message', form).empty().removeClass('form-card-message-success').addClass('form-card-message-error').text('Uh oh, something happened?');
              }
              // disable spinner animation on submit button
              $('.button-spinner', form).prop('disabled', false);
            },
            error: function (results) {
              // var results = JSON.parse(results);
              console.log(results);
              // disable spinner animation on submit button
              $('.button-spinner', form).prop('disabled', false);
            }
          });
        });
      });
    }
  });

  $('#aws-cognito-confirm-account').validate({
    // debug: true,
    errorElement: 'span',
    errorClass: 'form-field-error',
    validClass: 'form-field-valid',
    errorPlacement: function (error, element) {
      error.appendTo(element.parents('.form-field'));
    },
    highlight: function (element, errorClass, validClass) {
      $(element).parents('.form-field').addClass(errorClass).removeClass(validClass);
    },
    unhighlight: function (element, errorClass, validClass) {
      $(element).parents('.form-field').removeClass(errorClass).addClass(validClass);
    },
    'rules': {
      'confirmation-code': {
        required: true,
        number: true,
        minlength: 6,
        maxlength: 6
      }
    },
    'messages': {
      'confirmation-code': {
        required: 'Please enter your confirmation code',
        number: 'Your confirmation code is a six digit number.',
        minlength: 'Your confirmation code is too short.',
        maxlength: 'Your confirmation code is too long.'
      }
    },
    submitHandler: function (form) {
      // enable spinner animation on submit button
      $('.button-spinner', form).prop('disabled', true);

      grecaptcha.ready(function () {
        grecaptcha.execute(recaptcha_site_key, { action: 'aws_cognito_confirm_account' }).then(function (token) {
          // get all the variables
          var email_address = $('#confirm-email-address', form).val();
          var confirmation_code = $('#confirmation-code', form).val();
          // var nonce = $('#aws-cognito-confirm-account-nonce', form).val();

          // do something with them!
          $.ajax({
            type: 'post',
            url: '/wp-admin/admin-ajax.php',
            data: {
              action: 'aws_cognito_confirm_account',
              email_address: email_address,
              confirmation_code: confirmation_code,
              recaptcha_token: token
              // nonce: nonce
            },
            success: function (results) {
              var results = JSON.parse(results);
              // console.log(results);
              if (results.status === 'success') {
                $('.form-card-message', form).empty().removeClass('form-card-message-error').addClass('form-card-message-success').text(results.message);
                var redirect_url = $(form).attr('data-redirect-url');
                if (redirect_url) {
                  if (redirect_url === 'reload') {
                    setTimeout(function () {
                      location.reload();
                    }, 250);
                  } else {
                    setTimeout(function () {
                      window.location.href = redirect_url;
                    }, 250);
                  }
                }
              } else if (results.status === 'error') {
                $('.form-card-message', form).empty().removeClass('form-card-message-success').addClass('form-card-message-error').text(results.message);
              } else {
                $('.form-card-message', form).empty().removeClass('form-card-message-success').addClass('form-card-message-error').text('Uh oh, something happened?');
              }
              // disable spinner animation on submit button
              $('.button-spinner', form).prop('disabled', false);
            },
            error: function (results) {
              console.log(results);
              // disable spinner animation on submit button
              $('.button-spinner', form).prop('disabled', false);
            }
          });
        });
      });
    }
  });

  $('#go-to-resend-confirmation-code-form').on('click', function (e) {
    e.preventDefault();
    // pre-fill email address on next form
    var email_address = $('#confirm-email-address').val();
    $('#resend-email-address').val(email_address);
    // get the current form
    var this_form = $(this).parents('form');
    // hide this form and show the next form
    $(this_form).removeClass('form-flow-active');
    $(this_form).next().addClass('form-flow-active');
  });

  $('#aws-cognito-resend-confirmation-code').validate({
    // debug: true,
    errorElement: 'span',
    errorClass: 'form-field-error',
    validClass: 'form-field-valid',
    errorPlacement: function (error, element) {
      error.appendTo(element.parents('.form-field'));
    },
    highlight: function (element, errorClass, validClass) {
      $(element).parents('.form-field').addClass(errorClass).removeClass(validClass);
    },
    unhighlight: function (element, errorClass, validClass) {
      $(element).parents('.form-field').removeClass(errorClass).addClass(validClass);
    },
    'rules': {
      'resend-email-address': {
        required: true,
        email: true
      }
    },
    'messages': {
      'resend-email-address': {
        required: 'Please enter your email address.',
        email: 'Please enter a valid email address.'
      }
    },
    submitHandler: function (form) {
      // enable spinner animation on submit button
      $('.button-spinner', form).prop('disabled', true);

      grecaptcha.ready(function () {
        grecaptcha.execute(recaptcha_site_key, { action: 'aws_cognito_resend_confirmation_code' }).then(function (token) {

          // get all the variables
          var email_address = $('#resend-email-address').val();
          // var nonce = $('#aws-cognito-resend-confirmation-code-nonce', form).val();

          // do something with them!
          $.ajax({
            type: 'post',
            url: '/wp-admin/admin-ajax.php',
            data: {
              action: 'aws_cognito_resend_confirmation_code',
              email_address: email_address,
              recaptcha_token: token
              // nonce: nonce
            },
            success: function (results) {
              var results = JSON.parse(results);
              console.log(results);
              if (results.status === 'success') {

                $('.form-card-message', form).empty().removeClass('form-card-message-error').addClass('form-card-message-success').text(results.message);

              } else if (results.status === 'error') {

                $('.form-card-message', form).empty().removeClass('form-card-message-success').addClass('form-card-message-error').text(results.message);

              } else {

                $('.form-card-message', form).empty().removeClass('form-card-message-success').addClass('form-card-message-error').text('Uh oh, something happened?');

              }

              // go back to confirm account form
              setTimeout(function () {
                $(form).removeClass('form-flow-active');
                $(form).prev().addClass('form-flow-active');
              }, 3000);

              // disable spinner animation on submit button
              $('.button-spinner', form).prop('disabled', false);
            },
            error: function (results) {
              console.log(results);
              // disable spinner animation on submit button
              $('.button-spinner', form).prop('disabled', false);
            }
          });

        });
      });
    }
  });

  // show/hide ABM Single Sign-On button in Log In form
  if (feature_flags.FEATURE_ABM_SINGLE_SIGN_ON == true) {
    var testSSOEmails = [
      'jacob.greenwald@parkchirp.com',
      'caroline.sso@parkchirp.com',
      'nathan.sso@parkchirp.com',
      'abmssotest@parkchirp.com',
    ];

    var input = $('#login-email-address');
    if ($(input).length > 0) {
      var timeout = null;
      var match = false;
      var domains = ['abm.com'];
      $(input).on('input', function () {
        var value = $(this).val().toLowerCase();
        clearTimeout(timeout);
        timeout = setTimeout(function () {
          $(domains).each(function (index, domain) {
            domain = domain.toLowerCase();
            if (value.includes('@' + domain)) {
              match = true;
            }
          });
          if (match === true || testSSOEmails.includes(value)) {
            var abm_sso_url = $('meta[name="abm-sso-url"]').attr('content');
            console.log('abm_sso_url:', abm_sso_url);
            $('#login-abm-sso-button .button').attr('href', abm_sso_url);
            $('#login-password-and-submit-fields').hide();
            $('#login-abm-sso-button').show();
            $('.login-boxes-footer').hide();
          }
        }, 125);
        $('#login-abm-sso-button').hide();
        $('#login-password-and-submit-fields').show();
        $('#login-abm-sso-button .button').attr('href', '#');
        $('.login-boxes-footer').show();
        match = false;
      });
    }
  }

  $('#aws-cognito-log-in').validate({
    // debug: true,
    errorElement: 'span',
    errorClass: 'form-field-error',
    validClass: 'form-field-valid',
    errorPlacement: function (error, element) {
      error.appendTo(element.parents('.form-field'));
    },
    highlight: function (element, errorClass, validClass) {
      $(element).parents('.form-field').addClass(errorClass).removeClass(validClass);
    },
    unhighlight: function (element, errorClass, validClass) {
      $(element).parents('.form-field').removeClass(errorClass).addClass(validClass);
    },
    'rules': {
      'login-email-address': {
        required: true,
        email: true
      },
      'login-password': {
        required: true
      }
    },
    'messages': {
      'login-email-address': {
        required: 'Please enter your email address.',
        email: 'Please enter a valid email address.'
      },
      'login-password': {
        required: 'Please enter your password.'
      }
    },
    submitHandler: function (form) {
      // enable spinner animation on submit button
      $('.button-spinner', form).prop('disabled', true);

      grecaptcha.ready(function () {
        grecaptcha.execute(recaptcha_site_key, { action: 'aws_cognito_log_in' }).then(function (token) {
          // get all the variables
          var email_address = $('#login-email-address', form).val();
          var password = $('#login-password', form).val();
          // var nonce = $('#aws-cognito-log-in-nonce', form).val();

          // do something with them!
          $.ajax({
            type: 'post',
            url: '/wp-admin/admin-ajax.php',
            data: {
              action: 'aws_cognito_log_in',
              email_address: email_address,
              password: password,
              recaptcha_token: token
              // nonce: nonce
            },
            success: function (results) {
              var results = JSON.parse(results);
              // console.log(results);
              if (results.status === 'success') {
                if (results['results']['ChallengeName'] === 'MFA_SETUP') {
                  if (results['authenticator_app_setup']['SecretCode']) {
                    // this is for authenticator app setup
                    var qr_code = $('#mfa-authenticator-app-qr-code');
                    var site_name = $(qr_code).attr('data-site-name');
                    var secret_code = results['authenticator_app_setup']['SecretCode'];
                    var qr_code_url = 'otpauth://totp/' + site_name + '?secret=' + secret_code;
                    var code = new QRCode('mfa-authenticator-app-qr-code', {
                      text: qr_code_url,
                      width: 200,
                      height: 200,
                      colorDark: '#000000',
                      colorLight: '#FFFFFF',
                      correctLevel: QRCode.CorrectLevel.H
                    });
                    $(qr_code).attr('data-secret-code', secret_code);
                    $('#aws-cognito-mfa-setup #session').val(results['authenticator_app_setup']['Session']);
                    // hide this step and show next step
                    // $(form).hide();
                    // $('#aws-cognito-mfa-setup').show();
                  }
                } else if (results['results']['ChallengeName'] === 'SOFTWARE_TOKEN_MFA') {
                  // this is for entering a one-time password from your authenticator app

                  // let's go to MFA challenge
                  $('#aws-cognito-mfa-verify-otp #email-address').val(results['email_address']);
                  $('#aws-cognito-mfa-verify-otp #session').val(results['results']['Session']);
                  // hide this step and show next step
                  $(form).hide();
                  $('#aws-cognito-mfa-verify-otp').show();
                } else {
                  // regular log in with email and password with no MFA
                  var redirect_url = $(form).attr('data-redirect-url');
                  if (redirect_url) {
                    if (redirect_url === 'reload') {
                      setTimeout(function () {
                        location.reload();
                      }, 250);
                    } else {
                      setTimeout(function () {
                        window.location.href = redirect_url;
                      }, 250);
                    }
                  }
                }
                $('.form-card-message', form).empty().removeClass('form-card-message-error').addClass('form-card-message-success').text(results.message);
              } else if (results.status === 'error') {
                $('.form-card-message', form).empty().removeClass('form-card-message-success').addClass('form-card-message-error').text(results.message);
                if (results.error_code === 'PasswordResetRequiredException') {
                  // copy email address to forgot password form
                  $('#forgot-password-email-address').val(results.email_address);
                  // hide this step and show next step
                  setTimeout(function () {
                    $(form).removeClass('form-flow-active');
                    $(form).next().addClass('form-flow-active');
                  }, 250);
                }
              } else {
                $('.form-card-message', form).empty().removeClass('form-card-message-success').addClass('form-card-message-error').text('Uh oh, something happened?');
              }
              // disable spinner animation on submit button
              $('.button-spinner', form).prop('disabled', false);
            },
            error: function (results) {
              // var results = JSON.parse(results);
              console.log(results);
              // disable spinner animation on submit button
              $('.button-spinner', form).prop('disabled', false);
            }
          });
        });
      });
    }
  });

  // $('#aws-cognito-mfa-setup').validate({
  //   // debug: true,
  //   errorElement: 'span',
  //   errorClass: 'form-field-error',
  //   validClass: 'form-field-valid',
  //   errorPlacement: function(error, element) {
  //     error.appendTo(element.parents('.form-field'));
  //   },
  //   highlight: function(element, errorClass, validClass) {
  //     $(element).parents('.form-field').addClass(errorClass).removeClass(validClass);
  //   },
  //   unhighlight: function(element, errorClass, validClass) {
  //     $(element).parents('.form-field').removeClass(errorClass).addClass(validClass);
  //   },
  //   'rules': {
  //     'mfa-options': {
  //       required: true
  //     },
  //     'one-time-password': {
  //       required: {
  //         depends: function() {
  //           if ($('input[name="mfa-options"][value="authenticator-app"]').is(':checked')) {
  //             return true;
  //           } else {
  //             return false;
  //           }
  //         }
  //       },
  //       number: true,
  //       minlength: 6,
  //       maxlength: 6
  //     },
  //     'email-address': {
  //       required: {
  //         depends: function() {
  //           if ($('input[name="mfa-options"][value="email"]').is(':checked')) {
  //             return true;
  //           } else {
  //             return false;
  //           }
  //         }
  //       },
  //       email: true
  //     },
  //     'phone-number': {
  //       required: {
  //         depends: function() {
  //           if ($('input[name="mfa-options"][value="sms"]').is(':checked')) {
  //             return true;
  //           } else {
  //             return false;
  //           }
  //         }
  //       },
  //       phoneUS: true
  //     }
  //   },
  //   'messages': {
  //     'mfa-options': {
  //       required: 'Please choose a multi-factor authentication option.'
  //     },
  //     'one-time-password': {
  //       required: 'Please enter your one-time password from your authenticator app.',
  //       number: 'Your one-time password is a six digit number.',
  //       minlength: 'Your one-time password is too short.',
  //       maxlength: 'Your one-time password is too long.'
  //     },
  //     'email-address': {
  //       required: 'Please enter your email address.',
  //       email: 'Please enter a valid email address.'
  //     },
  //     'phone-number': {
  //       required: 'Please enter your mobile phone number.',
  //       phoneUS: 'Please enter a valid phone number.'
  //     }
  //   },
  //   submitHandler: function(form) {
  //     // enable spinner animation on submit button
  //     $('.button-spinner', form).prop('disabled', true);

  //     grecaptcha.ready(function() {
  //       grecaptcha.execute(recaptcha_site_key, { action: 'aws_cognito_mfa_setup' }).then(function(token) {
  //         // get all the variables
  //         var mfa_option = $('input[name="mfa-options"]', form).val();
  //         var one_time_password = null;
  //         var email_address = null;
  //         var phone_number = null;
  //         var session = $('#session', form).val();
  //         var nonce = $('#aws-cognito-mfa-setup-nonce', form).val();
  //         if (mfa_option === 'authenticator-app') {
  //           one_time_password = $('#one-time-password', form).val();
  //         } else if (mfa_option === 'email') {
  //           email_address = $('#email-address', form).val();
  //         } else if (mfa_option === 'sms') {
  //           phone_number = $('#phone-number', form).val();
  //         }

  //         // do something with them!
  //         $.ajax({
  //           type: 'post',
  //           url: '/wp-admin/admin-ajax.php',
  //           data: {
  //             action: 'aws_cognito_mfa_setup',
  //             mfa_option: mfa_option,
  //             one_time_password: one_time_password,
  //             email_address: email_address,
  //             phone_number: phone_number,
  //             session: session,
  //             recaptcha_token: token,
  //             nonce: nonce
  //           },
  //           success: function(results) {
  //             var results = JSON.parse(results);
  //             console.log(results);
  //             if (results.status === 'success') {
  //               if (results.mfa_option === 'authenticator-app' && results['results']['Status'] === 'SUCCESS') {
  //                 // hide this step and show next step
  //                 $(form).hide();
  //                 $('#aws-cognito-mfa-verify-otp').show();
  //               } else if (results.mfa_option === 'email') {

  //               } else if (results.mfa_option === 'sms') {

  //               }
  //               $('.form-card-message', form).empty().removeClass('form-card-message-error').addClass('form-card-message-success').text(results.message);
  //             } else if (results.status === 'error') {
  //               $('.form-card-message', form).empty().removeClass('form-card-message-success').addClass('form-card-message-error').text(results.message);
  //             } else {
  //               $('.form-card-message', form).empty().removeClass('form-card-message-success').addClass('form-card-message-error').text('Uh oh, something happened?');
  //             }
  //             // disable spinner animation on submit button
  //             $('.button-spinner', form).prop('disabled', false);
  //           },
  //           error: function(results) {
  //             console.log(results);
  //             $('.form-card-message', form).empty().removeClass('form-card-message-success').addClass('form-card-message-error').text('Uh oh, something happened?');
  //             // disable spinner animation on submit button
  //             $('.button-spinner', form).prop('disabled', false);
  //           }
  //         });
  //       });
  //     });
  //   }
  // });

  // $('#aws-cognito-mfa-verify-otp').validate({
  //   // debug: true,
  //   errorElement: 'span',
  //   errorClass: 'form-field-error',
  //   validClass: 'form-field-valid',
  //   errorPlacement: function(error, element) {
  //     error.appendTo(element.parents('.form-field'));
  //   },
  //   highlight: function(element, errorClass, validClass) {
  //     $(element).parents('.form-field').addClass(errorClass).removeClass(validClass);
  //   },
  //   unhighlight: function(element, errorClass, validClass) {
  //     $(element).parents('.form-field').removeClass(errorClass).addClass(validClass);
  //   },
  //   'rules': {
  //     'one-time-password': {
  //       required: true,
  //       number: true,
  //       minlength: 6,
  //       maxlength: 6
  //     }
  //   },
  //   'messages': {
  //     'one-time-password': {
  //       required: 'Please enter your one-time password from your authenticator app.',
  //       number: 'Your one-time password is a six digit number.',
  //       minlength: 'Your one-time password is too short.',
  //       maxlength: 'Your one-time password is too long.'
  //     }
  //   },
  //   submitHandler: function(form) {
  //     // enable spinner animation on submit button
  //     $('.button-spinner', form).prop('disabled', true);

  //     grecaptcha.ready(function() {
  //       grecaptcha.execute(recaptcha_site_key, { action: 'aws_cognito_mfa_verify_otp' }).then(function(token) {
  //         // get all the variables
  //         var challenge_name = $('#challenge-name', form).val();
  //         var email_address = $('#email-address', form).val();
  //         var one_time_password = $('#one-time-password', form).val();
  //         var session = $('#session', form).val();
  //         var nonce = $('#aws-cognito-mfa-verify-otp-nonce', form).val();

  //         // do something with them!
  //         $.ajax({
  //           type: 'post',
  //           url: '/wp-admin/admin-ajax.php',
  //           data: {
  //             action: 'aws_cognito_mfa_verify_otp',
  //             challenge_name: challenge_name,
  //             email_address: email_address,
  //             one_time_password: one_time_password,
  //             session: session,
  //             recaptcha_token: token,
  //             nonce: nonce
  //           },
  //           success: function(results) {
  //             var results = JSON.parse(results);
  //             console.log(results);
  //             // disable spinner animation on submit button
  //             $('.button-spinner', form).prop('disabled', false);
  //           },
  //           error: function(results) {
  //             console.log(results);
  //             // disable spinner animation on submit button
  //             $('.button-spinner', form).prop('disabled', false);
  //           }
  //         });
  //       });
  //     });
  //   }
  // });

  // // show/hide necessary fields for each mfa option
  // $('input[type="radio"][name="mfa-options"]').on('change', function() {
  //   var value = $(this).val();
  //   $('.mfa-option-fields').hide();
  //   $('.mfa-option-fields-' + value).show();
  // });

  // log out of AWS Cognito account
  $('body').on('click', '#aws-cognito-log-out', function (e) {
    e.preventDefault();
    $(this).prop('disabled', true);
    var redirect_url = $(this).attr('data-redirect-url');
    $.ajax({
      type: 'post',
      url: '/wp-admin/admin-ajax.php',
      data: {
        action: 'aws_cognito_log_out'
      },
      success: function (results) {
        var results = JSON.parse(results);
        // console.log(results);
        if (results.status === 'success') {
          if (redirect_url) {
            if (redirect_url === 'reload') {
              setTimeout(function () {
                location.reload();
              }, 250);
            } else {
              setTimeout(function () {
                window.location.href = redirect_url;
              }, 250);
            }
          }
        }
        $(this).prop('disabled', false);
      },
      error: function (results) {
        console.log(results);
        $(this).prop('disabled', false);
      }
    });
  });

  // AWS Cognito :: Forgot Password
  $('#aws-cognito-forgot-password').validate({
    // debug: true,
    errorElement: 'span',
    errorClass: 'form-field-error',
    validClass: 'form-field-valid',
    errorPlacement: function (error, element) {
      error.appendTo(element.parents('.form-field'));
    },
    highlight: function (element, errorClass, validClass) {
      $(element).parents('.form-field').addClass(errorClass).removeClass(validClass);
    },
    unhighlight: function (element, errorClass, validClass) {
      $(element).parents('.form-field').removeClass(errorClass).addClass(validClass);
    },
    'rules': {
      'forgot-password-email-address': {
        required: true,
        email: true
      }
    },
    'messages': {
      'forgot-password-email-address': {
        required: 'Please enter your email address.',
        email: 'Please enter a valid email address.'
      }
    },
    submitHandler: function (form) {
      // enable spinner animation on submit button
      $('.button-spinner', form).prop('disabled', true);

      // get variables
      var email_address = $('#forgot-password-email-address', form).val();
      // var nonce = $('#aws-cognito-forgot-password-nonce').val();

      // do stuff
      $.ajax({
        type: 'post',
        url: '/wp-admin/admin-ajax.php',
        data: {
          action: 'aws_cognito_forgot_password',
          email_address: email_address
          // nonce: nonce
        },
        success: function (results) {
          var results = JSON.parse(results);
          // console.log(results);
          if (results.status === 'success') {
            $('.form-card-message', form).empty().removeClass('form-card-message-error').addClass('form-card-message-success').text(results.message);
            // hide this step and show next step
            setTimeout(function () {
              $(form).removeClass('form-flow-active');
              $(form).next().addClass('form-flow-active');
              $('.page-header-text-step-1').hide();
              $('.page-header-text-step-2').show();
            }, 250);
          } else if (results.status === 'error') {
            $('.form-card-message', form).empty().removeClass('form-card-message-success').addClass('form-card-message-error').text(results.message);
          }
          // disable spinner animation on submit button
          $('.button-spinner', form).prop('disabled', false);
        },
        error: function (results) {
          console.log(results);
          $('.form-card-message', form).empty().removeClass('form-card-message-success').addClass('form-card-message-error').text('Uh oh, something happened?');
          // disable spinner animation on submit button
          $('.button-spinner', form).prop('disabled', false);
        }
      });
    }
  });

  // AWS Cognito :: Confirm Forgot Password
  $('#aws-cognito-confirm-forgot-password').validate({
    // debug: true,
    errorElement: 'span',
    errorClass: 'form-field-error',
    validClass: 'form-field-valid',
    errorPlacement: function (error, element) {
      error.appendTo(element.parents('.form-field'));
    },
    highlight: function (element, errorClass, validClass) {
      $(element).parents('.form-field').addClass(errorClass).removeClass(validClass);
    },
    unhighlight: function (element, errorClass, validClass) {
      $(element).parents('.form-field').removeClass(errorClass).addClass(validClass);
    },
    'rules': {
      'confirm-forgot-password-password': {
        required: true,
        minlength: 12,
        maxlength: 99
      },
      'confirm-forgot-password-password-match': {
        required: true,
        minlength: 12,
        maxlength: 99,
        equalTo: '#confirm-forgot-password-password'
      },
      'confirm-forgot-password-password-reset-code': {
        required: true,
        number: true,
        minlength: 6,
        maxlength: 6
      }
    },
    'messages': {
      'confirm-forgot-password-password': {
        required: 'Please provide a password.',
        minlength: 'Your password must be at least 12 characters long.',
        maxlength: 'Your password must be 99 characters or less.'
      },
      'confirm-forgot-password-password-match': {
        required: 'Your password does not match the previous field.',
        minlength: 'Your password must be at least 12 characters long.',
        maxlength: 'Your password must be 99 characters or less.',
        equalTo: 'Your password does not match the previous field.'
      },
      'confirm-forgot-password-password-reset-code': {
        required: 'Please enter the password reset code you were emailed.',
        number: 'Your password reset code is a six digit number.',
        minlength: 'Your password reset code is too short.',
        maxlength: 'Your password reset code is too long.'
      }
    },
    submitHandler: function (form) {
      // enable spinner animation on submit button
      $('.button-spinner', form).prop('disabled', true);

      // get variables
      var password = $('#confirm-forgot-password-password', form).val();
      var password_reset_code = $('#confirm-forgot-password-password-reset-code', form).val();
      // var nonce = $('#aws-cognito-confirm-forgot-password-nonce', form).val();

      // do stuff
      $.ajax({
        type: 'post',
        url: '/wp-admin/admin-ajax.php',
        data: {
          action: 'aws_cognito_confirm_forgot_password',
          password: password,
          password_reset_code: password_reset_code
          // nonce: nonce
        },
        success: function (results) {
          var results = JSON.parse(results);
          // console.log(results);
          if (results.status === 'success') {
            $('.form-card-message', form).empty().removeClass('form-card-message-error').addClass('form-card-message-success').text(results.message);
            var redirect_url = $(form).attr('data-redirect-url');
            if (redirect_url) {
              if (redirect_url === 'reload') {
                setTimeout(function () {
                  location.reload();
                }, 250);
              } else if (redirect_url === 'onboarding') {
                // hide this step and show next step
                setTimeout(function () {
                  $(form).removeClass('form-flow-active');
                  $(form).next().addClass('form-flow-active');
                }, 250);
              } else {
                setTimeout(function () {
                  window.location.href = redirect_url;
                }, 250);
              }
            }
          } else if (results.status === 'error') {
            $('.form-card-message', form).empty().removeClass('form-card-message-success').addClass('form-card-message-error').text(results.message);
          }
          // disable spinner animation on submit button
          $('.button-spinner', form).prop('disabled', false);
        },
        error: function (results) {
          console.log(results);
          $('.form-card-message', form).empty().removeClass('form-card-message-success').addClass('form-card-message-error').text('Uh oh, something happened?');
          // disable spinner animation on submit button
          $('.button-spinner', form).prop('disabled', false);
        }
      });

    }
  });

  // AWS Cognito :: Update Profile
  $('#aws-cognito-update-profile').validate({
    // debug: true,
    errorElement: 'span',
    errorClass: 'form-field-error',
    validClass: 'form-field-valid',
    errorPlacement: function (error, element) {
      error.appendTo(element.parents('.form-field'));
      error.attr('data-cy', `${error[0].id}-text`);
    },
    highlight: function (element, errorClass, validClass) {
      $(element).parents('.form-field').addClass(errorClass).removeClass(validClass);
    },
    unhighlight: function (element, errorClass, validClass) {
      $(element).parents('.form-field').removeClass(errorClass).addClass(validClass);
    },
    'rules': {
      'first-name': {
        required: true,
        minlength: 2
      },
      'last-name': {
        required: true,
        minlength: 2
      },
      'country-code': {
        required: true,
        minlength: 1,
        maxlength: 3
      },
      'phone-number': {
        required: true,
        minlength: 10,
        maxlength: 15,
      },
      'street-address': {
        minlength: 2
      },
      'city': {
        minlength: 2
      },
      'zip-code': {
        zipcodeUS: true
      }
    },
    'messages': {
      'first-name': {
        required: 'Please enter your first name.',
        minlength: 'Your first name must be at least 2 characters long.'
      },
      'last-name': {
        required: 'Please enter your last name.',
        minlength: 'Your last name must be at least 2 characters long.'
      },
      'country-code': {
        required: 'Please enter your country code.',
        minlength: 'Your country code must be at least 1 character long.',
        maxlength: 'Your country code must be 3 characters or less.'
      },
      'phone-number': {
        required: 'Please enter your phone number.',
        minlength: 'Your phone number must be at least 10 characters long.',
        maxlength: 'Your phone number must be 15 characters or less.'
      },
      'street-address': {
        minlength: 'Please enter a valid street address.'
      },
      'city': {
        minlength: 'Please enter a valid city name.'
      },
      'zip-code': {
        zipcodeUS: 'Please enter a valid zip code.'
      }
    },
    submitHandler: function (form) {
      // enable spinner animation on submit button
      $('.button-spinner', form).prop('disabled', true);

      // get all license plates and store them in an array
      var license_plates = [];
      $('input[name="license-plates"]').each(function (index, license_plate) {
        if ($(license_plate).val()) {
          license_plates.push($(license_plate).val());
        }
      });

      // wrap everything up into an object
      var metadata = {};
      metadata['firstName'] = $('#first-name').val();
      metadata['lastName'] = $('#last-name').val();
      metadata['countryCode'] = $('#country-code').val();
      metadata['phoneNumber'] = $('#phone-number').val();
      metadata['street'] = $('#street-address').val();
      metadata['city'] = $('#city').val();
      metadata['state'] = $('#state').val();
      metadata['zip'] = $('#zip-code').val();
      metadata['licensePlates'] = license_plates;

      // convert object to JSON
      console.log(metadata);
      metadata = JSON.stringify(metadata);
      console.log(metadata);

      // get AWS Cognito ID Token from cookie
      var id_token = getCookie('aws_cognito_id_token');
      if (id_token.length) {
        // send it away!
        $.ajax({
          type: 'post',
          url: aws_api_endpoint_url + 'update-user-metadata',
          headers: {
            'Authorization': id_token
          },
          data: metadata,
          contentType: 'application/json',
          success: function (results) {
            console.log('Profile updated!', results);
            $.ajax({
              type: 'post',
              url: '/wp-admin/admin-ajax.php',
              data: {
                action: 'aws_cognito_refresh_token'
              },
              success: function (results) {
                var results = JSON.parse(results);
                if (results.status === 'success') {
                  console.log('Tokens refreshed!', results);
                  $('.form-card-message', form).empty().removeClass('form-card-message-error').addClass('form-card-message-success').text('Profile updated!');
                  setTimeout(function () {
                    location.reload(true);
                  }, 250);
                } else if (results.status === 'error') {
                  console.log('Tokens not refreshed?!', results);
                  // disable spinner animation on submit button
                  $('.button-spinner', form).prop('disabled', false);
                }
              },
              error: function (results) {
                console.log('Token refresh failed?', results);
                // disable spinner animation on submit button
                $('.button-spinner', form).prop('disabled', false);
              }
            });
          },
          error: function (results) {
            console.log(results);
            $('.form-card-message', form).empty().removeClass('form-card-message-success').addClass('form-card-message-error').text('Something went wrong. Try again?');
            // disable spinner animation on submit button
            $('.button-spinner', form).prop('disabled', false);
          }
        });
      }
    }
  });

  // AWS Cognito :: Change Password
  $('#aws-cognito-change-password').validate({
    // debug: true,
    errorElement: 'span',
    errorClass: 'form-field-error',
    validClass: 'form-field-valid',
    errorPlacement: function (error, element) {
      error.appendTo(element.parents('.form-field'));
      error.attr('data-cy', `${error[0].id}-text`);
    },
    highlight: function (element, errorClass, validClass) {
      $(element).parents('.form-field').addClass(errorClass).removeClass(validClass);
    },
    unhighlight: function (element, errorClass, validClass) {
      $(element).parents('.form-field').removeClass(errorClass).addClass(validClass);
    },
    'rules': {
      'current-password': {
        required: true,
      },
      'new-password': {
        required: true,
        minlength: 12,
        maxlength: 99
      },
      'new-password-match': {
        required: true,
        minlength: 12,
        maxlength: 99,
        equalTo: '#new-password'
      }
    },
    'messages': {
      'current-password': {
        required: 'Please enter your current password.'
      },
      'new-password': {
        required: 'Please provide a password.',
        minlength: 'Your password must be at least 12 characters long.',
        maxlength: 'Your password must be 64 characters or less.'
      },
      'new-password-match': {
        required: 'Your password does not match the previous field.',
        minlength: 'Your password must be at least 12 characters long.',
        maxlength: 'Your password must be 64 characters or less.',
        equalTo: 'Your password does not match the previous field.'
      }
    },
    submitHandler: function (form) {
      // enable spinner animation on submit button
      $('.button-spinner', form).prop('disabled', true);

      var current_password = $('#current-password', form).val();
      var new_password = $('#new-password', form).val();
      var new_password_match = $('#new-password-match', form).val();
      // var nonce = $('#aws-cognito-change-password-nonce', form).val();

      $.ajax({
        type: 'post',
        url: '/wp-admin/admin-ajax.php',
        data: {
          action: 'aws_cognito_change_password',
          current_password: current_password,
          new_password: new_password
          // nonce: nonce
        },
        success: function (results) {
          var results = JSON.parse(results);
          // console.log(results);
          var message = results.message;
          if (results.status === 'success') {
            $.ajax({
              type: 'post',
              url: '/wp-admin/admin-ajax.php',
              data: {
                action: 'aws_cognito_refresh_token'
              },
              success: function (results) {
                var results = JSON.parse(results);
                if (results.status === 'success') {
                  console.log('Tokens refreshed!', results);
                  $('.form-card-message', form).empty().removeClass('form-card-message-error').addClass('form-card-message-success').text(message);
                  setTimeout(function () {
                    location.reload(true);
                  }, 250);
                } else if (results.status === 'error') {
                  console.log('Tokens not refreshed?!', results);
                  $('.form-card-message', form).empty().removeClass('form-card-message-success').addClass('form-card-message-success').text(message);
                  // disable spinner animation on submit button
                  $('.button-spinner', form).prop('disabled', false);
                }
              },
              error: function (results) {
                console.log('Token refresh failed?', results);
                $('.form-card-message', form).empty().removeClass('form-card-message-success').addClass('form-card-message-success').text('Token refresh failed?');
                // disable spinner animation on submit button
                $('.button-spinner', form).prop('disabled', false);
              }
            });
          } else if (results.status === 'error') {
            $('.form-card-message', form).empty().removeClass('form-card-message-success').addClass('form-card-message-error').text(message);
            // disable spinner animation on submit button
            $('.button-spinner', form).prop('disabled', false);
          }
        },
        error: function (results) {
          console.log(results);
          $('.form-card-message', form).empty().removeClass('form-card-message-success').addClass('form-card-message-error').text('Uh oh, something happened?');
          // disable spinner animation on submit button
          $('.button-spinner', form).prop('disabled', false);
        }
      });
    }
  });
  
  // inc-chirp2-single-facility-form functionality
  $('.chirp2-sf-form').each(function(index, form) {

    // hourly/monthly/coupon tabs functionality
    $('.chirp2-sf-form-menu-item', form).on('click', function() {
      var tab_name = $(this).attr('data-tab');
      $('.chirp2-sf-form-menu-item', form).removeClass('chirp2-sf-form-menu-item-active');
      $('.chirp2-sf-form-tab', form).removeClass('chirp2-sf-form-tab-active');
      $('.chirp2-sf-form-menu-item[data-tab="' + tab_name + '"]', form).addClass('chirp2-sf-form-menu-item-active');
      $('.chirp2-sf-form-tab[data-tab="' + tab_name + '"]', form).addClass('chirp2-sf-form-tab-active');
    });
    
    // get initial hourly parking price if the hourly tab is active
    if ($('.chirp2-sf-form-tab[data-tab="hourly-parking"]', form).hasClass('chirp2-sf-form-tab-active')) {
      // get variables
      var facility_id = $('#facility-id').val();
      var start_date = $('#hourly-start-date', form).val();
      var start_time = $('#hourly-start-time', form).val();
      var end_date = $('#hourly-end-date', form).val();
      var end_time = $('#hourly-end-time', form).val();
      var promo_code = $('#hourly-promo-code', form).val();
      var offset = $('#offset', form).val();
      // get a new price
      chirp2_sf_form_update_hourly_price(facility_id, start_date, start_time, end_date, end_time, offset, promo_code);
    }
    
    // update hourly parking price on date/time change
    $('#hourly-start-date, #hourly-start-time, #hourly-end-date, #hourly-end-time', form).on('change', function() {
      // get variables
      var facility_id = $('#facility-id').val();
      var start_date = $('#hourly-start-date', form).val();
      var start_time = $('#hourly-start-time', form).val();
      var end_date = $('#hourly-end-date', form).val();
      var end_time = $('#hourly-end-time', form).val();
      var promo_code = $('#hourly-promo-code', form).val();
      var offset = $('#offset', form).val();
      // if start_date is later than end_date, change them to match
      if (start_date > end_date) {
        $('#hourly-end-date', form).val(start_date);
        end_date = start_date;
      }
      // get a new price
      chirp2_sf_form_update_hourly_price(facility_id, start_date, start_time, end_date, end_time, offset, promo_code);
    });
    
    // update hourly parking price on promo code typing
    $('#hourly-promo-code', form).on('keyup', debounce(function() {
      // get variables
      var facility_id = $('#facility-id').val();
      var start_date = $('#hourly-start-date', form).val();
      var start_time = $('#hourly-start-time', form).val();
      var end_date = $('#hourly-end-date', form).val();
      var end_time = $('#hourly-end-time', form).val();
      var promo_code = $('#hourly-promo-code', form).val();
      var offset = $('#offset', form).val();
      // get a new price
      chirp2_sf_form_update_hourly_price(facility_id, start_date, start_time, end_date, end_time, offset, promo_code);
    }, 500));
    
    // update hourly parking price on promo code submit
    $('#hourly-promo-code-submit', form).on('click', function(e) {
      e.preventDefault();
      // get variables
      var facility_id = $('#facility-id').val();
      var start_date = $('#hourly-start-date', form).val();
      var start_time = $('#hourly-start-time', form).val();
      var end_date = $('#hourly-end-date', form).val();
      var end_time = $('#hourly-end-time', form).val();
      var promo_code = $('#hourly-promo-code', form).val();
      var offset = $('#offset', form).val();
      // get a new price
      chirp2_sf_form_update_hourly_price(facility_id, start_date, start_time, end_date, end_time, offset, promo_code);
    });
    
    // calculate monthly product changes
    $('input[name="monthly-options"], #monthly-quantity', form).on('change', function() {
      var price = $('input[name="monthly-options"]:checked').attr('data-price');
      var quantity = $('#monthly-quantity').val();
      chirp2_sf_form_update_product_price('monthly', price, quantity);
      var current_url = $('#monthly-parking-submit').attr('href');
      var product_id = $('input[name="monthly-options"]:checked').val();
      var start_date = $('#monthly-start-date').val();
      var offset = $('#offset').val();
      var promo_code = $('#monthly-promo-code').val();
      chirp2_sf_form_update_monthly_checkout_url(current_url, product_id, start_date, offset, quantity, promo_code);
    });
    
    // update monthly parking products on promo code typing
    $('#monthly-promo-code', form).on('keyup', debounce(function() {
      var facility_id = $('#facility-id').val();
      var promo_code = $('#monthly-promo-code', form).val();
      chirp2_sf_form_update_products('monthly', facility_id, promo_code);
    }, 500));
    
    // update monthly parking products on promo code submit
    $('#monthly-promo-code-submit', form).on('click', function(e) {
      e.preventDefault();
      var facility_id = $('#facility-id').val();
      var promo_code = $('#monthly-promo-code', form).val();
      chirp2_sf_form_update_products('monthly', facility_id, promo_code);
    });
    
    // calculate coupon product changes
    $('input[name="coupon-options"], #coupon-quantity', form).on('change', function() {
      var price = $('input[name="coupon-options"]:checked').attr('data-price');
      var quantity = $('#coupon-quantity').val();
      chirp2_sf_form_update_product_price('coupon', price, quantity);
      var current_url = $('#coupon-parking-submit').attr('href');
      var product_id = $('input[name="coupon-options"]:checked').val();
      var promo_code = $('#coupon-promo-code').val();
      chirp2_sf_form_update_coupon_checkout_url(current_url, product_id, quantity, promo_code);
    });
    
    // update coupon parking products on promo code typing
    $('#coupon-promo-code', form).on('keyup', debounce(function() {
      var facility_id = $('#facility-id').val();
      var promo_code = $('#coupon-promo-code', form).val();
      chirp2_sf_form_update_products('coupon', facility_id, promo_code);
    }, 500));
    
    // update coupon parking products on promo code submit
    $('#coupon-promo-code-submit', form).on('click', function(e) {
      e.preventDefault();
      var facility_id = $('#facility-id').val();
      var promo_code = $('#coupon-promo-code', form).val();
      chirp2_sf_form_update_products('coupon', facility_id, promo_code);
    });
    
  });
});
